{
  "_languages": {
    "ja": "日本語 (Japanese)",
    "en": "English (English)",
    "cn": "中文 (Chinese)",
    "fr": "Français (French)",
    "de": "Deutsch (German)"
  },
  "general": {
    "scheduled_by_em": "This action is disabled because an update schedule was set by the Enterprise Manager.",
    "keep_existing": "Keep existing",
    "copy_to_clipboard": "Copy to clipboard",
    "copied": "Copied",
    "none": "None",
    "invalid_file": {
      "max_size": "The uploaded SCD file exceeds the size limit of 50 MB. Please ensure your file is within the allowed size and try again",
      "general_error": "You must upload the an SCD file; any other type will not be accepted"
    },
    "buttons": {
      "stop": "Stop",
      "run_now": "Run now",
      "download_last_query_run_log": "Download Last Run Log",
      "add": "Add",
      "create": "Create",
      "save": "Save",
      "send": "Send",
      "duplicate": "Duplicate",
      "cancel": "Cancel",
      "next": "Next",
      "back": "Back",
      "view": "View",
      "edit": "Edit",
      "configure": "Configure",
      "delete": "Delete",
      "export": "Export",
      "export_csv": "Export CSV",
      "update": "Update",
      "apply": "Apply",
      "close": "Close",
      "download": "Download",
      "restart": "Restart",
      "restart_service_now": "Restart Service Now",
      "enable": "Enable",
      "disable": "Disable",
      "deselect_all": "Deselect all",
      "exclude": "Exclude",
      "copy": "Copy",
      "done": "Done",
      "remove": "Remove",
      "reset": "Reset",
      "upload": "Upload",
      "pause": "Pause",
      "resume": "Resume",
      "approve": "Approve",
      "kill": "Kill",
      "read_more": "Show More",
      "read_less": "Show Less",
      "test": "Test",
      "proceed": "Proceed",
      "dismiss": "Dismiss"
    },
    "time_frames": {
      "fifteen_minutes": "Last 15 minutes",
      "one_hour": "Last 1 hour",
      "four_hours": "Last 4 hours",
      "twelve_hours": "Last 12 hours",
      "one_day": "Last 1 day",
      "one_week": "Last 7 days",
      "one_month": "Last 30 days",
      "max_tooltip": "The data set for this duration is too large to be displayed",
      "custom": "Custom"
    },
    "duration": {
      "seconds": "Seconds",
      "minutes": "Minutes",
      "hours": "Hours",
      "days": "Days",
      "weeks": "Weeks",
      "months": "Months",
      "time_seconds": "{{count}} second",
      "time_seconds_other": "{{count}} seconds",
      "time_minutes": "{{count}} minute",
      "time_minutes_other": "{{count}} minutes",
      "time_hours": "{{count}} hour",
      "time_hours_other": "{{count}} hours",
      "time_days": "{{count}} day",
      "time_days_other": "{{count}} days",
      "time_weeks": "{{count}} week",
      "time_weeks_other": "{{count}} weeks",
      "time_months": "{{count}} month",
      "time_months_other": "{{count}} months"
    },
    "frequency_editor": {
      "daily": "Days",
      "weekly": "Weeks",
      "hourly": "Hours",
      "minutes": "Minutes",
      "repeats_label": "Repeats every",
      "on_days_label": "On",
      "at_hour_label": "At",
      "next_run": "Next run at",
      "humanized": {
        "minute": {
          "short": "{{count}} minute",
          "short_other": "{{count}} minutes",
          "long": "Every minute",
          "long_other": "Every {{count}} minutes"
        },
        "hour": {
          "short": "{{count}} hour",
          "short_other": "{{count}} hours",
          "long": "Every hour",
          "long_other": "Every {{count}} hours"
        },
        "day": {
          "short": "{{count}} day at {{hour}}",
          "short_other": "{{count}} days at {{hour}}",
          "long": "Every day at {{hour}}",
          "long_other": "Every {{count}} days at {{hour}}"
        },
        "week": {
          "short": "{{count}} week on {{days, list}} at {{hour}}",
          "short_other": "{{count}} weeks on {{days, list}} at {{hour}}",
          "long": "Every week on {{days, list}} at {{hour}}",
          "long_other": "Every {{count}} weeks on {{days, list}} at {{hour}}"
        }
      }
    },
    "frequency": {
      "and": "and",
      "day": "${day} at ${time}",
      "week": "${week} on ${days} at ${time}",
      "daily": "Daily",
      "weekly": "Weekly",
      "hourly": "Hourly",
      "minutes": "Minutes",
      "one_second": "1 second",
      "two_seconds": "2 seconds",
      "three_seconds": "3 seconds",
      "five_minutes": "5 minutes",
      "ten_minutes": "10 minutes",
      "fifteen_minutes": "15 minutes",
      "thirty_minutes": "30 minutes",
      "forty_five_minutes": "45 minutes",
      "one_hour": "1 hour",
      "two_hour": "2 hours",
      "three_hour": "3 hours",
      "four_hour": "4 hours",
      "five_hour": "5 hours",
      "six_hour": "6 hours",
      "seven_hour": "7 hours",
      "eight_hour": "8 hours",
      "nine_hour": "9 hours",
      "ten_hour": "10 hours",
      "eleven_hour": "11 hours",
      "twelve_hour": "12 hours",
      "one_week": "1 week",
      "two_week": "2 weeks",
      "three_week": "3 weeks",
      "four_week": "4 weeks",
      "five_week": "5 weeks",
      "six_week": "6 weeks",
      "one_month": "1 month",
      "three_month": "3 months",
      "one_day": "1 day",
      "two_day": "2 days",
      "three_day": "3 days",
      "four_day": "4 days",
      "five_day": "5 days",
      "six_day": "6 days",
      "seven_day": "7 days",
      "eight_day": "8 days",
      "nine_day": "9 days",
      "ten_day": "10 days",
      "eleven_day": "11 days",
      "twelve_day": "12 days",
      "thirteen_day": "13 days",
      "fourteen_day": "14 days",
      "fifteen_day": "15 days",
      "sixteen_day": "16 days",
      "seventeen_day": "17 days",
      "eighteen_day": "18 days",
      "nineteen_day": "19 days",
      "twenty_day": "20 days",
      "twenty_one_day": "21 days",
      "twenty_two_day": "22 days",
      "twenty_three_day": "23 days",
      "twenty_four_day": "24 days",
      "twenty_five_day": "25 days",
      "twenty_six_day": "26 days",
      "twenty_seven_day": "27 days",
      "twenty_eight_day": "28 days",
      "twenty_nine_day": "29 days",
      "thirty_day": "30 days",
      "thirty_one_day": "31 days",
      "twelve_AM": "12:00 AM",
      "twelve_half_AM": "12:30 AM",
      "one_AM": "1:00 AM",
      "one_half_AM": "1:30 AM",
      "two_AM": "2:00 AM",
      "two_half_AM": "2:30 AM",
      "three_AM": "3:00 AM",
      "three_half_AM": "3:30 AM",
      "four_AM": "4:00 AM",
      "four_half_AM": "4:30 AM",
      "five_AM": "5:00 AM",
      "five_half_AM": "5:30 AM",
      "six_AM": "6:00 AM",
      "six_half_AM": "6:30 AM",
      "seven_AM": "7:00 AM",
      "seven_half_AM": "7:30 AM",
      "eight_AM": "8:00 AM",
      "eight_half_AM": "8:30 AM",
      "nine_AM": "9:00 AM",
      "nine_half_AM": "9:30 AM",
      "ten_AM": "10:00 AM",
      "ten_half_AM": "10:30 AM",
      "eleven_AM": "11:00 AM",
      "eleven_half_AM": "11:30 AM",
      "twelve_PM": "12:00 PM",
      "twelve_half_PM": "12:30 PM",
      "one_PM": "1:00 PM",
      "one_half_PM": "1:30 PM",
      "two_PM": "2:00 PM",
      "two_half_PM": "2:30 PM",
      "three_PM": "3:00 PM",
      "three_half_PM": "3:30 PM",
      "four_PM": "4:00 PM",
      "four_half_PM": "4:30 PM",
      "five_PM": "5:00 PM",
      "five_half_PM": "5:30 PM",
      "six_PM": "6:00 PM",
      "six_half_PM": "6:30 PM",
      "seven_PM": "7:00 PM",
      "seven_half_PM": "7:30 PM",
      "eight_PM": "8:00 PM",
      "eight_half_PM": "8:30 PM",
      "nine_PM": "9:00 PM",
      "nine_half_PM": "9:30 PM",
      "ten_PM": "10:00 PM",
      "ten_half_PM": "10:30 PM",
      "eleven_PM": "11:00 PM",
      "eleven_half_PM": "11:30 PM"
    },
    "schedule": {
      "every_day": "Every day",
      "monday_to_friday": "Monday to Friday",
      "mondays": "Mondays",
      "tuesdays": "Tuesdays",
      "wednesdays": "Wednesdays",
      "thursdays": "Thursdays",
      "fridays": "Fridays",
      "saturdays": "Saturdays",
      "sundays": "Sundays"
    },
    "datetime": {
      "relativeTime": {
        "ss": "%d seconds",
        "s": "1 second",
        "m": "1 minute",
        "mm": "%d minutes",
        "h": "1 hour",
        "hh": "%d hours",
        "d": "1 day",
        "dd": "%d days",
        "M": "1 month",
        "MM": "%d months",
        "y": "1 year",
        "yy": "%d years",
        "future": "in %s",
        "past": "%s ago"
      },
      "formats": {
        "LT": "hh:mm A",
        "LTS": "MMM D, YYYY hh:mm:ss A",
        "L": "dddd, MMM D, YYYY, hh:mm:ss A",
        "LL": "hh:mm:ss A · MMM D, YYYY",
        "LLL": "hh:mm:ss A",
        "LLLL": "MMM D, YYYY_h.mm A",
        "l": "dddd, MMM D, YYYY",
        "ll": "MMM D, YYYY"
      },
      "weekdays": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "weekdaysShort": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "monthsShort": [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "months": [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    },
    "flyout_title": {
      "actions": "Actions",
      "bulk": "Bulk Actions"
    },
    "form": {
      "name_hint": "Keep empty for system default",
      "names": {
        "custom_range": "Custom Range",
        "browse": "Browse"
      },
      "fields": {
        "name": "Name",
        "location": "Location",
        "type": "Type",
        "backplane": "Backplane",
        "criticality": "Criticality",
        "description": "Description",
        "start_date": "Start Date",
        "end_date": "End Date",
        "start_time": "Start Time",
        "end_time": "End Time",
        "drop_file_placeholder": "Drop file here"
      }
    },
    "loading": "Loading…",
    "export_filename_template": "tot_{{machineName}}_{{fileName}}_{{timestamp}}.{{ext}}",
    "grid": {
      "settings": {
        "title": "Table Settings",
        "no_grouping": "No grouping",
        "expand_all": "Expand All",
        "collapse_all": "Collapse All",
        "columns": "Columns",
        "grouping": "Grouping",
        "reset": "Reset table to default"
      },
      "status_panel": {
        "items": "Items:",
        "out_of": "out of",
        "selected": "Selected Items:"
      },
      "others_group": "Others",
      "filters": {
        "selectable_filters": {
          "any": "Any",
          "range": "Range",
          "list": "List",
          "preset_options": "Preset Options",
          "custom_range": "Custom Range"
        },
        "ip": {
          "title": "Address",
          "subtitle": "One address per line"
        },
        "time_before_after": {
          "anytime": "Anytime",
          "started_before": "Started before",
          "started_after": "Started after",
          "ended_before": "Ended before",
          "ended_after": "Ended after",
          "date": "Date",
          "time": "Time",
          "before": "Before ${time}",
          "after": "After ${time}",
          "from": "From ${time}",
          "until": "Until ${time}"
        },
        "text_list": {
          "title": "Insert ID list (one per row); values must be in valid UUID format",
          "title_no_validation": "Insert ID list (one per row)"
        }
      },
      "severity": {
        "critical": "Critical",
        "high": "High",
        "medium": "Medium",
        "low": "Low",
        "info": "Info",
        "none": "None"
      }
    },
    "not_available": "N/A",
    "disabled": "Disabled",
    "enabled": "Enabled",
    "dropdown": {
      "select": "Select",
      "multiple_select": "Select multiple",
      "combo_select": "Select multiple or type",
      "add_new": "add new"
    },
    "risk": {
      "tooltip": "Risk score",
      "status": {
        "off": "OFF"
      },
      "events": "Unresolved Events",
      "vulnerabilities": "Vulnerabilities",
      "criticality": "Criticality",
      "widget": {
        "low": "Low Risk",
        "medium": "Medium Risk",
        "high": "High Risk",
        "tooltip_title": "Average Risk Score Breakdown",
        "controllers_modules_assets": "Controllers & Modules",
        "network_assets": "Network Assets",
        "iot_assets": "Iot Assets"
      }
    },
    "key_words": {
      "em": "EM",
      "assets": "Assets",
      "items": "items",
      "select_all": "(Select All)",
      "blanks": "(Blanks)",
      "all": "All",
      "export_file_name": "Exported data",
      "ongoing": "Ongoing",
      "direct": "(Direct)"
    },
    "copy_of": "Copy of",
    "dynamic_copy_of": "$t(general.copy_of) {{title}}",
    "bulk_toaster": {
      "success": "Bulk operation completed successfully",
      "failure": "Bulk operation completed with errors"
    },
    "search_placeholder": "Search…",
    "empty_state": {
      "no_items": "No items",
      "no_items_found": "No items found",
      "refine": "Refine your search or remove filters",
      "loading": "Loading table data"
    },
    "capability_unavailable_action": "Sorry, You don’t have permission to perform this action.",
    "tenable_support_email": "support@tenable.com",
    "generic_contact_support_msg": "If the problem persists, contact {{email}}",
    "input_range": {
      "start": "start",
      "end": "end"
    },
    "status_pill_options": {
      "resurfaced": "Resurfaced",
      "active": "Active",
      "resolved": "Resolved",
      "fixed": "Fixed",
      "authorized": "Authorized"
    },
    "from": "From",
    "to": "To",
    "any_date": "Any Date",
    "no_results": {
      "title": "Could Not Load Details",
      "subtitle": "Please try again, and if the problem persists, contact support@tenable.com."
    }
  },
  "my_saved_views": {
    "title": "My Saved Views",
    "empty_tooltip": "To create a saved view, go to the Inventory or Findings pages, apply filters of your choice and click “Save Filter”.",
    "inventory": "Inventory",
    "controllers": "Controllers & Modules",
    "network": "Network Assets",
    "iot": "IoT Assets",
    "vulnerabilities": "Vulnerabilities",
    "policy_violations": "Policy Violations"
  },
  "side_drawer": {
    "no_results": {
      "title": "Could Not Load Details",
      "subtitle": "Please try again"
    }
  },
  "ui_grid": {
    "columns": {
      "displayed_columns": "Displayed Columns",
      "reset_to_default": "Reset Columns to Default"
    },
    "filters": {
      "select_all": "Select All",
      "group_by": {
        "title": "Group By",
        "title_active": "Grouped By: {{group}}",
        "collapse_all": "Collapse All",
        "expand_all": "Expand All",
        "none": "None"
      },
      "add_filter": "Add Filter",
      "remove_all_filters": "Remove All Filters",
      "save_filter": "Save Filter",
      "edit_filter": "Edit Saved Filter",
      "saved_filters": {
        "disabled_hover": "There are no saved filters yet",
        "enabled_hover": "{{count}} Saved Filters",
        "max_filters_reached": "You've reached the maximum number of saved filters. To save a new one, first delete an existing one",
        "success_message": "Filter saved successfully",
        "edit_success_message": "Changes in saved filter were saved successfully",
        "delete_success_message": "Saved filter was deleted successfully",
        "name_edit_success_message": "Saved filter was edited successfully",
        "saved_filter_actions_hover": "Saved Filter Actions",
        "form": {
          "name": "Name",
          "filters": "Filter:"
        },
        "action_buttons": {
          "edit_name": "Edit Saved Filter Name",
          "delete": "Delete Saved Filter",
          "save_changes": "Save Changes",
          "save_copy": "Save as Copy"
        }
      }
    },
    "actions": {
      "label": "Actions",
      "label_bulk": "Bulk Actions",
      "selected": "{{count}} Selected"
    },
    "no_results": {
      "title": "No Results",
      "description": "Try adjusting the filters or refining your search"
    },
    "no_data": {
      "title": "No Data"
    }
  },
  "em": {
    "title": "EM",
    "icp": {
      "title": "ICP"
    }
  },
  "setup_wizard": {
    "title": "Set-up Wizard",
    "title_iem": "EM Set-up Wizard",
    "submit_button": "Complete and Restart",
    "start_setup": {
      "title": "Welcome to Tenable OT Security setup",
      "title_iem": "Welcome to Tenable OT Security Enterprise Manager setup",
      "button": "Start Set-up Wizard"
    },
    "user_info": {
      "title": "User Info",
      "username": "Username",
      "retype_username": "Retype Username",
      "full_name": "Full Name",
      "password": "Password",
      "retype_password": "Retype Password"
    },
    "device": {
      "title": "Device",
      "device_name": {
        "title_icp": "Site Name",
        "title_em": "Organization Name",
        "description": "The name of the site where the Tenable OT Security ICP device is installed",
        "description_em": "The name of the organization using this Tenable OT Security Enterprise Manager platform"
      },
      "port_configuration": {
        "description": "It is possible to separate the Tenable OT Security management port from the port used for active queries. After applying this change, the management interface will be accessible through port #3 while the active queries are carried out through port #1.",
        "checkbox": "Separate management from active queries"
      },
      "ip": {
        "title": "IP",
        "description": "The IP address for Management and active queries"
      },
      "queries_ip": {
        "title": "Active Queries IP",
        "description": "The IP address for active queries"
      },
      "subnet_mask": "Subnet Mask",
      "queries_subnet_mask": "Active Queries Subnet Mask",
      "gateway": "Gateway",
      "queries_gateway": "Active Queries Gateway",
      "management": {
        "ip": {
          "title": "Management IP",
          "description": "The IP address for Management"
        },
        "subnet": "Management Subnet Mask",
        "gateway": "Management Gateway"
      }
    },
    "notifications": {
      "failure": "Failed to set up your device. Please try again later, or contact Tenable support if the problem persists."
    }
  },
  "about": {
    "buttons": {
      "about": "About",
      "logout": "Log-out"
    },
    "version": "Version",
    "updated": "Updated",
    "license_type": "License Type",
    "subscription": "Subscription",
    "perpetual": "Perpetual",
    "subscription_expires": "Subscription Expires",
    "maintenance_expires": "Maintenance Expires",
    "licensed_assets": "Licensed Assets",
    "unlimited": "Unlimited",
    "license_code": "License Code",
    "computer_id": "Computer ID",
    "customer_id": "Customer ID",
    "copyright": "© {{year}} Tenable™, Inc."
  },
  "compliance": {
    "title": "Compliance",
    "frameworks_link": "Security Framework Preferences",
    "frameworks": {
      "iso": "ISO 27001 Controls",
      "caf": "CAF Principles",
      "otcc": "OTCC Sub Domains",
      "nis2": "NIS 2 Directive (Article 21)",
      "nerc_cip": "NERC-CIP Requirements",
      "iec_62443": "IEC-62443 Requirements",
      "nist_csf": "NIST-CSF Subcategory",
      "default": "Not Defined (Default)"
    },
    "compliance_card": {
      "applied_for": "Applies to: ",
      "show_assets": "Show Asset List",
      "hide_assets": "Hide Asset List",
      "frameworks_mapping": {
        "iec_62443": {
          "title": "IEC-62443 Requirements:",
          "tooltip": {
            "risk_assessment": "62443-3-3:2013 \nSR 7.8 (Control system component inventory)",
            "incident_handling": "62443-3-3:2013 \nSR 2.8 (Auditable events)\nSR 2.9 (Audit storage capacity)\nSR 2.10 (Response to audit processing failures)\nSR 2.11 (Timestamps)\nSR 3.1 (Communication integrity)\nSR 3.2 (Malicious code protection)\nSR 3.3 (Security functionality verification)\nSR 3.5 (Input validation)\nSR 5.1 (Network segmentation)\nSR 5.2 (Zone boundary protection)\nSR 5.3 (General-purpose person-to-person communication restrictions)\nSR 6.1 (Audit log accessibility)\nSR 6.2 (Continuous monitoring)\nSR 7.6 (Network and security configuration settings)",
            "vulnerability_handling": "SR 3.3 (Security functionality verification)\nSR 3.4 (Software and information integrity)\nSR 6.2 (Continuous monitoring)\nSR 7.6 (Network and security configuration settings)\nSR 7.8 (Control system component inventory)",
            "config_management": "62443-3-3:2013 \nSR 2.8 (Auditable events)\nSR 2.9 (Audit storage capacity)\nSR 2.10 (Response to audit processing failures)\nSR 2.11 (Timestamps)\nSR 3.2 (Malicious code protection)\nSR 7.6 (Network and security configuration settings)",
            "supply_chain_management": "62443-3-3:2013 \nSR 3.1 (Communication integrity)",
            "insecure_cryptography": "62443-3-3:2013 \nSR 1.7 (Strength of password-based authentication)",
            "insecure_communication": "62443-3-3:2013 \nSR 3.1 (Communication integrity) \nSR 3.5 (Input validation)\nSR 4.1 (Information confidentiality)\nSR 4.3 (Use of cryptography)\nSR 5.1 (Network segmentation)\nSR 5.2 (Zone boundary protection)\nSR 5.3 (General-purpose person-to-person communication restrictions)"
          },
          "text": {
            "risk_assessment": "62443-3-3:2013, \nSR 7.8",
            "incident_handling": "62443-3-3:2013, \nSR 2.8, \nSR 2.9, \nSR 2.10, \nSR 2.11, \nSR 3.1,\nSR 3.2, \nSR 3.3\nSR 3.5, \nSR 5.1, \nSR 5.2, \nSR 5.3, \nSR 6.1, \nSR 6.2\nSR 7.6",
            "vulnerability_handling": "SR 3.3, \nSR 3.4, \nSR 6.2, \nSR 7.6, \nSR 7.8",
            "config_management": "62443-3-3:2013, \nSR 2.8, \nSR 2.9, \nSR 2.10, \nSR 2.11,  \nSR 3.2\nSR 7.6",
            "supply_chain_management": "62443-3-3:2013, \nSR 3.1",
            "insecure_cryptography": "62443-3-3:2013, \nSR 1.7",
            "insecure_communication": "62443-3-3:2013, \nSR 3.1, \nSR 3.5, \nSR 4.1, \nSR 4.3, \nSR 5.1, \nSR 5.2, \nSR 5.3"
          }
        },
        "iso": {
          "title": "ISO 27001 | Controls:",
          "tooltip": {
            "risk_assessment": "5.9 (Inventory of information and other associated assets)\n5.12 (Classification of information)",
            "incident_handling": "5.7 (Threat intelligence)\n5.25 (Assessment and decision on information security events)\n5.28 (Collection of evidence)\n6.8 (Information security event reporting)\n8.7 (Protection against malware)\n8.15 (Logging)\n8.16 (Monitoring activities)",
            "vulnerability_handling": "5.7 (Threat intelligence)\n8.8 (Management of technical vulnerabilities)",
            "config_management": "8.9 (Configuration management)\n8.15 (Logging)\n8.16 (Monitoring activities)\n8.19 (Installation of software on operational systems)",
            "supply_chain_management": "5.15 (Access control)",
            "insecure_cryptography": "6.8 (Information security event reporting)\n8.24 (Use of cryptography)",
            "insecure_communication": "5.16 (Identity management)\n5.17 (Authentication information)\n6.8 (Information security event reporting)"
          },
          "text": {
            "risk_assessment": "5.9, 5.12",
            "incident_handling": "5.7, 5.25, 5.28, 6.8, 8.7, 8.15, 8.16",
            "vulnerability_handling": "5.7, 8.8",
            "config_management": "8.9, 8.15, 8.16, 8.19",
            "supply_chain_management": "5.15",
            "insecure_cryptography": "6.8, 8.24",
            "insecure_communication": "5.16, 5.17, 6.8"
          }
        },
        "nerc_cip": {
          "title": "NERC-CIP | Requirements:",
          "tooltip": {
            "risk_assessment": "CIP-08-6 R1 (Cyber Security Incident Response Plan Specifications)\nCIP-08-6 R2 (Cyber Security Incident Response Plan Implementation and Testing)\nCIP-010-2 R3 (Configuration Change Mgmt and Vulnerability assessments)",
            "incident_handling": "CIP-08-6 R1 (Cyber Security Incident Response Plan Specifications)\nCIP-08-6 R2 (Cyber Security Incident Response Plan Implementation and Testing)",
            "vulnerability_handling": "CIP-007-6 R2 (Security Patch Management)\nCIP-007-6 R4 (Systems Event Monitoring)\nCIP-010 R1 (Configuration Change Management) \nCIP-010 R3 (Vulnerability assessments)",
            "config_management": "CIP-010 R1 (Configuration Change Management) \nCIP-010 R2 (Configuration Monitoring)",
            "supply_chain_management": "CIP-005-6 R1 (Electronic Security Perimeter)\nCIP-007-6 R4 (Systems Event Monitoring)",
            "insecure_cryptography": "CIP-005-6 R2 (Remote Access Management)",
            "insecure_communication": "CIP-005-6 R1 (Electronic Security Perimeter)"
          },
          "text": {
            "risk_assessment": "CIP-08-6 R1,R2, CIP-010-2 R3",
            "incident_handling": "CIP-008-6 R1, CIP-008-6 R2",
            "vulnerability_handling": "CIP-010 R3, CIP-007-6 R2, CIP-007-6 R4, CIP-010 R1",
            "config_management": "CIP-010-3 R1, CIP-010-3 R2",
            "supply_chain_management": "CIP-005-6 R1, CIP-007-6 R4",
            "insecure_cryptography": "CIP-005-6 R2",
            "insecure_communication": "CIP-005-6 R1"
          }
        },
        "caf": {
          "title": "CAF | Principles:",
          "tooltip": {
            "risk_assessment": "A2.a (Risk Management Process)\nA3.a (Asset Management)",
            "incident_handling": "C1.a (Monitoring Coverage) \nC1.b (Securing Logs) \nC1.c (Generating Alerts) \nC1.d (Identifying Security Incidents) \nC1.e (Monitoring Tools and Skills) \nC2.a (System Abnormalities for Attack Detection) \nC2.b (Proactive Attack Discovery)",
            "vulnerability_handling": "A2.a (Risk  Management  Process) \nB4.d (Vulnerability Management)",
            "config_management": "B5.a (Resilience Preparation)\nC1.a (Monitoring Coverage)",
            "supply_chain_management": "C2.b (Proactive Attack Discovery)",
            "insecure_cryptography": "B3.b (Data in Transit)",
            "insecure_communication": "B2.a (Identity Verification, Authentication and Authorization)"
          },
          "text": {
            "risk_assessment": "A2.a, A3.a",
            "incident_handling": "C1.a, C1.b, C1.c, C1.d, C1.e, C2.a, C2.b",
            "vulnerability_handling": "A2.a, B4.d",
            "config_management": "B5.a, C1.a",
            "supply_chain_management": "C2.b",
            "insecure_cryptography": "B3.b",
            "insecure_communication": "B2.a"
          }
        },
        "otcc": {
          "title": "OTCC | Subdomains:",
          "tooltip": {
            "risk_assessment": "1-3 (Cybersecurity Risk Management)\n2-1 (Asset Management)",
            "incident_handling": "2-11 (Cybersecurity Event Logs and Monitoring Management)\n2-12 (Cybersecurity Incident and Threat Management)",
            "vulnerability_handling": "2-9 (Vulnerability Management)",
            "config_management": "2-11 (Cybersecurity Event Logs and Monitoring Management)",
            "supply_chain_management": "1-3 (Cybersecurity Risk Management)",
            "insecure_cryptography": "2-7 (Cryptography)\n2-11 (Cybersecurity Event Logs and Monitoring Management)",
            "insecure_communication": "2-2 (Identity and Access Management)\n2-11 (Cybersecurity Event Logs and Monitoring Management)"
          },
          "text": {
            "risk_assessment": "1-3, 2-1",
            "incident_handling": "2-11, 2-12",
            "vulnerability_handling": "2-9",
            "config_management": "2-11",
            "supply_chain_management": "1-3",
            "insecure_cryptography": "2-7, 2-11",
            "insecure_communication": "2-2, 2-11"
          }
        },
        "nis2": {
          "title": "NIS 2 Directive (Article 21) | measures:",
          "tooltip": {
            "risk_assessment": "a (Policies on risk analysis and information system security)\ni (Human resources security, access control policies and asset management)",
            "incident_handling": "b (Incident handling)\nf (Policies and procedures to assess the effectiveness of cybersecurity risk-management measures)\ng (Basic cyber hygiene practices and cybersecurity training)",
            "vulnerability_handling": "e (Security in network and information systems acquisition, development and maintenance, including vulnerability handling and disclosure)\nf (Policies and procedures to assess the effectiveness of cybersecurity risk-management measures)\ng (Basic cyber hygiene practices and cybersecurity training)\ni (Human resources security, access control policies, and asset management)",
            "config_management": "c (Business continuity, such as backup management and disaster recovery, and crisis management)\ng (Basic cyber hygiene practices and cybersecurity training)",
            "supply_chain_management": "a (Policies on risk analysis and information system security),\ni (Human resources security, access control policies, and asset management)",
            "insecure_cryptography": "h (Policies and procedures regarding the use of cryptography and, where appropriate, encryption.)\nj (The use of multi-factor authentication or continuous authentication solutions, secured voice, video, and text communications and secured emergency communication systems within the entity, where appropriate.)",
            "insecure_communication": "j (The use of multi-factor authentication or continuous authentication solutions, secured voice, video and text communications and secured emergency communication systems within the entity, where appropriate.)"
          },
          "text": {
            "risk_assessment": "a, i",
            "incident_handling": "b, f, g",
            "vulnerability_handling": "e, f, g, i",
            "config_management": "c, g",
            "supply_chain_management": "a, i",
            "insecure_cryptography": "h, j",
            "insecure_communication": "j"
          }
        },
        "nist_csf": {
          "title": "NIST-CSF Subcategory",
          "tooltip": {
            "risk_assessment": "ID-AM-1 (Physical devices and systems within the organization are inventoried)\nID-AM-2 (Software platforms and applications within the organization are inventoried)\nID-AM-3 (Organizational communication and data flows are mapped)\nID-AM-5 (Resources are prioritized based on their classification, criticality, and business value)",
            "incident_handling": "ID-RA-2 (Cyber threat intelligence is received from information sharing forums and sources\nID-RA-3 (Threats, both internal and external, are identified and documented)\nID-RA-4 (Potential business impacts and likelihoods are identified)\nPR-AC-2 (Physical access to assets is managed and protected)\nDE-AE-2 (Detected events are analyzed to understand attack targets and methods)\nDE.AE-4 (Impact of events is determined) \nDE-AE-5 (Incident alert thresholds are established)\nDE-CM-2 (The physical environment is monitored to detect potential cybersecurity events)\nDE-CM-4 (Malicious code is detected)\nRS-AN-2 (The impact of the incident is understood)",
            "vulnerability_handling": "ID-RA-1 (Asset vulnerabilities are identified and documented)\nID-RA-2 (Cyber threat intelligence is received from information-sharing forums and sources)\nID-RA-3 (Threats, both internal and external, are identified and documented)\nID-RA-4 (Potential business impacts and likelihoods are identified)\nID-RA-5 (Threats, vulnerabilities, likelihoods, and impacts are used to determine risk)\nID-RA-6 (Risk responses are identified and prioritized)\nPR-IP-2 (A System Development Life Cycle to manage systems is implemented)\nDE-CM-8 (Vulnerability scans are performed)",
            "config_management": "PR-IP-1 (A baseline configuration of information technology/industrial control systems is created and maintained incorporating security principles)\nPR-IP-3 (Configuration change control processes are in place)\nPR-MA-1 (Maintenance and repair of organizational assets are performed and logged, with approved and controlled tools)\nDE-CM-4 (Malicious code is detected)",
            "supply_chain_management": "PR-AC-5 (Network integrity is protected)",
            "insecure_cryptography": "PR-AC-1 (Identities and credentials are issued, managed, verified, revoked, and audited for authorized devices, users and processes)",
            "insecure_communication": "PR-AC-5 (Network integrity is protected)\nDE.CM-7 (Monitoring for unauthorized personnel, connections, devices, and software is performed)"
          },
          "text": {
            "risk_assessment": "ID-AM-1、\nID-AM-2、\nID-AM-3、\nID-AM-5",
            "incident_handling": "ID-RA-2 \nID-RA-3 \nID-RA-4 \nPR-AC-2\nDE-AE-2 \nDE-AE-4 \nDE-AE-5 \nDE-CM-2 \nDE-CM-4 \nRS-AN-2",
            "vulnerability_handling": "ID-RA-1, \nID-RA-2, \nID-RA-3, \nID-RA-4, \nID-RA-5, \nID-RA-6 , \nPR-IP-2, \nDE-CM-8",
            "config_management": "PR-IP-1, \nPR-IP-3, \nPR-MA-1, \nDE-CM-4",
            "supply_chain_management": "PR-AC-5",
            "insecure_cryptography": "PR-AC-1",
            "insecure_communication": "PR-AC-5、\nDE-CM-7"
          }
        }
      },
      "titles": {
        "incident_handling": "Incident Handling",
        "vulnerability_handling": "Vulnerability Handling",
        "config_management": "Configuration & Change Management",
        "supply_chain_management": "External Exposure Risk",
        "insecure_cryptography": "Unsecured Cryptography",
        "insecure_communication": "Unsecured Communication Monitoring",
        "risk_assessment": "Risk Assessment"
      },
      "descriptions": {
        "incident_handling": "Monitor and promptly respond to high-risk security incidents. Minimize their impact by ensuring timely detection and effective response.",
        "vulnerability_handling": "Identify, evaluate, and mitigate OT, network, and IoT asset vulnerabilities. Protect against exploits through proactive Risk-Based Vulnerability Management.",
        "config_management": "Ensure operational continuity and quick recovery during service disruptions.",
        "supply_chain_management": "Identify, evaluate, and mitigate OT, network, and IoT assets from unexpected external communication.",
        "insecure_cryptography": "Monitor and detect unsecured cryptographic events to prevent compromise of sensitive information and service disruption.",
        "insecure_communication": "Monitor and detect unsecured communication events. Prevent unauthorized access.",
        "risk_assessment": "Assess and manage risks associated with OT, network, and IoT assets. Ensure proactive identification and mitigation of potential threats."
      },
      "tooltips": {
        "based_on_events": "Based on events resolved in the last 30 Days",
        "based_on_vulnerabilities": "Based on vulnerabilities fixed in the last 90 Days",
        "external_connection": "Assets that may be accessible from the Internet/External networks within 2 hops or less",
        "based_on_events_last_7_days": "Based on events from the last 7 Days"
      },
      "grid": {
        "titles": {
          "incident_handling": "Assets with abnormal unresolved events",
          "incident_handling_asset_list": "Mean Time to Response (MTTR) in days",
          "vulnerability_handling": "Active vulnerabilities by asset type category",
          "vulnerability_handling_asset_list": "Mean Time to Respond (MTTR) & SLA in days",
          "config_management_asset_list": "Assets with Unresolved Configuration and Change Events",
          "supply_chain_management": "Assets with potential external exposure risk",
          "insecure_cryptography": "Unsecured Cryptographic Events",
          "insecure_communication": "Suspicious Authentication Events",
          "risk_assessment": "Assets at Risk by Category"
        },
        "columns": {
          "event_category": "Event Category",
          "criticality_high": "Asset Criticality: High",
          "criticality_medium": "Asset Criticality: Medium",
          "criticality_low": "Asset Criticality: Low",
          "total_assets": "Total Assets",
          "ot_controllers": "Controllers and Modules",
          "network_assets": "Network Assets",
          "iot_assets": "IoT Assets",
          "total_fixed": "Total Vulnerabilities",
          "within_sla": "Fixed within SLA",
          "overdue": "Fixed after SLA",
          "mttr": "MTTR",
          "violation_type": "Risk Type",
          "purdue_level_01": "Purdue Level 0-1 Assets",
          "purdue_level_23": "Purdue Level 2-3 Assets",
          "purdue_level_45": "Purdue Level 4 Assets",
          "unsecured_login_purdue_level_23": "Purdue Level 2-3 assets associated with “Unsecured Login” Events",
          "unsecured_login_purdue_level_45": "Purdue Level 4 assets associated with “Unsecured Login” Events",
          "login_unencrypted_purdue_level_23": "Purdue Level 2-3 assets associated with Login “Using Unencrypted Credentials” Events",
          "login_unencrypted_purdue_level_45": "Purdue Level 4 assets associated with Login “Using Unencrypted Credentials” Events",
          "connection_without_auth_purdue_level_23": "Purdue Level 2-3 assets associated with Login “RDP with No Authentication” Events",
          "connection_without_auth_purdue_level_45": "Purdue Level 4 assets associated with Login “RDP with No Authentication” Events",
          "failed_login_purdue_level_23": "Purdue Level 2-3 assets associated with “Failed login” Events",
          "failed_login_purdue_level_45": "Purdue Level 4 assets associated with “Failed login” Events",
          "external_connection_purdue_level_01": "Purdue Level 0-1 Assets with External connection",
          "external_connection_purdue_level_23": "Purdue Level 2-3 Assets with External connection",
          "network_events": "High-critical assets associated with Network Events",
          "network_threats": "High-critical assets associated with Network Threat Events",
          "controller_activities_events": "Assets associated with Controller Activities Events",
          "controller_validation_events": "Assets associated with Controller Validation Events",
          "scada_events": "Assets associated with SCADA Events",
          "mttr_last_30_days": "MTTR (Last 30 days)",
          "risk_score": "Risk Score",
          "vulnerability_severity": "Vulnerability Severity",
          "total_asset_in_scope": "Total Assets in Scope",
          "frameworks_in_scope": "Frameworks in Scope",
          "general": "General Info",
          "assets_at_high_risk": "Assets at High Risk",
          "assets_suspicious_events": "High-Risk Asset with suspicious open events",
          "assets_change_events": "High-Risk Asset with configuration and status change events",
          "assets_external_connection": "High-Risk Asset with external connection",
          "assets_critical_vulnerabilities": "High-Risk Asset with active critical vulnerabilities",
          "assets_insecure_auth": "High-Risk Asset with Unsecured authentication events"
        },
        "rows": {
          "network_threats": "Network Threats",
          "network_events": "Network Events",
          "critical": "Critical",
          "high": "High",
          "medium": "Medium",
          "low": "Low",
          "critical_sla_3": "Critical (SLA 3 Days)",
          "high_sla_7": "High (SLA 7 Days)",
          "medium_sla_30": "Medium (SLA 30 Days)",
          "low_no_sla": "Low (No SLA)",
          "within_last_3_days": "Within last 3d",
          "more_than_3_days_ago": "More than 3d ago",
          "no_indication_for_snapshot": "No indication for Snapshot",
          "configuration_events": "Configuration Events",
          "scada_events": "SCADA Events",
          "controller_validation_events": "Controller Validation Events",
          "controller_activities_events": "Controller Activities Events",
          "external_connection": "External Connection",
          "new_asset_discovered": "New Asset Discovered (last 7 days)",
          "successful_unsecured_login": "Successful Unsecured Login",
          "login_unencrypted": "Login Using Unencrypted Credentials",
          "high_rate_of_login_attempts": "High Rate of Login Attempts",
          "failed_login": "Failed Login",
          "connection_with_no_authentication": "Connection with No Authentication",
          "rdp_no_authentication": "RDP with no Authentication"
        }
      }
    }
  },
  "dashboards": {
    "title": "Dashboards",
    "total": "Total {{items}}",
    "icp_license_expired_notification": "Some ICPs’ licenses have expired, so data from those ICPs is temporarily unavailable. To resolve this and ensure uninterrupted service, please update your ICP license.",
    "icps_link": "View ICPs",
    "buttons": {
      "create": "Create Dashboard",
      "view": "View Dashboard",
      "make_default": "Make Default"
    },
    "export": {
      "suffix": "-Dashboard",
      "page": "Page",
      "download_message": "Dashboard export in progress—keep the dashboard page open until download is complete",
      "report": {
        "button": "Save as PDF",
        "filename": "Executive Report",
        "em_filename": "Executive EM Report",
        "title": "Executive Report",
        "title_tooltip": "Last 30 days exportable PDF report",
        "site": "Site",
        "first_page": {
          "main_title": "Risk Assessment \n Report by Tenable OT Security",
          "secondary_title": "Tenable OT Security protects industrial networks from cyber threats,\n        malicious insiders, and human error, by providing visibility and control.",
          "description_one": "Tenable OT Security Risk Assessment report provides a unique, full, and detailed analysis of the industrial\n    environment, network behavior, asset inventory, and risk posture. The report covers all aspects of risk\n    assessment and delivers a comprehensive and fully detailed view of the network and assets in order\n    to drive mitigation and reduce risk.",
          "description_two": "Tenable OT Security’s advanced technology of network traffic monitoring and analysis, combined with its Device\n    Integrity component, generate the most complete and detailed situational awareness of the\n    industrial network. The report enables executives, managers, security analysts, and automation\n    engineers to dive deep into the risk factors in the network in order to prioritize mitigation steps. The\n    report provides process owners with the answers to some of the toughest challenges in protecting an\n    industrial network.",
          "copyright": "© Tenable, Inc. All rights reserved. Tenable OT Security is a registered trademark of Tenable, Inc"
        },
        "data_page": {
          "title": "Executive Summary"
        },
        "footer": {
          "breadcrumb": "Risk Assessment Report",
          "confidential": "Confidential",
          "version": "Tenable OT Security Version",
          "created_at": "Report Created At:"
        }
      }
    },
    "tooltip_nouns": {
      "sensor": "{{ count }} sensor",
      "sensor_other": "{{ count }} sensors",
      "asset": "{{ count }} asset",
      "asset_other": "{{ count }} assets",
      "controller": "{{ count }} controller",
      "controller_other": "{{ count }} controllers",
      "device": "{{ count }} device",
      "device_other": "{{ count }} devices",
      "event": "{{ count }} event",
      "event_other": "{{ count }} events",
      "vulnerability": "{{ count }} vulnerability",
      "vulnerability_other": "{{ count }} vulnerabilities",
      "icp": "{{ count }} ICP",
      "icp_other": "{{ count }} ICPs"
    },
    "cards": {
      "title": "Gallery",
      "risk": {
        "title": "Risk",
        "sub_title": "Product dashboard",
        "description": "This dashboard provides insights on the network’s cyber exposure by looking into asset risk score and vulnerability management metrics."
      },
      "inventory": {
        "title": "Inventory",
        "sub_title": "Product dashboard",
        "description": "This dashboard provides visibility into the asset inventory, facilitating asset management and tracking."
      },
      "events_and_policies": {
        "title": "Events and Policies",
        "sub_title": "Product dashboard",
        "description": "This dashboard provides the means to detect network threats by tracking the identified events and the policies used to detect them."
      }
    },
    "widgets": {
      "sensors_status": {
        "title": "Sensors Status",
        "chart_description": "",
        "columns": {
          "status": "Status",
          "count": "Assets"
        }
      },
      "assets_by_device_category": {
        "title": "Assets by Category",
        "chart_description": "",
        "columns": {
          "category": "Category",
          "count": "Assets"
        }
      },
      "assets_by_criticality": {
        "title": "Assets by Criticality",
        "chart_description": "",
        "columns": {
          "criticality": "Criticality",
          "count": "Assets"
        }
      },
      "assets_by_vendor": {
        "title": "Most Common Asset Vendors",
        "chart_description": "",
        "columns": {
          "vendor": "Vendor",
          "count": "Assets"
        }
      },
      "assets_by_os": {
        "title": "Most Common OS",
        "chart_description": "The following table shows an operating system breakdown of assets by type. The table is sorted by the total number of assets.",
        "columns": {
          "os": "OS",
          "count": "Assets"
        }
      },
      "assets_by_purdue_level": {
        "title": "Assets by Purdue Level",
        "chart_description": "",
        "columns": {
          "purdue": "Purdue level",
          "count": "Assets"
        }
      },
      "assets_by_risk": {
        "title": "Assets by Risk Score",
        "chart_description": "",
        "columns": {
          "risk": "Risk level",
          "count": "Assets"
        },
        "risk": {
          "off": "Off",
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        }
      },
      "sensors_system_health": {
        "title": "Overall Sensors Status",
        "chart_description": "",
        "columns": {
          "status": "Status",
          "count": "Sensors"
        },
        "status": {
          "offline": "Offline",
          "online": "Online"
        },
        "by_site": {
          "title": "Sensors Status",
          "chart_description": "",
          "columns": {
            "site": "site"
          }
        }
      },
      "assets_by_type": {
        "title": "Assets by Type",
        "chart_description": "The following chart shows the breakdown of all assets by type.",
        "columns": {
          "type": "Type",
          "count": "Assets"
        }
      },
      "network_assets_by_type": {
        "title": "Network assets by Type",
        "columns": {
          "type": "Type",
          "count": "Assets"
        }
      },
      "controllers_by_type": {
        "title": "Controllers and Modules by Type",
        "chart_description": "",
        "columns": {
          "type": "Type",
          "count": "Assets"
        }
      },
      "iot_devices_by_type": {
        "title": "IoT Assets by Type",
        "chart_description": "",
        "columns": {
          "type": "Type",
          "count": "Assets"
        }
      },
      "assets_by_family": {
        "title": "Most Common Asset Families",
        "chart_description": "",
        "columns": {
          "family": "Family",
          "count": "Assets"
        }
      },
      "events_by_category_chart": {
        "title": "Events by Category (Last 7 days)",
        "report_title": "Events by Category (Last 30 days)",
        "chart_description": "",
        "columns": {
          "type": "Type",
          "hit": "Events",
          "category": "Category",
          "count": "Status"
        }
      },
      "eventsinthelast30days": {
        "title": "Daily Events Breakdown (Last 30 days)",
        "chart_description": "",
        "columns": {
          "time": "Time",
          "none": "None",
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        }
      },
      "events_by_resolve_status_chart": {
        "title": "Events Status (Last 30 days)",
        "chart_description": "",
        "columns": {
          "status": "Status",
          "hit": "Events"
        }
      },
      "events_by_severity_chart": {
        "title": "Unresolved Events by Severity (Last 7 days)",
        "report_title": "Unresolved Events by Severity (Last 30 days)",
        "chart_description": "",
        "columns": {
          "severity": "Severity",
          "status": "Status",
          "hit": "Events"
        }
      },
      "inventory_statistics": {
        "title": "Inventory Statistics",
        "chart_description": "",
        "page_title": "Inventory",
        "columns": {
          "risk": "Average Risk Score",
          "assets": "Assets",
          "newAssets": "New assets last 24H",
          "reportNewAssets": "New Assets Last 30 Days"
        }
      },
      "risk_statistics": {
        "title": "Risk Statistics",
        "chart_description": "",
        "page_title": "Risk",
        "columns": {
          "risk": "Average Risk Score",
          "events": "Events in the Last 24h",
          "report_events": "Events in the Last 30 Days",
          "vulnerabilities": "Vulnerabilities"
        }
      },
      "events_statistics": {
        "title": "Events and Policies Statistics",
        "chart_description": "",
        "columns": {
          "events": "Unresolved Events—Last 24hrs",
          "policies": "Enabled Policies"
        }
      },
      "total_assets_statistics": {
        "title": "Total Assets Discovered",
        "chart_description": "",
        "columns": {
          "id": "Total Assets Discovered"
        }
      },
      "enabled_policies_statistics": {
        "title": "Enabled Policies",
        "chart_description": "",
        "columns": {
          "id": "Enabled Policies"
        }
      },
      "new_assets_statistics": {
        "title": "New Assets Discovered",
        "chart_description": "",
        "columns": {
          "id": "New Assets Discovered"
        }
      },
      "unresolved_events": {
        "title": "Unresolved Events in the last day",
        "chart_description": "",
        "columns": {
          "hitId": "Events"
        }
      },
      "top_risk_assets": {
        "title": "Highest-Risk Assets",
        "chart_description": "The following table shows the assets with the highest risk score, reflecting their CVE and exposure to threats.\n      The table is sorted by risk score.",
        "page_description": "A sound and reliable risk assessment requires thorough visibility into even the smallest details and\n      configuration changes in an OT network. Leveraging its superb detection capabilities and unique Device\n      Integrity offering, Tenable OT Security builds a risk profile for each asset using a wide range of signals and details about\n      asset configuration and asset-related events. In this way, Tenable OT Security supports a risk-based approach toward\n      raising overall level of cyber-hygiene in the industrial environment by clearly presenting the weakest\n      points and possible steps to address them.",
        "note": "Tenable OT Security constantly tracks assets' risk scores by integrating information on events, CVEs, and configuration\n      with user-defined asset criticality for industrial processes. Continuous risk assessment enables users to track changes in risk score and\n      risk factors, as well as evaluating mitigation steps. By tuning policies and defining different asset criticality levels, Tenable OT Security adapts its risk\n      evaluation to specific site guidelines and requirements.",
        "columns": {
          "name": "Name",
          "type": "Type",
          "risk": "Risk",
          "ips": "IPs",
          "macs": "MACs",
          "vendor": "Vendor"
        }
      },
      "top_assets_as_event_sources": {
        "title": "Most Common Event Sources (Last 7 days)",
        "report_title": "Most Common Event Sources (Last 30 days)",
        "chart_description": "",
        "columns": {
          "name": "Name",
          "count": "Events Count",
          "type": "Type",
          "risk": "Risk",
          "ips": "IPs",
          "macs": "MACs",
          "vendor": "Vendor"
        }
      },
      "top_assets_as_event_destinations": {
        "title": "Most Common Event Destinations (Last 7 days)",
        "report_title": "Most Common Event Destinations (Last 30 days)",
        "chart_description": "",
        "columns": {
          "name": "Name",
          "count": "Events Count",
          "type": "Type",
          "risk": "Risk",
          "ips": "IPs",
          "macs": "MACs",
          "vendor": "Vendor"
        }
      },
      "mostrecentevents": {
        "title": "Most Recent Events",
        "chart_description": "",
        "page_title": "Events",
        "columns": {
          "time": "Time",
          "type": "Type",
          "severity": "Severity",
          "srcAssets": "Source Assets",
          "dstAssets": "Destination Assets",
          "srcIp": "Source IP",
          "dstIp": "Destination IP",
          "srcMac": "Source MAC",
          "dstMac": "Destination MAC"
        }
      },
      "site_status": {
        "title": "ICP Status",
        "chart_description": "",
        "columns": {
          "connectivity": "Connectivity",
          "count": "ICPs"
        },
        "connectivity": {
          "online": "Online",
          "offline": "Offline"
        }
      },
      "policies_by_hits": {
        "title": "Most Common Policies (Last 7 days)",
        "report_title": "Most Common Policies (Last 30 days)",
        "chart_description": "",
        "page_title": "Policies"
      },
      "most_common_vulnerabilities": {
        "title": "Most Common Vulnerabilities",
        "chart_description": ""
      },
      "most_severe_vulnerability": {
        "title": "Most Severe Vulnerabilities",
        "chart_description": ""
      },
      "vulnerabilities_by_severity": {
        "title": "Vulnerabilities by Severity",
        "chart_description": ""
      },
      "most_common_plugin_families": {
        "title": "Most Common Plugin Families",
        "chart_description": ""
      },
      "iem_plugins_per_site": {
        "title": "Vulnerabilities",
        "chart_description": ""
      },
      "iem_high_severity_plugins": {
        "title": "High-Severity Vulnerabilities",
        "chart_description": ""
      },
      "iem_events": {
        "title": "Events (Last 24 hours)",
        "chart_description": ""
      },
      "iem_high_events": {
        "title": "High-Severity Events (Last 24 hours)",
        "chart_description": ""
      },
      "iem_assets": {
        "title": "Assets",
        "chart_description": ""
      },
      "iem_high_risk_assets": {
        "title": "High-Risk Assets",
        "chart_description": ""
      },
      "iem_avg_risk_score": {
        "title": "Average Risk Score",
        "chart_description": ""
      },
      "iem_sensors_status": {
        "title": "Sensors Status",
        "chart_description": ""
      },
      "iem_events_by_category": {
        "title": "Events by Category (Last 1 day)",
        "report_title": "Events by Category (Last 30 days)",
        "chart_description": ""
      },
      "iem_events_by_severity": {
        "title": "Unresolved Events by Severity (Last 1 day)",
        "report_title": "Unresolved Events by Severity (Last 30 days)",
        "chart_description": ""
      },
      "iem_events_by_category_severity": {
        "title": "Events by Category and Severity (Last 7 days)",
        "chart_description": ""
      },
      "iem_events_breakdown": {
        "title": "Hourly Events Breakdown (Last 24 hours)",
        "report_title": "Hourly Events Breakdown (Last 30 days)",
        "chart_description": ""
      },
      "iem_events_status": {
        "title": "Events Status (Last 7 days)",
        "report_title": "Events Status (Last 30 days)",
        "chart_description": ""
      },
      "iem_common_policies": {
        "title": "Most Common Policies by Events (Last 24 hours)",
        "report_title": "Most Common Policies by Events (Last 30 days)",
        "chart_description": "",
        "page_title": "Policies"
      }
    },
    "messages": {
      "make_default_success": "Default dashboard was updated successfully",
      "make_default_failure": "failed to update default dashboard"
    },
    "generic_columns": {
      "plugins": "Plugins",
      "site": "Site",
      "assets": "Assets",
      "events": "Events",
      "risk": "Risk Score"
    }
  },
  "events": {
    "title": "Events",
    "action_info_message": "All event actions are now available in Policy Violation Findings view",
    "action_info_message_link": "Go to Policy Violation Findings",
    "actions": {
      "pause": {
        "last_update": "Last update"
      },
      "resolve": "Resolve",
      "resolve_all": "Resolve All",
      "download_pcap": {
        "label": "Download Capture File",
        "findings_label": "Download Last Capture File",
        "notifications": {
          "preparing_pcap": "Preparing capture file for download—this may take a few minutes. Download will start automatically.",
          "failure": "Capture file for this event is not available"
        }
      },
      "exclude": {
        "title": "Exclude from Policy",
        "slider": {
          "info": "Future events that meet this condition will not affect asset risk score and will not appear in the events list. You will be able to delete this condition from the exclusions tab on the policy page.",
          "info_findings": "Future events that meet this condition will not generate a finding and will not affect asset risk score. You will be able to delete this condition from the exclusions tab on the policy page.",
          "policy": "Policy Name",
          "conditions": {
            "title": "Exclude Conditions",
            "title_findings": "Exclude Conditions (based on last event)",
            "src_asset": "Source asset is {{value}}",
            "src_ip": "Source IP is {{value}}",
            "dst_asset": "Destination asset is {{value}}",
            "dst_ip": "Destination IP is {{value}}",
            "sid": "SID is {{value}}",
            "protocol": "Protocol is {{value}}",
            "report": "Report is {{value}}",
            "gocbRef": "GOOSE Control Block Reference is {{value}}",
            "goId": "GOOSE ID is {{value}}",
            "mac": "MAC address is {{value}}",
            "ip": "IP address is {{value}}",
            "tag": "Tag is {{value}}",
            "usb": "USB device ID is {{value}}",
            "port": "Port is {{value}}",
            "src_dnp": "Source DNP3 address is {{value}}",
            "dst_dnp": "Destination DNP3 address is {{value}}",
            "cot": "Cause of Transmission is {{value}}",
            "multi": "within the set of ({{value}})"
          },
          "description": "Exclusion Description",
          "toaster": {
            "success": "Event was excluded successfully",
            "failure": "Event exclusion failed",
            "duplicate": "An exclusion with the same details for this policy already exists"
          }
        }
      }
    },
    "resolve_form": {
      "title": "Resolve Event",
      "title_other": "Bulk Resolve Events ({{count}})",
      "resolve_all_title": "Resolve all displayed events {{count}}",
      "aggregation_warning": "This action will resolve all displayed events. Clustered events will be resolved automatically.",
      "comment": "Comment",
      "resolve_all_popup": {
        "title": "Resolve All Displayed Events",
        "text": "Are you sure?<br>If you proceed, all events that are currently displayed will be resolved."
      },
      "messages": {
        "success": "{{ count }} event has been resolved successfully",
        "success_other": "{{ count }} events have been resolved successfully",
        "failure": "Failed to resolve the event",
        "failure_bulk": "There are no unresolved events to resolve"
      }
    },
    "resolved": "Resolved",
    "no_category": "No Category",
    "not_resolved": "Not resolved",
    "all_events": {
      "title": "All Events",
      "grid_columns": {
        "log_id": "Log ID",
        "finding_id": "Finding ID",
        "time": "Time",
        "time_localized": "Time Localized",
        "event_type": "Event Type",
        "severity": "Severity",
        "policy_name": "Policy Name",
        "src_asset": "Source Asset",
        "src_address": "Source Address",
        "dst_asset": "Destination Asset",
        "dst_address": "Destination Address",
        "protocol": "Protocol",
        "category": "Event Category",
        "status": "Status",
        "resolved_by": "Resolved By",
        "resolved_on": "Resolved On",
        "comment": "Comment",
        "time_utc": "Time UTC"
      },
      "cluster": "{{ count }} event in this cluster",
      "cluster_other": "{{ count }} events in this cluster",
      "event_summary": {
        "title": "Event Summary",
        "charts": {
          "event_over_time": "Event Over Time",
          "most_frequent_events_types": "Most Frequent Event Types",
          "events_by_category": "Events By Category"
        }
      },
      "power_panel": {
        "header": {
          "resolved": "Resolved",
          "not_resolved": "Not resolved",
          "event": "Event",
          "tooltip": {
            "log_id": "Event log ID: ",
            "time": "Time: ",
            "type": "Type: ",
            "severity": "Severity: ",
            "status": "Status: "
          },
          "not_seen": "Asset not seen for {{time}}"
        },
        "tabs": {
          "details": "Details",
          "rule": "Rule Details",
          "code": "Code",
          "source": "Source",
          "destination": "Destination",
          "affected": "Affected Assets",
          "policy": "Policy",
          "addresses": "Scanned Addresses",
          "ports": "Scanned Ports",
          "status": "Status"
        },
        "details": {
          "title": "Details",
          "name": "Name",
          "channel": "Channel",
          "iec_subscribe_failure_report": "Report",
          "iec_unauthorized_write_tag": "Tag",
          "goose_gocb_ref": "GOOSE Control Block Reference",
          "goose_go_id": "GOOSE ID",
          "goose_dat_set": "Dataset",
          "goose_anomaly_type": "Anomaly Type",
          "source_name": "Source Name",
          "source_ip_address": "Source IP Address",
          "source_mac_address": "Source MAC Address",
          "destination_name": "Destination Name",
          "destination_ip_address": "Destination IP Address",
          "destination_mac_address": "Destination MAC Address",
          "protocol": "Protocol",
          "port": "Port",
          "tag_value": "Tag Value",
          "tag_name": "Tag Name",
          "tag_count": "Tag Count",
          "task_name": "Task Name",
          "task_value": "Task Value",
          "program_name": "Program Name",
          "routine_name": "Routine Name",
          "rung_name": "Rung Name",
          "item_name": "Item Name",
          "forced_value": "Tag & Forced Value",
          "point_value": "Point Value",
          "point_user": "Point User",
          "code_revision": "Code Revision",
          "new_fw_version": "New FW Version",
          "new_key_state": "New Key State",
          "new_state": "New State",
          "old_fw_version": "Old FW Version",
          "old_key_state": "Old Key State",
          "old_state": "Old State",
          "function_code": "Function Code",
          "conflictingmacs": "Associated MAC Addresses",
          "clear_all": "Clear All",
          "clear_fault_table": "Clear Fault Table",
          "clear_io_fault_table": "Clear I/O Fault Table",
          "clear_tags": "Clear Tags",
          "clear_paths": "Clear Paths",
          "clear_hw_configuration": "Clear HW Configuration",
          "clear_logic": "Clear Logic",
          "clear_supplemental": "Clear Supplemental",
          "selected_protocol": "Selected Protocol",
          "cookie": "Cookie",
          "slot": "Slot",
          "traffic_deviation": "Deviation",
          "conversation_deviation": "Conversation Deviation",
          "average_traffic": "Average",
          "spike_value": "Spike Value",
          "average_conversations": "Average Conversations",
          "timestamp": "Baseline Date",
          "status": "Status",
          "plc_name": "PLC Name",
          "node_id": "Node ID",
          "signature": "Signature",
          "unit_number": "Unit Number",
          "time_window": "Time Window",
          "cot": "Cot",
          "source_dnp3_address": "Source DNP3 Address",
          "destination_dnp3_address": "Destination DNP3 Address",
          "username": "Username",
          "rule_message": "Rule Message",
          "sid": "SID",
          "why_important": "Why is this important?",
          "mitigation": "Suggested Mitigation",
          "last_seen": "Last seen",
          "type": "Type",
          "path_name": "Path Name",
          "type_name": "Type Name",
          "module_name": "Module Name",
          "number_deleted": "Deleted number",
          "mms_variables": "Details",
          "table_id": "Table ID",
          "version": "Version",
          "inactive_since": "Inactive since"
        },
        "route": {
          "title": "Route"
        },
        "source": {
          "title": "Source",
          "name": "Name",
          "type": "Type",
          "site": "Site",
          "location": "Location",
          "os": "OS",
          "vendor": "Vendor",
          "risk_score": "Risk Score",
          "asset_criticality": "Asset Criticality",
          "addresses": "Address",
          "ips": "IPs",
          "macs": "MACs",
          "model": "Model",
          "purdue_level": "Purdue Level",
          "description": "Description",
          "backplane": "Backplane",
          "slot": "Slot"
        },
        "destination": {
          "title": "Destination",
          "name": "Name",
          "type": "Type",
          "site": "Site",
          "location": "Location",
          "os": "OS",
          "vendor": "Vendor",
          "risk_score": "Risk Score",
          "asset_criticality": "Asset Criticality",
          "addresses": "Address",
          "ips": "IPs",
          "macs": "MACs",
          "model": "Model",
          "purdue_level": "Purdue Level",
          "description": "Description",
          "backplane": "Backplane",
          "slot": "Slot"
        },
        "policy": {
          "title": "Policy"
        },
        "status": {
          "title": "Status",
          "resolved": "Resolved status",
          "resolved_by": "Resolved By",
          "resolved_date": "Resolved Date",
          "comment": "Comment"
        },
        "rule": {
          "category": "Rule Category",
          "header": "Rule Header",
          "message": "Rule Message",
          "sid": "SID",
          "cve": "CVE Reference",
          "url": "URL Reference",
          "arachnids": "arachnids Reference",
          "bid": "BID Reference",
          "bugtraq": "bugtraq Reference",
          "mcafee": "mcafee Reference",
          "md5": "md5 Reference",
          "nessus": "nessus Reference",
          "secunia": "secunia Reference",
          "created": "Created On",
          "updated": "Rule Last Update",
          "revision": "Rule Revision"
        },
        "scanned_address": "Scanned Addresses",
        "scanned_ports": "Scanned Ports",
        "no_selection": "No item selected",
        "not_available": "Data is not available"
      },
      "filters": {
        "ip": {
          "title": "Addresses",
          "subtitle": "One address per line"
        },
        "no_items": "No items to filter"
      },
      "deleted_label": "(Deleted)"
    }
  },
  "configuration_events": {
    "title": "Configuration Events"
  },
  "scada_events": {
    "title": "SCADA Events"
  },
  "network_threats": {
    "title": "Network Threats"
  },
  "network_events": {
    "title": "Network Events"
  },
  "policies": {
    "notifications": {
      "create": {
        "success": "Policy created successfully",
        "failure": "Failed to create the policy"
      },
      "edit": {
        "success": "Policy was saved successfully",
        "failure": "Failed to save the policy"
      },
      "enable": {
        "failure": "Failed to enable the policy"
      },
      "disable": {
        "failure": "Failed to disable the policy"
      },
      "delete": {
        "success": "{{amount}} policies were deleted successfully",
        "failure": "Failed to delete the policies"
      },
      "duplicate": {
        "success": "Policy was duplicated successfully",
        "failure": "Failed to duplicate the policy"
      }
    },
    "title": "Policies",
    "grid_columns": {
      "policy_id": "Policy ID",
      "sub_category": "Sub Category",
      "category": "Category",
      "snapshot": "Take snapshot after policy hit",
      "disablePolicy": "Disable policy after first hit",
      "protocol": "Protocol",
      "hitsLast24h": "Events in the last 24 hours",
      "hitsLast1w": "Events in the last 7 days",
      "hitsLast30d": "Events in the last 30 days",
      "status": {
        "title": "Status",
        "paused_warning": "This policy generated too many events and was disabled by the system",
        "disabled_info": "Set a baseline in the network map in order to enable this policy",
        "paused_popup": {
          "header": "Enable Policy",
          "text": "Are you sure?<br>This policy generated too many events and was disabled by the system. We recommend that you edit the policy before turning it back on.",
          "enable": "Enable"
        },
        "enable": "ON",
        "disable": "OFF"
      },
      "policy_name": "Policy Name",
      "severity": "Severity",
      "event_type": "Event Type",
      "source": "Source",
      "destinations_affected_asset": "Destinations/Affected Asset",
      "destination": "Destination",
      "affected_assets": "Affected Assets",
      "protocol_port": "Protocol/Port",
      "schedule": "Schedule",
      "syslog": "Syslog",
      "tag_group": "Controller Tag Group",
      "value_group": "Tag Value",
      "not_seen_for": "Not Seen For",
      "rediscovered_asset": "Inactive For",
      "rule_group": "Rule Group",
      "time_window": "Time Window",
      "sensitivity": "Sensitivity",
      "email": "Email",
      "exclusions": "Exclusions"
    },
    "single_policy": {
      "details": {
        "title": "Details",
        "policy_definition": {
          "title": "Policy Definition"
        },
        "policy_actions": {
          "title": "Policy Actions",
          "true": "True",
          "false": "False",
          "snapshot": {
            "take_snapshot": "Take snapshot",
            "no": "No"
          }
        },
        "general": {
          "title": "General",
          "category": "Category",
          "status": {
            "value": {
              "disabled": "Disabled",
              "enabled": "Enabled",
              "paused": "Paused by the system"
            }
          }
        }
      },
      "triggered_events": {
        "title": "Triggered Events"
      },
      "exclusions": {
        "title": "Exclusions",
        "zone": {
          "asset_out_of_zone": "Asset out of zone",
          "asset_out_of_zone_other": "{{ count }} Assets out of zone"
        },
        "col_defs": {
          "src_asset": "Source Asset",
          "src_ip": "Source IP",
          "dst_asset": "Destination Asset",
          "dst_ip": "Destination IP",
          "protocol": "Protocol",
          "sid": "SID",
          "mac": "MAC Address",
          "ip": "IP Address",
          "tag": "Tag",
          "usb": "USB Device ID",
          "port": "Port",
          "cot": "COT",
          "src_dnp": "Source DNP3 Address",
          "dst_dnp": "Destination DNP3 Address",
          "gocbRef": "GOOSE Control Block Reference",
          "goId": "GOOSE ID",
          "description": "Description",
          "created_by": "Created By",
          "created_on": "Created On",
          "excluded_events": "Excluded Events"
        },
        "actions": {
          "delete_popup": {
            "title": "Delete Exclusion",
            "content": "Are you sure?<br>If you proceed, this exclusion will be permanently deleted.",
            "notification": {
              "success": "Exclusion was deleted successfully",
              "failure": "Failed to delete exclusion"
            }
          }
        }
      }
    },
    "event_type": {
      "step_title": "Event Type"
    },
    "policy_definition": {
      "step_title": "Policy Definition",
      "rule_group": "Rule Group",
      "tag_value": {
        "any": "Any value",
        "different": "Different from value",
        "range": "Out of allowed range"
      },
      "asset_not_seen": "Asset Not Seen",
      "protocol": "Protocol Group",
      "disable_after_hit": "Disable After Hit",
      "asset_group_info": "The available selection includes all asset groups except dynamic groups that have any of the following asset properties in their rule set: Risk Score, Backplane Name, Sources, Tags, Hardware State, Lifecycle Status, Replacement Product, Subnets."
    },
    "policy_actions": {
      "step_title": "Policy Actions",
      "event_severity": {
        "levels": {
          "high": {
            "order": "0",
            "display": "High"
          },
          "medium": {
            "order": "1",
            "display": "Medium"
          },
          "low": {
            "order": "2",
            "display": "Low"
          },
          "none": {
            "order": "3",
            "display": "None"
          }
        }
      },
      "additionalActions": {
        "title": "Additional Actions",
        "snapshot": "Take snapshot after policy hit",
        "disablePolicy": "Disable policy after first hit"
      },
      "email_group": {
        "no_smtp_config": "SMTP servers are not configured",
        "no_email_group_config": "No email groups configured"
      },
      "syslog": {
        "no_syslog_config": "Syslog servers are not configured"
      },
      "bulk_notification": "Information entered in the fields below will override any current content for the selected policies. Selected fields with no input will erase all current values."
    },
    "buttons": {
      "create_policy": "Create Policy",
      "edit_policy": "Edit Policy",
      "duplicate_policy": "Duplicate Policy",
      "delete_policy": {
        "header": "Delete Policies",
        "text": "Are you sure? <br>If you proceed, {{amountOfPolicies}} policies will be permanently deleted."
      }
    },
    "complex_group": {
      "or": "Or",
      "and": "And",
      "or_lower": "or",
      "and_lower": "and"
    },
    "bulk_edit_slider": {
      "title": "Bulk Edit ({{amount}})"
    }
  },
  "inventory": {
    "title": "Inventory",
    "no_results": {
      "title": "No Assets Found",
      "description": "Try updating your network definitions for better passive monitoring:",
      "button": "Go to Network Definitions",
      "description2": "OR\nCreate an asset discovery active query:",
      "button2": "Go to Discovery Queries"
    },
    "grid_columns": {
      "id": "Asset ID",
      "name": "Name",
      "plugin_last_hit": "Last Hit Date",
      "ips": "IP",
      "subnets": "Subnets",
      "macs": "MAC",
      "type": "Type",
      "backplane": "Backplane",
      "slot": "Slot",
      "vendor": "Vendor",
      "family": "Family",
      "firmware": "Firmware",
      "location": "Location",
      "last_seen": "Last Seen",
      "model": "Model",
      "state": "State",
      "description": "Description",
      "risk": "Risk Score",
      "criticality": "Criticality",
      "purdue": "Purdue Level",
      "first_seen": "First Seen",
      "mac": "MAC",
      "plc_name": "PLC Name",
      "domain": "Domain",
      "station": "Station",
      "os": "OS",
      "category": "Category",
      "network_segment": "Network Segment",
      "last_update": "Last Update",
      "last_code_change": "Last Code Change",
      "source": "Source",
      "eol_state": "Hardware State",
      "eol_discontinued_at": "Discontinued At",
      "eol_vendor_status": "Vendor Lifecycle Status",
      "eol_replacement": "Replacement Product",
      "serial": "Serial Number",
      "tags": "Tags"
    },
    "eol": {
      "state_values": {
        "active": "Active",
        "end_of_life": "End Of Life",
        "discontinued": "Discontinued",
        "unknown": "Unknown"
      },
      "filter": {
        "discontinued": {
          "before": "Discontinued before",
          "after": "Discontinued after"
        }
      }
    },
    "source": {
      "source_types": {
        "sensor": "Sensor",
        "local": "Local",
        "csv": "CSV",
        "pcap": "PCAP",
        "nessus": "Nessus",
        "active_ot": "Active OT",
        "iot_connector": "IoT Connector",
        "user_defined": "User Defined",
        "er_span": "ERSPAN",
        "ot_agent": "OT Agent"
      }
    },
    "controllers": {
      "title": "Controllers & Modules"
    },
    "network_assets": {
      "title": "Network Assets"
    },
    "every_asset": {
      "title": "All Assets",
      "export_diagnostics": "Export Diagnostics",
      "merge_with_another": "Merge with Another"
    },
    "iot_assets": {
      "title": "IoT Assets"
    },
    "edit_asset": {
      "title": "Edit Asset Details",
      "title_bulk": "Bulk Edit Asset Details ({{count}})",
      "bulk_info": "Information entered in the fields below will override any current content for the selected assets. Selected fields with no input will erase all current values.",
      "bulk_segment_unallowed": "Some of the selected assets have multiple IP addresses. Bulk action not available.",
      "fields": {
        "criticality": "Criticality",
        "purdueLevel": "Purdue Level",
        "network_segment": "Network Segments",
        "location": "Location",
        "description": "Description"
      }
    },
    "merge_assets": {
      "title": "Merge Asset | Select Source Asset",
      "subtitle": "Target Asset: {{asset_name}}",
      "merged_success": "Assets merged successfully",
      "note": "<b>Note:</b> the source asset that is selected here will be deleted from the inventory, after its attributes and findings are merged into the target asset <b>{{asset_name}}</b>. Any case of conflict will be resolved by the system to keep the merged asset’s data as full, accurate, and up to date as possible, based on the data of both assets. <b>This action is irreversible.<b>",
      "note_action": "Read more about asset merging in our user guide",
      "submit": "Merge and Delete",
      "force": "Force merge even if attributes conflict"
    }
  },
  "risks": {
    "title": "Risks"
  },
  "plugins": {
    "title": "Vulnerabilities",
    "single_page_title": "Vulnerability",
    "single_page_details": "Details",
    "single_page_assets": "Affected Assets",
    "active": "Active ({{ count }})",
    "fixed": "Fixed ({{ count }})",
    "single_page_assets_power_panel": {
      "header": {
        "tooltip": {
          "name": "Asset name: ",
          "ips": "Addresses: ",
          "type": "Type: ",
          "risk_score": "Risk score: ",
          "last_seen_date": "Last seen date: "
        }
      }
    },
    "update_plugin_flyout": "Update plugins",
    "vpr_severity": {
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "none": "None"
    },
    "grid": {
      "name": "Name",
      "severity": "Severity",
      "vpr_score": "VPR",
      "active_assets": "Active Assets",
      "fixed_assets": "Fixed Assets",
      "plugin_family": "Plugin family",
      "plugin_id": "Plugin ID",
      "source": "Source",
      "comment": "Comment",
      "owner": "Owner"
    },
    "grid_messages": {
      "mitigated_since": {
        "main": "Showing vulnerabilities that affected assets in your environment and were fixed since {{ date }}",
        "single_vuln": "Showing assets that were affected by this vulnerability and fixed since {{ date }}",
        "single_asset": "Showing vulnerabilities that affected this asset and were fixed since {{ date }}"
      },
      "updates_disabled": "You can enable automatic cloud updates for the Nessus Plugin Set",
      "updates_disabled_link": "Configure Settings"
    },
    "grid_info": {
      "plugin_set": "Plugin set",
      "last_update": "Last update"
    },
    "edit": {
      "button": "Edit Details",
      "title": "Edit Vulnerability Details",
      "title_other": "Bulk Edit Vulnerability Details ({{ count }})",
      "info": "Information entered in the fields below will override any current content for the selected Vulnerabilities. Selected fields with no input will erase all current values.",
      "messages": {
        "success": "Vulnerability details updated successfully"
      }
    },
    "details": {
      "category_overview": "Overview",
      "name": "Name",
      "severity": "Severity",
      "affectedAssets": "Affected Assets",
      "description": "Description",
      "solution": "Solution",
      "seeAlso": "Resources",
      "comment": "Comment",
      "owner": "Owner",
      "category_plugin_details": "Plugin details",
      "source": "Plugin Source",
      "id": "Plugin ID",
      "family": "Plugin Family Name",
      "pluginType": "Type",
      "pluginPubDate": "Publication Date",
      "pluginModDate": "Modification Date",
      "scriptVersion": "Script Version",
      "category_vpr_key_drivers": "VPR key drivers",
      "vprScore": "VPR Score",
      "threatRecency": "Threat Recency",
      "threatIntensity": "Threat Intensity",
      "exploitCodeMaturity": "Exploit Code Maturity",
      "ageOfVuln": "Age of Vulnerability",
      "productCoverage": "Product Coverage",
      "category_risk_info": "Risk info",
      "cvssVector": "CVSS Vector",
      "cvssTemporalVector": "CVSS Temporal Vector",
      "cvssTemporalScore": "CVSS Temporal Score",
      "cvssBaseScore": "CVSS Base Score",
      "cvssV3Vector": "CVSS v3.0 Vector",
      "cvssV3TemporalVector": "CVSS v3.0 Temporal Vector",
      "cvssV3TemporalScore": "CVSS v3.0 Temporal Score",
      "cvssImpactScore": "CVSS Impact Score",
      "cvssV3BaseScore": "CVSS v3.0 Base Score",
      "stigSeverity": "IAVM Severity",
      "category_vulnerability_information": "Vulnerability Information",
      "vulnPubDate": "Vulnerability Publication Date",
      "vulnModDate": "Vulnerability Modification Date",
      "cpe": "CPE",
      "category_refs": "Reference Information",
      "cves": "CVEs",
      "category_exploitability_information": "Exploitability Information",
      "exploitAvailable": "Exploit Available",
      "exploitabilityEase": "Exploit Ease",
      "exploitedByMalware": "Exploited by Malware",
      "exploitFrameworkCanvas": "Exploit Exists in CANVAS",
      "canvasPackage": "CANVAS Exploit Package",
      "exploitFrameworkCore": "Exploit Exists in CORE",
      "exploitFrameworkExploithub": "Exploit Exists in ExploitHub",
      "exploithubSku": "ExploitHub SKU",
      "exploitFrameworkMetasploit": "Exploit Exists in Metasploit",
      "metasploitName": "Metasploit Module",
      "exploitFrameworkD2Elliot": "Exploit Exists in D2 Elliot",
      "d2ElliotName": "D2 Elliot Entry",
      "pluginHits": {
        "port": "Port",
        "source": "Source",
        "hit_date": "Last Hit date",
        "fixed_at": "Fixed at",
        "output": {
          "title": "Plugin Output",
          "show": "Show full output",
          "hide": "Hide full output"
        }
      },
      "cisaKnownExploitedDates": "CISA Known Exploited Dates"
    },
    "nessus_loading": {
      "title": "Nessus is loading",
      "subtitle": "It may take up to 30 minutes to display Nessus plugin details. If the problem persists, contact support@tenable.com."
    },
    "nnm_not_available": {
      "title": "NNM is not available",
      "subtitle": "Plugin details are not available while NNM is down. If the problem persists, contact support@tenable.com."
    }
  },
  "findings": {
    "title": "Findings",
    "status": {
      "active": "Active",
      "fixed": "Fixed",
      "resurfaced": "Resurfaced",
      "resolved": "Resolved"
    },
    "vulnerability_findings": {
      "tab_title": "Vulnerabilities",
      "grid_title": "Vulnerability Findings",
      "no_results": {
        "title": "No Vulnerabilities Found",
        "description": "Try checking your inventory: you might not have known assets in your environment yet, or not enough details about your assets.",
        "button": "Go to Inventory"
      },
      "grid": {
        "id": "Finding ID",
        "affected_asset": "Affected Asset",
        "ip": "IP",
        "severity": "Severity",
        "plugin_name": "Plugin Name",
        "plugin_output": "Plugin Output",
        "plugin_id": "Plugin ID",
        "plugin_source": "Plugin Source",
        "plugin_family": "Plugin Family",
        "port": "Port",
        "protocol": "Protocol",
        "vpr": "VPR",
        "status": "Status",
        "first_hit": "First Hit",
        "last_hit": "Last Hit",
        "fixed_at": "Fixed At",
        "asset_type": "Asset Type",
        "asset_risk_score": "Asset Risk Score",
        "asset_criticality": "Asset Criticality",
        "asset_category": "Asset Category",
        "asset_vendor": "Asset Vendor",
        "asset_family": "Asset Family",
        "asset_model": "Asset Model",
        "asset_state": "Asset State",
        "asset_mac": "MAC Address",
        "firmware": "Firmware",
        "os": "OS",
        "purdue_lvl": "Purdue Level",
        "network_segment": "Network Segment",
        "location": "Location",
        "backplane_name": "Backplane Name",
        "plugin_cvssv3_score": "CVSSv3 Base Score",
        "asset_tags": "Asset Tags"
      },
      "cvss3_score_category": {
        "none": "None",
        "low": "Low",
        "medium": "Medium",
        "high": "High",
        "critical": "Critical"
      },
      "side_drawer": {
        "header": {
          "kpis": {
            "vpr": {
              "label": "VPR",
              "tooltip": "Tenable calculates the Vulnerability Priority Rating (VPR) of a vulnerability to measure risk and urgency. Tenable dynamically adjusts VPR to reflect the current threat landscape. VPR ranges from 0.1 to 10, with higher numbers meaning more likely exploits. A low VPR iis 0.1 to 3.9, while a medium VPR is 4.0 to 6.9. A high VPR is 7.0 to 8.9, while critical a VPR is 9.0 to 10."
            },
            "cvss3": {
              "label": "CVSSv3"
            },
            "criticality": {
              "label": "Asset Criticality"
            }
          }
        },
        "vulnerability_details": "Vulnerability Details",
        "plugin_output": "Plugin Output",
        "vulnerability": "Vulnerability",
        "affected_asset": {
          "title": "Affected Asset",
          "link": "View Full Asset Details",
          "name": "Name",
          "type": "Type",
          "criticality": "Criticality",
          "risk": "Risk Score",
          "ip": "IP Address",
          "macs": "MAC Address",
          "vendor": "Vendor",
          "family": "Family",
          "model": "Model",
          "firmware": "Firmware",
          "os": "OS",
          "tags": "Tags",
          "purdue": "Purdue Level"
        }
      }
    },
    "policy_violations": {
      "tab_title": "Policy Violations",
      "grid_title": "Policy Violation Findings",
      "events_link": "Full Event Log",
      "grid_actions": {
        "resolve": {
          "button": "Resolve",
          "title": "Resolve Finding",
          "bulk_title": "Bulk Resolve Findings ({{count}})",
          "description": "Resolve this event",
          "success": "Finding has been resolved successfully",
          "success_other": "{{ count }} findings have been resolved successfully"
        },
        "exclude": {
          "toaster": {
            "success": "Policy violation was excluded successfully"
          }
        }
      },
      "no_results": {
        "title": "No Policy Violations Found",
        "description": "To start collecting event-based data, you need to go to Network Definitions and turn on the Passive Monitoring engine,",
        "button": "Go to Network Definitions"
      },
      "grid": {
        "id": "Finding ID",
        "status": "Status",
        "severity": "Severity",
        "violation_type": "Violation Type",
        "violation_category": "Violation Category",
        "policy_name": "Policy",
        "plugin_name": "Plugin Name",
        "mitre_tactics": "MITRE ICS Tactics",
        "mitre_techniques": "MITRE ICS Techniques",
        "source_asset": "Source Asset",
        "source_ip": "Source IP",
        "source_mac": "Source MAC",
        "destination_asset": "Destination Asset",
        "destination_ip": "Destination IP",
        "destination_mac": "Destination MAC",
        "protocol": "Protocol",
        "first_hit": "First Hit",
        "last_hit": "Last Hit",
        "active_hits": "Active Hits",
        "asset_type": "Asset Type",
        "asset_criticality": "Asset Criticality",
        "asset_vendor": "Asset Vendor",
        "asset_family": "Asset Family",
        "asset_model": "Asset Model",
        "asset_tags": "Asset Tags",
        "purdue_lvl": "Purdue Level",
        "asset_location": "Asset Location",
        "resolved_on": "Resolved On",
        "resolved_by": "Resolved By",
        "comment": "Comment"
      },
      "side_drawer": {
        "header": {
          "policy_violation": "Policy Violation",
          "unknown_src_dst": "Unknown",
          "trend": {
            "label": "Active Hits",
            "tooltip": {
              "trending_up": "{{ last_trend_window_value }} hits in the last 7 days (up from {{ prev_trend_window_value }} in the previous 7 days)",
              "trending_down": "{{ last_trend_window_value }} hits in the last 7 days (down from {{ prev_trend_window_value }} in the previous 7 days)",
              "trending_unchanged": "{{ last_trend_window_value }} hits in the last 7 days (same as previous 7 days)"
            }
          },
          "resolved_at": "Resolved At",
          "similar_findings": {
            "label": "Similar Findings",
            "active": "Active",
            "resolved": "Resolved"
          }
        },
        "tabs": {
          "details": {
            "title": "Details",
            "section": {
              "section_title": "Finding Details",
              "section_subtitle": "To view the full details of all {{total_hits}} hits ({{active_hits}} active), search for this finding ID in the Events log.",
              "actions": {
                "copy": "Copy Finding ID",
                "events_log": "Full Event Log"
              }
            },
            "subsections": {
              "violation_details": {
                "title": "Violation Details",
                "what": "What Happened",
                "mitre_tactics": "MITRE ICS Tactics",
                "mitre_techniques": "MITRE ICS Techniques",
                "src_name": "Source Name",
                "src_ip": "Source IP Address",
                "src_mac": "Source MAC Address",
                "dest_name": "Destination Name",
                "dest_ip": "Destination IP Address",
                "dest_mac": "Destination MAC Address",
                "protocol": "Protocol",
                "violation_type": "Violation Type",
                "violation_category": "Violation Category",
                "policy_hit": "Policy Hits",
                "first_hit": "First Hit",
                "last_hit": "Last Hit"
              },
              "why_important": {
                "title": "Why is this important?"
              },
              "suggest_mitigation": {
                "title": "Suggested Mitigation"
              },
              "plugin": {
                "title": "Plugin Details",
                "name": "Plugin Name",
                "id": "Plugin ID",
                "severity": "Severity",
                "synopsis": "Plugin Synopsis",
                "description": "Plugin Description",
                "solution": "Solution"
              },
              "resolution": {
                "title": "Resolution Details",
                "resolved_by": "Resolved by",
                "resolved_at": "Resolved at",
                "comment": "Comment"
              }
            }
          },
          "source": {
            "title": "Source",
            "section": {
              "title_single": "Source Asset",
              "title_multiple": "Source Assets"
            },
            "subsections": {
              "title": "Source #{{ index }}",
              "link": "View Full Asset Details",
              "name": "Name",
              "type": "Type",
              "site": "Site",
              "location": "Location",
              "os": "OS",
              "vendor": "Vendor",
              "risk_score": "Risk Score",
              "asset_criticality": "Asset Criticality",
              "addresses": "Address",
              "ips": "IPs",
              "macs": "MACs",
              "model": "Model",
              "purdue_level": "Purdue Level",
              "description": "Description",
              "backplane": "Backplane",
              "slot": "Slot"
            }
          },
          "destination": {
            "title": "Destinations",
            "section": {
              "title_single": "Destination Asset",
              "title_multiple": "Destination Assets"
            },
            "subsections": {
              "title": "Destination #{{ index }}",
              "link": "View Full Asset Details",
              "name": "Name",
              "type": "Type",
              "site": "Site",
              "location": "Location",
              "os": "OS",
              "vendor": "Vendor",
              "risk_score": "Risk Score",
              "asset_criticality": "Asset Criticality",
              "addresses": "Address",
              "ips": "IPs",
              "macs": "MACs",
              "model": "Model",
              "purdue_level": "Purdue Level",
              "description": "Description",
              "backplane": "Backplane",
              "slot": "Slot"
            }
          },
          "policy": {
            "title": "Policy",
            "section": {
              "title": "Policy",
              "link": "View and Manage Full Policy Details"
            }
          }
        }
      }
    }
  },
  "code_revisions": {
    "version": "Version",
    "latest": "Latest",
    "empty": "There are no code versions for this controller\n Take a snapshot to start",
    "compare_to": "Compare to",
    "baseline": "Baseline",
    "previous_version": "Previous Version",
    "baseline_version": "Baseline Version",
    "actions": {
      "setBaseLine": "Set Version as Baseline",
      "takeSnapshot": "Take Snapshot",
      "takingSnapshot": "Taking Snapshot"
    },
    "turn_off": {
      "cancel": "Cancel",
      "header": "Snapshots are turned off",
      "body": "Please note that Snapshots have been turned off. If you proceed, an active controller query will be performed."
    },
    "snapshot_success": "Finished taking snapshot successfully",
    "snapshot_failed": "Failed taking snapshot",
    "snapshot_trigger_type": {
      "Periodic": "Periodic Snapshot",
      "UserInitiated": "User-initiated Snapshot",
      "EventTriggered": "Event-triggered Snapshot"
    },
    "grid": {
      "name": "Name",
      "size": "Size",
      "compiled_on": "Compiled on"
    }
  },
  "open_ports": {
    "ACV_is_off_message": "Port mapping is turned off",
    "port_mapping_is_on_message": "Port mapping is an ongoing process—the data below may not include the most recent changes. Click on \"Update Open Ports\" to initiate dedicated mapping.",
    "settings_link": "Configure Queries",
    "update_button": "Update Open Ports",
    "scan_button": "Update Port State",
    "updating_message": "Updating ports… This action may take a few minutes."
  },
  "network": {
    "title": "Network",
    "network_summary": {
      "title": "Network Summary",
      "from": "From",
      "to": "To",
      "conversation_traffic_spline_chart": {
        "title": "Traffic and Conversations Over Time",
        "traffic_legend": "Traffic",
        "conversations_legend": "Conversations",
        "no_data": "No data yet"
      },
      "conversation_traffic_bar_chart": {
        "title": "Top 5 ",
        "traffic_legend": "Traffic",
        "conversations_legend": "Conversations",
        "no_data": "No data yet",
        "source": "Sources",
        "destination": "Destinations"
      },
      "protocols": {
        "title": "Protocols",
        "no_data": "No data yet"
      }
    },
    "conversations": {
      "title": "Conversations",
      "grid": {
        "ongoing": "Ongoing",
        "completed": "Completed",
        "col_defs": {
          "start_time": "Start Time",
          "end_time": "End Time",
          "duration": "Duration",
          "bytes": "Bytes",
          "packets": "Packets",
          "src_ip": "Source Address",
          "dst_ip": "Destination Address",
          "src_port": "Source Port",
          "dst_port": "Destination Port",
          "protocol": "Protocol",
          "type": "Type"
        }
      }
    },
    "packet_captures": {
      "title": "Packet Captures",
      "oldest_file": "Oldest capture file",
      "download": "Download",
      "close": "Close ongoing captures",
      "off": "Packet Capture is turned off",
      "on": "Turn on",
      "ongoing": "Ongoing",
      "completed": "Completed",
      "close_warning": "Closing ongoing captures will result in immediate termination of recording to the\n latest capture files, and make them available for download. Simultaneously, new files\n are created to contain later traffic.",
      "notifications": {
        "turn_on": {
          "success": "Successfully turned on packet capture",
          "failure": "Failed to turn on packet capture"
        },
        "close": {
          "success": "Ongoing packet captures were closed successfully",
          "failure": "Ongoing packet captures failed to close"
        }
      },
      "column_defs": {
        "start_time": "Start Time",
        "end_time": "End Time",
        "type": "Status",
        "source": "Sensor",
        "name": "File Name",
        "size": "File Size"
      }
    }
  },
  "network_map": {
    "title": "Network Map",
    "loading": "Loading assets",
    "group_by": "Group by",
    "map_loading_failed": {
      "title": "Network map is unavailable",
      "subtitle": "If the problem persists, contact support@tenable.com"
    },
    "network_map_disabled_text": {
      "title": "Network Map not supported",
      "subtitle": "This feature is under maintenance. Please contact your CSM (global_csm@tenable.com) for assistance."
    },
    "card": {
      "no_data": "Data is not available",
      "node": {
        "type": "Type",
        "vendor": "Vendor",
        "family": "Family"
      },
      "link": {
        "traffic": "Traffic",
        "conv": "# Conv.",
        "protocols": "Protocols",
        "data_since": "Data since"
      }
    },
    "filters_options": {
      "type": "Asset Types",
      "risk": "Risk Levels",
      "purdue": "Purdue Levels",
      "vendor": "Vendors",
      "family": "Families",
      "category": "Categories"
    },
    "group_by_options": {
      "type": "Asset type",
      "purdue": "Purdue level",
      "risk": "Risk level",
      "category": "Category",
      "none": "No grouping",
      "collapse": "Collapse all groups"
    },
    "actions": {
      "baseline": {
        "title": "Set as baseline",
        "notification": {
          "success": "Network baseline was set successfully",
          "failure": "Setting a network baseline failed—please try again. If the problem persists, contact technical support."
        }
      },
      "layout": "Auto-arrange",
      "clear_filters": "Clear Filters",
      "reset_map": {
        "title": "Reset to default view",
        "description": "Resetting the map will revert current filters and grouping to default."
      }
    },
    "single_network_map": {
      "actions": {
        "goto_full_map": "Go to network map"
      }
    }
  },
  "groups": {
    "iem_title": "Global Groups",
    "title": "Groups",
    "remove_button": "Remove From Group",
    "overview": "Overview",
    "tabs": {
      "members": "Members",
      "used_in": "Used in Policies"
    },
    "usage_info": {
      "policies": "{{ count }} Policies",
      "zones": "{{ count }} Zones",
      "providers": "{{ count }} Authentication servers",
      "queries": "{{ count }} Queries",
      "system_log": "System Log",
      "restrictions": "Active queries restrictions",
      "users": "{{ count }} Users",
      "email_groups": "{{ count }} Email groups",
      "user_groups": "{{ count }} User groups",
      "em_groups": "{{ count }} EM Site-Access User Groups"
    },
    "asset_groups": {
      "steps": {
        "type": "Group Type",
        "definition": "Group Definition"
      },
      "predefined_groups": "System Defined",
      "user_defined_groups": "User Defined",
      "title": "Asset Groups & Tags",
      "create_group": "Create Asset Group",
      "edit_group": "Edit Asset Group",
      "duplicate_group": "Duplicate Asset Group",
      "form": {
        "notifications": {
          "create": {
            "success": "Asset Group created successfully",
            "failure": "Failed to create Asset Group"
          },
          "edit": {
            "success": "Asset Group updated successfully",
            "failure": "Failed to updated Asset Group"
          },
          "delete": {
            "success": "Asset group deleted successfully",
            "failure": "Failed to delete Asset Group"
          },
          "duplicate": {
            "success": "Asset group duplicated successfully",
            "failure": "Failed to duplicate Asset group "
          }
        },
        "group_type_form": {
          "asset_list": "Asset Selection",
          "ip_range": "IP Range",
          "ip_list": "IP List",
          "function": "Function Group",
          "static": "Static\n(Manual Selection)",
          "dynamic": "Dynamic\n(Rule Based)"
        },
        "members_form": {
          "title": "Available Assets",
          "name": "Name",
          "start_ip": "Start IP",
          "end_ip": "End IP",
          "ip_list": "IP List",
          "ip_list_sub_title": "One IP or Subnet (CIDR) per line",
          "display_tag": "Display tag on member assets",
          "message_box": {
            "static": "Static asset groups are defined by manually picking assets and adding them to the group. Once set, the group members won't change unless a user edits them.",
            "dynamic": "Dynamic asset groups are defined by rules that filter and search your asset inventory. As the ongoing asset discovery and enrichment continues, members will automatically be added to or removed from the group, keeping it up to date. Note: in larger environments, the tagging process might not be immediate, and a few minutes might pass until all assets are tagged."
          },
          "text_filters": "Add at least one filter to enable group creation.",
          "available_assets": "Available Assets",
          "no_results_dynamic": "There are currently no assets in the inventory that match the applied filter. However, you can still create the group, and assets discovered in the future and match the conditions will be automatically added to it. Also note that when using an IP filter, the group can be empty from monitored assets but still be used in policies to represent external IPs that are not part of your monitored network"
        }
      },
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
        "title_with_policy": "Unable to delete the asset group—it is currently being used by other entities.",
        "header": "Delete asset Group"
      },
      "column_defs": {
        "name": "Name",
        "type": "Type",
        "members": "Members",
        "used_in_policies": "Used in Policies",
        "used_in_zones": "Used in Zones",
        "queries": "Used in Queries",
        "display_tag": "Display Tag",
        "system": "Origin",
        "id": "Group ID"
      },
      "display_tag": {
        "info": "Note: in larger environments, the tagging process might not be immediate, and a few minutes might pass until all assets are tagged.",
        "label": {
          "enable": "Enable Tag Display",
          "disable": "Disable Tag Display"
        },
        "state": {
          "enabled": "Enabled",
          "disabled": "Disabled"
        }
      },
      "single_asset_group": {
        "display_tag": {
          "title": "Tag Display on Assets",
          "state": {
            "enabled": "Enabled",
            "disabled": "Disabled"
          }
        }
      },
      "type": {
        "static": "Static",
        "dynamic": "Dynamic"
      },
      "asset_groups": "Asset Groups"
    },
    "segment_groups": {
      "title": "Network Segments",
      "create_group": "Create Network Segment",
      "edit_group": "Edit Network Segment",
      "delete_popup": {
        "title": "Are you sure?<br>If you proceed, this network segment will be permanently deleted.",
        "title_with_policy": "Unable to delete the network segment—it is currently being used by other entities.",
        "header": "Delete Network Segment"
      },
      "grid": {
        "gid": "Group ID",
        "name": "Name",
        "vlan": "VLAN",
        "description": "Description",
        "rules": "Number of Segments",
        "policies": "Used in Policies",
        "user_defined": "User-defined network segments",
        "predefined": "Auto-generated network segments",
        "system_name": "System Name"
      },
      "help": {
        "title": "Learn More About Network Segments",
        "parts": [
          {
            "title": "What is network segmentation?",
            "summary": "Segmentation is a method of creating groups of related network assets, assisting in the logical isolation of one group of assets from another. Segmentation enables granular control of the traffic within each segment as well as the traffic that passes between segments."
          },
          {
            "title": "How is network segmentation determined?",
            "summary": "Tenable OT Security automatically assigns each asset to a default segment based on its type and IP address. You can adjust the segmentation manually to more accurately reflect your segmentation requirements."
          },
          {
            "title": "Using Network Segments in Policies",
            "summary": "Network segments can be used in policy configuration in a manner similar to asset groups. Define a policy for specific network segments, so that events will be generated for activities that are detected between those segments."
          }
        ],
        "close": "Close"
      },
      "form": {
        "notifications": {
          "create": {
            "success": "Network segment created successfully",
            "failure": "Failed to create Network segment"
          },
          "edit": {
            "success": "Network segment saved successfully",
            "failure": "Failed to save Network segment"
          },
          "delete": {
            "success": "Network segment deleted successfully",
            "failure": "Failed to delete Network segment"
          }
        }
      },
      "system_default": "System Default"
    },
    "email_groups": {
      "title": "Email Groups",
      "create_group": "Create Email Group",
      "edit_group": "Edit Email Group",
      "duplicate_group": "Duplicate Email Group",
      "predefined_groups": "Predefined email groups",
      "user_defined_groups": "User-defined email groups",
      "form": {
        "name": "Name",
        "smtp": {
          "input": "SMTP server",
          "no_smtp_servers": "SMTP server must be configured before you can add an Email Group",
          "add_smtp": "Add SMTP Server"
        },
        "emails": {
          "text": "Emails",
          "subtext": "One email per line"
        },
        "notifications": {
          "create": {
            "success": "Email Group created successfully",
            "failure": "Failed to create Email Groups"
          },
          "edit": {
            "success": "Email Group saved successfully",
            "failure": "Failed to save Email Groups"
          },
          "duplicate": {
            "success": "Email Groups duplicated successfully",
            "failure": "Failed to duplicate Email Groups"
          },
          "delete": {
            "success": "Email Groups deleted successfully",
            "failure": "Failed to delete Email Groups"
          }
        }
      },
      "tabs": {
        "members": {
          "emails_list": "Emails List"
        }
      },
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
        "title_with_policy": "Unable to delete the email group—it is currently being used by other entities.",
        "header": "Delete email Group"
      },
      "column_defs": {
        "name": "Name",
        "emails": "Emails",
        "server": "Email Server",
        "used_in": "Used in Policies"
      }
    },
    "port_groups": {
      "title": "Port Groups",
      "create_group": "Create Port Group",
      "edit_group": "Edit Port Group",
      "duplicate_group": "Duplicate Port Group",
      "name_label": "Name",
      "add_port": "Add port",
      "tcp_port": "TCP Port",
      "port_description": "Port number or a range",
      "predefined_groups": "Predefined port groups",
      "user_defined_groups": "User-defined port groups",
      "delete_popup": {
        "title": "Are you sure?<br>If you proceed, this port group will be permanently deleted.",
        "title_with_policy": "Unable to delete the port group—it is currently being used by other entities.",
        "header": "Delete Port Group"
      },
      "form": {
        "notifications": {
          "create": {
            "success": "Port Group created successfully",
            "failure": "Failed to create Port Group"
          },
          "edit": {
            "success": "Port Group updated successfully",
            "failure": "Failed to updated Port Group"
          },
          "delete": {
            "success": "Port group deleted successfully",
            "failure": "Failed to delete Port Group"
          },
          "duplicate": {
            "success": "Port group duplicated successfully",
            "failure": "Failed to duplicate Port group "
          }
        }
      },
      "group": " group",
      "column_defs": {
        "name": "Name",
        "tcp_port": "TCP Port",
        "used_in": "Used in Policies"
      }
    },
    "protocol_groups": {
      "title": "Protocol Groups",
      "create_group": "Create Protocol Group",
      "predefined_groups": "Predefined protocol groups",
      "user_defined_groups": "User-defined protocol groups",
      "form": {
        "port_label": "Port",
        "name_label": "Name",
        "protocols_label": "Protocols",
        "add_protocol": "Add Protocol",
        "create_group_title": "Create Protocol Group",
        "edit_group_title": "Edit Protocol Group",
        "duplicate_group_title": "Duplicate Protocol Group",
        "notifications": {
          "create": {
            "success": "Protocol group created successfully",
            "failure": "Failed to create Protocol group"
          },
          "edit": {
            "success": "Protocol group saved successfully",
            "failure": "Failed to save Protocol group "
          },
          "duplicate": {
            "success": "Protocol group duplicated successfully",
            "failure": "Failed to duplicate Protocol group "
          },
          "delete": {
            "success": "Protocol group deleted successfully",
            "failure": "Failed to delete Protocol group "
          }
        }
      },
      "edit_group": "Edit Protocol Group",
      "duplicate_group": "Duplicate Protocol Group",
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
        "title_with_policy": "Unable to delete the protocol group—it is currently being used by other entities.",
        "header": "Delete Protocol Group"
      },
      "column_defs": {
        "name": "Name",
        "protocols": "Protocols",
        "used_in": "Used in Policies"
      }
    },
    "rule_groups": {
      "title": "Rule Groups",
      "grid": {
        "gid": "Group ID",
        "name": "Name",
        "rules": "Number of Rules",
        "policies": "Used in Policies",
        "user_defined": "User-defined rule groups",
        "predefined": "Predefined rule groups"
      },
      "rules_grid": {
        "id": "SID",
        "msg": "Message",
        "protocol": "Protocol",
        "category": "Category"
      },
      "create_group": "Create Rule Group",
      "edit_group": "Edit Rule Group",
      "duplicate_group": "Duplicate Rule Group",
      "form": {
        "name": "Name",
        "rules": "Available Rules",
        "notifications": {
          "create": {
            "success": "Rule group created successfully",
            "failure": "Failed to create rule group"
          },
          "edit": {
            "success": "Rule group edited successfully",
            "failure": "Failed to update rule group"
          },
          "duplicate": {
            "success": "Rule group duplicated successfully",
            "failure": "Failed to duplicate rule group"
          },
          "delete": {
            "success": "Rule group deleted successfully",
            "failure": "Failed to delete rule group"
          }
        }
      },
      "predefined_groups": "Predefined rule groups",
      "user_defined_groups": "User-defined rule groups",
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
        "title_with_policy": "Unable to delete the rule group—it is currently being used by other entities.",
        "header": "Delete Rule Group",
        "messages": {
          "success": "Rule group deleted successfully",
          "failure": "Failed to delete rule group"
        }
      },
      "single_page": {
        "title": "Rule Group",
        "members_page": "Members",
        "policies_page": "Used in policies"
      }
    },
    "schedule_groups": {
      "title": "Schedule Groups",
      "create_group": "Create Schedule Group",
      "edit_group": "Edit Schedule Group",
      "duplicate_group": "Duplicate Schedule Group",
      "predefined_groups": "Predefined schedule groups",
      "user_defined_groups": "User-defined schedule groups",
      "steps": {
        "type": "Group Type",
        "definition": "Group Definition"
      },
      "tabs": {
        "members": {
          "covers": "Covers"
        }
      },
      "types": {
        "recurring": "Recurring",
        "once": "Time Range"
      },
      "form": {
        "name": "Name",
        "repeats": "Repeats",
        "start_time": "Start time",
        "start_date": "Start Date",
        "end_time": "End time",
        "add_condition": "Add Condition",
        "notifications": {
          "create": {
            "success": "Schedule Group created successfully",
            "failure": "Failed to create Schedule Groups"
          },
          "edit": {
            "success": "Schedule Group saved successfully",
            "failure": "Failed to save Schedule Groups"
          },
          "duplicate": {
            "success": " Schedule Groups duplicated successfully",
            "failure": "Failed to duplicate Schedule Groups"
          },
          "delete": {
            "success": " Schedule Groups deleted successfully",
            "failure": "Failed to delete Schedule Groups"
          }
        }
      },
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
        "title_with_policy": "Unable to delete the schedule group, it is currently being used by other entities.",
        "header": "Delete schedule Group"
      },
      "column_defs": {
        "name": "Name",
        "type": "Type",
        "covers": "Covers",
        "used_in": "Used in Policies"
      }
    },
    "tag_groups": {
      "title": "Controller Tag Groups",
      "create_group": "Create Controller Tag Group",
      "edit_group": "Edit Controller Tag Group",
      "duplicate_group": "Duplicate Controller Tag Group",
      "predefined_groups": "Predefined Controller Tag Groups",
      "user_defined_groups": "User-defined Controller Tag Groups",
      "delete_popup": {
        "title": "Are you sure? <br>If you proceed, this group will be permanently deleted",
        "title_with_policy": "Unable to delete the Controller Tag group—it is currently being used by other entities.",
        "header": "Delete Controller Tag Group"
      },
      "form": {
        "steps": {
          "type": "Group Type",
          "asset": "Select Controller",
          "members": "Group Members"
        },
        "group_type_form": {
          "asset_list": "Asset Selection",
          "ip_range": "IP Range",
          "ip_list": "IP List"
        },
        "members_form": {
          "title": "Controllers",
          "name": "Name",
          "start_ip": "Start IP",
          "end_ip": "End IP",
          "ip_list": "IP List",
          "ip_list_sub_title": "One IP or Subnet (CIDR) per line"
        },
        "tags_form": {
          "title": "Tags",
          "name": "Name",
          "start_ip": "Start IP",
          "end_ip": "End IP",
          "ip_list": "IP List",
          "ip_list_sub_title": "One IP or Subnet (CIDR) per line"
        },
        "notifications": {
          "create": {
            "success": "Controller Tag Group created successfully",
            "failure": "Failed to create Controller Tag Groups"
          },
          "edit": {
            "success": "Controller Tag Group saved successfully",
            "failure": "Failed to save Controller Tag Groups"
          },
          "duplicate": {
            "success": "Controller Tag Groups duplicated successfully",
            "failure": "Failed to duplicate Controller Tag Groups"
          },
          "delete": {
            "success": "Controller Tag Groups deleted successfully",
            "failure": "Failed to delete Controller Tag Groups"
          }
        }
      },
      "column_defs": {
        "name": "Name",
        "type": "Type",
        "controller": "Controller",
        "tags": "Tags",
        "used_in": "Used in Policies"
      }
    }
  },
  "icps": {
    "title": "ICPs",
    "toggle_title": "Auto-approve ICP pairing requests",
    "nag": {
      "requests": {
        "text": "ICP pairing request is pending approval",
        "link_text": "View Requests"
      }
    },
    "actions": {
      "approve": {
        "failure": "Failed to approve ICP"
      },
      "delete": {
        "failure": "Failed to delete ICP",
        "pending_approval": {
          "header": "Delete ICP Pairing Request",
          "text": "Are you sure?",
          "success": "ICP pairing request was deleted"
        },
        "disconnected": {
          "header": "Delete ICP Connection",
          "text": "Are you sure?",
          "success": "Connection with {{icp_name}} was deleted successfully"
        },
        "connected": {
          "header": "Delete ICP Connection",
          "text": "Are you sure?<br>If you proceed, the connection to the ICP will be terminated.",
          "success": "Connection with {{icp_name}} was deleted successfully"
        }
      }
    },
    "manage_updates": {
      "title": "Manage Data Updates",
      "steps": {
        "title": "Manage Data Updates - {{name}}",
        "title_other": "Manage Data Updates ({{count}})",
        "method": "Update Method",
        "update": "Update"
      },
      "update_types": {
        "online": "Online Cloud Update",
        "offline": "Upload File",
        "scheduled": "Recurring Updates Schedule"
      },
      "feed_types": {
        "nessus": "Nessus plugin set",
        "suricata": "IDS Engine Ruleset",
        "dfe": "Dynamic Fingerprinting Engine (DFE)"
      },
      "scheduled": {
        "title": "Recurring Update Schedule",
        "enable": "Enable Recurring Update",
        "note": "Updates will be performed according to the timezone of the ICP. The schedule set here will override any existing schedules."
      },
      "offline": {
        "title": "Manual File Upload",
        "download": {
          "dfe": "Download the latest DFE file",
          "nessus": "Download the latest Nessus file",
          "suricata": "Download the latest IDS file",
          "internet_connection": "(Requires internet connection)"
        }
      },
      "online": {
        "title": "Online Cloud Update"
      },
      "notifications": {
        "success": "Version updated successfully."
      }
    },
    "update": {
      "action_menu_button": "Update ICP Version",
      "title": "Update ICP version | {{name}}",
      "title_other": "Update ICPs ({{count}})",
      "sub_title": {
        "os_only": "Available: OS Version",
        "os_and_app": "Available: App Version {{version}}"
      },
      "warning": "You are about to start an update of {{name}}. This process might take a while. During this time, the ICP will not be available.",
      "warning_other": "You are about to start an update of {{count}} ICPs. This process might take a while. During this time, the ICPs will not be available.",
      "app_and_os": "Update ICP Application to version {{version}} Including OS (recommended)",
      "os_only": "Update OS only",
      "check_for_updates": "Check for updates",
      "updates_available": "ICPs update check completed. Updates are available.",
      "update_success_app_and_os": "{{count}} ICPs were updated successfully.",
      "update_success_os": "The OS of {{count}} out of {{count}} ICPs were updated successfully.",
      "icps_up_to_date": "ICPs update check completed. All ICPs are up to date with the latest available version.",
      "em_first": "The EM must be updated first before updating any connected ICPs.",
      "app_and_os_no_recommended": "Update ICP Application to version {{version}} (only after OS update)"
    },
    "grid": {
      "site": "Name",
      "ip": "IP/Host",
      "last_sync": "Last Data Sync",
      "version": "Version",
      "license_type": "License Type",
      "license_expires": "License Expires",
      "licensed_assets": "Licensed Assets",
      "computer_id": "Computer ID",
      "sensors_info_title": "Sensors Info",
      "sensors_info_text": "{{online}} online (out of {{total}})",
      "license_usage_title": "License Usage",
      "license_usage_text": "{{current}}/{{total}} ({{percent}}%)",
      "unlimited": "Unlimited assets",
      "nessus_version": "Nessus Plugin Set",
      "ids_version": "IDS Engine Ruleset",
      "dfe_version": "DFE Version",
      "scheduled_by_em": "Schedule by EM",
      "scheduled_locally": "Schedule locally",
      "cpu_usage": "CPU Usage",
      "memory_usage": "Memory Usage",
      "status_secondary_text": "(since {{status_datetime}})",
      "status": {
        "title": "Status",
        "connected": "Connected",
        "disconnected": "Disconnected",
        "pending_approval": "Pending Approval",
        "preparing_connection": "Pairing in progress",
        "waiting_for_connection": "Waiting For Connection",
        "updating": "Update in progress"
      },
      "license_status": {
        "title": "License Status",
        "active": "Active",
        "uninitialized": "Uninitialized",
        "waiting_for_activation": "Waiting For Activation",
        "expired": "Expired",
        "asset_count_exceeded": "Asset Count Exceeded",
        "unknown_status": "Unknown"
      },
      "updates_available": "Updates available",
      "updates_not_available": "Updates not available"
    },
    "return_to_em": "Return to EM"
  },
  "mini_layout_pages": {
    "available_ip": "After restart, Tenable OT Security will be available at the following addresses",
    "enable": {
      "title": "System is Disabled",
      "buttonText": "Enable"
    },
    "shutdown": {
      "title": "System is shutting down",
      "additionalText": "To turn on the system, press the POWER button on the Tenable OT Security appliance"
    },
    "reboot": {
      "title": "System is restarting",
      "additionalText": "This will take a few minutes."
    },
    "license_expired": {
      "title": "License Expired",
      "additionalText": "Your license has expired or reached its assets limit. Contact your system administrator."
    },
    "factory_reset": {
      "title": "Factory Reset",
      "additionalText": "The system is performing a factory reset."
    }
  },
  "queries": {
    "title": "Active Queries",
    "credentials": {
      "title": "Credentials",
      "credentials_type_step_title": "Credentials Type",
      "credentials_details_step_title": "Credentials Details",
      "column_defs": {
        "name": "Name",
        "type": "Type",
        "description": "Description",
        "last_modified_by": "Last modified by",
        "last_modified_on": "Last modified on",
        "category": "Category"
      },
      "credentials_category": {
        "ot": "OT Credentials",
        "it": "IT Credentials"
      },
      "ot_credential_types": {
        "abb_rti_500": "ABB RTU 500",
        "bachman": "Bachmann",
        "concept": "Concept",
        "sel": "Sel",
        "sicam_http": "SICAM A8000 HTTP",
        "sicam_snmp": "SICAM A8000 SNMP",
        "siprotec_5": "SIPROTEC 5"
      },
      "it_credential_types": {
        "snmp_v1_v2": "SNMP v1+v2",
        "snmp_v3": "SNMP v3",
        "wmi": "WMI",
        "ssh": "SSH",
        "moxa": "Moxa",
        "fox_tls": "FOX TLS"
      },
      "add_credentials": {
        "title": "Add Credentials",
        "fields": {
          "name": "Name",
          "description": "Description",
          "username": "Username",
          "password": "Password",
          "test_ip_address": "Test IP Address",
          "community_strings": "Community Strings",
          "community_strings_hint": "Public / Private",
          "security_level": "Security Level",
          "authentication_password": "Authentication Password",
          "authentication_protocol": "Authentication Protocol",
          "private_password": "Private Password",
          "private_protocol": "Private Protocol",
          "security_engine_id": "Security Engine ID",
          "context_engine_id": "Context Engine ID",
          "context_name": "Context Name",
          "role_id": "Role ID",
          "role_id_placeholder": "Only Whole Numbers (0, 1, 2, 3..)"
        },
        "security_level_options": {
          "no_auth_no_priv": "NoAuthNoPriv",
          "auth_no_priv": "AuthNoPriv",
          "auth_priv": "AuthPriv"
        },
        "authentication_protocol_options": {
          "md5": "MD5",
          "sha": "SHA",
          "Sha224": "SHA224",
          "Sha256": "SHA256",
          "Sha384": "SHA384",
          "Sha512": "SHA512"
        },
        "private_protocol_options": {
          "des": "DES",
          "aes": "AES",
          "Aes192": "AES192",
          "Aes256": "AES256",
          "Aes192C": "AES192C",
          "Aes256C": "AES256C"
        },
        "notifications": {
          "success": "Credentials added successfully",
          "failure": "Failed to add credentials"
        }
      },
      "edit_credentials": {
        "title": "Edit Credentials",
        "notifications": {
          "success": "Credentials changes saved successfully",
          "failure": "Failed to save changes"
        }
      },
      "delete_credentials": {
        "title": "Delete Credentials",
        "text": "Are you sure you want to delete these credentials?<br>You will not be able to undo this action.",
        "notifications": {
          "success": "Credentials deleted successfully",
          "failure": "Unable to delete credentials"
        }
      },
      "test_credentials": {
        "title": "Test Credentials",
        "sensors": {
          "title": "Duplicate (Sensor)",
          "description": "This is required only for IPs in duplicated networks",
          "localhost": "Local"
        },
        "notifications": {
          "success": "Credentials test was successful",
          "role_id_success": "Credentials test passed.\nPlease note: Role ID is not validated during this test, as it is only used during the Snapshot action.",
          "failure": "Credentials test has failed"
        }
      }
    },
    "nessus_scans": {
      "title": "Nessus Scans",
      "create_scan_title": "Create Nessus Plugin List Scan",
      "edit_scan_title": "Edit Nessus Plugin List Scan",
      "create_text": "Create Scan",
      "scan_unavailable": "Failed to prepare scan. Please try again in a few minutes.",
      "no_results": {
        "title": "No Available Scans",
        "button": "Create Scan"
      },
      "column_defs": {
        "name": "Name",
        "status": "Status",
        "last_run": "Last run",
        "last_modified": "Last modified",
        "credentials": "Credentials",
        "credentials_options": {
          "none": "No Credentials",
          "all": "All Available Credentials"
        }
      },
      "ip_ranges": {
        "title": "IP Ranges",
        "message": "Nessus plugin list scan runs a user-defined list of plugins only on network assets within the specified IP ranges (CIDRs).",
        "form": {
          "name": "Name",
          "ip_ranges": "IP ranges",
          "thoroughTests": "Perform Thorough Tests",
          "reportVerbosity": "High Verbosity Processing",
          "networkReceiveTimeout": "Network Timeout (in seconds)",
          "maxChecksPerHost": "Max Simultaneous Checks Per Host",
          "maxHostsPerScan": "Max Simultaneous Hosts Per Scan",
          "origins": {
            "title": "Relevant Sensors",
            "subtitle": "This is required only for CIDRs that intersect with duplicated networks"
          },
          "tooltips": {
            "thoroughTests": "Causes various plugins to work harder. For example, when looking through SMB file shares, a plugin can analyze 3 directory levels deep instead of one. This could cause much more network traffic and analysis in some cases. By being more thorough, the scan is more intrusive and is more likely to disrupt the network or impact the scan speed, while potentially providing better audit results.",
            "reportVerbosity": "High verbosity provides more details about the plugin activity in the output of the scan results. When this option is selected, the output includes the informational plugins 56310, 64582 and 58651.",
            "networkReceiveTimeout": "Specifies the time that Nessus waits for a response from a host unless otherwise specified within a plugin. If you are scanning over a slow connection, you may want to set this to a higher number of seconds.",
            "maxChecksPerHost": "Specifies the maximum number of checks a Nessus scanner will perform against a single host at one time.",
            "maxHostsPerScan": "Specifies the maximum number of hosts that a Nessus scanner will scan at the same time."
          },
          "credentials": {
            "title": "Credentials",
            "note": "Note: if many credentials are defined in this site, the first option isn't recommended, as it might prolong the scan or cause other issues",
            "select_label": "Select credentials",
            "select_note": "These are the available credentials. To define more, go to the Credentials tab in this page"
          }
        }
      },
      "plugins": {
        "title": "Plugins",
        "table": {
          "title": "Available Plugins",
          "column_defs": {
            "plugin_name": "Plugin Name",
            "plugin_family_name": "Plugin Family Name",
            "plugin_id": "Plugin ID"
          }
        }
      },
      "notifications": {
        "create_scan": {
          "success": "Nessus scan created successfully",
          "failure": "Failed to create Nessus scan—for more information, please refer to the system log."
        },
        "edit_scan": {
          "success": "Nessus scan was saved successfully",
          "failure": "Failed to save Nessus scan—for more information, please refer to the system log."
        },
        "deleted_scan": {
          "success": "Nessus scan {{scan}} deleted successfully",
          "failure": "Nessus scan {{scan}} delete operation failed."
        },
        "completed_scan": {
          "success": "Nessus scan {{scan}} completed successfully",
          "failure": "Nessus scan {{scan}} run now operation failed—for more information, please refer to the system log."
        },
        "resumed_scan": {
          "success": "Nessus scan {{scan}} resumed successfully",
          "failure": "Nessus scan {{scan}} resume operation failed—for more information, please refer to the system log."
        }
      },
      "nessus_not_ready": {
        "title": "Nessus is loading",
        "text": "It may take up to 30 minutes to display Nessus plugin scans.\nIf the problem persists, contact support@tenable.com."
      }
    },
    "active_queries": {
      "title": "Active Queries Management",
      "global_config": {
        "enabled": {
          "tooltips": {
            "on": "Active Queries engine is enabled and running.",
            "off": "Active Queries engine is disabled. To enable it and increase your visibility, contact your system administrator.",
            "off_admin": "Active Queries engine is disabled. To enable it and increase your visibility, turn on the main switch on the Queries Management page. Also make sure a black-out period is not applied."
          }
        }
      },
      "otd_scans": {
        "title": "OTD Scans",
        "actions": {
          "download": "Download OTD scan file",
          "download_bulk": "Download OTD scan files",
          "create_otd_scan": "Create OTD Scan"
        },
        "grid": {
          "columns": {
            "name": "Name",
            "description": "Description",
            "credentials": "Credentials",
            "monitored_networks": "Monitored Networks",
            "schedule": "Schedule"
          }
        },
        "upload_card": {
          "title": "Upload OTD Scan Results (from portable agents)",
          "description": "Assets and Findings will be added or updated according to the scan results.",
          "upload_success": "Scan file uploaded successfully",
          "overlapping_ips_warning": "Overlapping IPs warning: if you have duplicated networks in your environment, make sure they are properly configured via Settings > Environment Configuration > Network Definitions. Otherwise, file uploads might result with unwanted asset merge."
        },
        "form": {
          "create_title": "Create OTD Scan",
          "edit_title": "Edit OTD Scan",
          "name": "Name",
          "description": "Description",
          "credentials": "Credentials",
          "monitored_networks": "Monitored Networks",
          "network_areas": "Network Areas",
          "enable_schedule": "Enable Schedule",
          "success": "OTD scan created successfully",
          "edit_success": "OTD scan updated successfully",
          "new_monitored_network_status": "Monitoring status of newly added subnets",
          "new_monitored_network_enabled": "Enabled",
          "new_monitored_network_disabled": "Disabled"
        },
        "messages": {
          "delete_success": "OTD scan deleted successfully",
          "bulk_delete_success": "OTD scans deleted successfully",
          "download_success": "OTD scan file downloaded successfully",
          "bulk_download_success": "OTD scan files downloaded successfully"
        },
        "delete_otd_scan": {
          "title": "Delete OTD Scan",
          "bulk_title": "Bulk delete OTD Scans",
          "text": "Are you sure?<br>If you proceed, this OTD scan will be permanently deleted.",
          "bulk_text": "Are you sure?<br>If you proceed, these OTD scan will be permanently deleted.",
          "notifications": {
            "success": "OTD scan deleted successfully",
            "failure": "Unable to delete OTD scan"
          }
        }
      },
      "tabs": {
        "discovery": "Discovery",
        "ot": "OT Queries",
        "it": "IT Queries",
        "initial_asset_enrichment": "Initial Enrichment",
        "nessus": "Nessus Scans",
        "general": "General",
        "otd_scans": "Agent Scans"
      },
      "active_query_card": {
        "badge": "Fundamental",
        "variations": "Custom Variations",
        "manual_run_toggle": {
          "title": "Enable Manual Run",
          "snmp_title": "SNMP Ports State",
          "subnets": "Auto-discover subnets",
          "fetch_neighbors_title": "Fetch Neighbors",
          "tooltips": {
            "bp": "Controls whether Backplane scan is allowed to be executed from the resync button in single asset page.",
            "arp": "Controls whether ARP query is allowed to be executed from the resync button in single asset page.",
            "snapshot": "Controls whether Snapshot is allowed to be executed from the single asset page.",
            "dns": "Controls whether DNS Lookup is allowed to be executed from the resync button in single asset page.",
            "details": "Controls whether Details query is allowed to be executed from the resync button in single asset page.",
            "wmi": "Controls whether WMI details query is allowed to be executed from the resync button in single asset page.",
            "wmi_usb": "Controls whether WMI USB state query is allowed to be executed from the resync button in single asset page.",
            "identification": "Controls whether Identification query is allowed to be executed from the resync button in single asset page.",
            "nessus": "Controls whether Nessus Basic Scan is allowed to be executed from the single asset page.",
            "netBios": "Controls whether NetBIOS query is allowed to be executed from the resync button in single asset page.",
            "snmp": "Controls whether SNMP query is allowed to be executed from the resync button in single asset page.",
            "snmp_port_state": "This is an addition to the SNMP query, which will leverage saved SNMP credentials to obtain network port status information from the device",
            "state": "Controls whether State query is allowed to be executed from the resync button in single asset page.",
            "ping": "Controls whether a ping query is allowed to be executed from the resync button in single asset page.",
            "fetch_neighbors": "Collect MAC and IP information of adjacent networked devices via SNMP. Discovered assets will be added to the inventory, if your network definitions allow it."
          }
        },
        "policy_run_toggle": {
          "title": "Enable Policy-Triggered Run",
          "tooltip": "Controls whether Snapshot is allowed for policies that have the 'Take snapshot after policy hit' option selected."
        },
        "queries_names": {
          "arp": "ARP Query",
          "bp": "Backplane Mapping",
          "details": "Details Query",
          "dns": "DNS Lookup",
          "identification": "Identification Query",
          "netBios": "NetBIOS Query",
          "nessus": "Nessus Basic Scan",
          "ping": "Ping Query",
          "port_scan": "Port Mapping",
          "port_scan_asset_enrichment": "Open Ports Check",
          "snapshot": "Code Snapshots",
          "snmp": "SNMP Query",
          "wmi": "WMI Details Query",
          "wmi_usb": "WMI USB State",
          "state": "State Query",
          "active_asset_tracking": "Active Asset Tracking",
          "initial_asset_enrichment": "Initial Enrichment Queries",
          "ics_discovery": "Controller Discovery",
          "asset_discovery": "Asset Discovery",
          "unknown": "Unknown",
          "subnets_discovery": "Subnets Auto-Discovery"
        }
      },
      "grid": {
        "columns": {
          "system_default": "System Default",
          "query_id": "Query ID",
          "name": "Name",
          "status": "Status",
          "assets": "Assets",
          "repeats": "Recurrence",
          "next_execution": "Next execution",
          "last_execution": "Last execution",
          "last_modified_by": "Last modified by",
          "last_run_by": "Last run by",
          "last_modified_on": "Last modified on",
          "created_by": "Created by",
          "concurrent_discovery_workers": "Number of Assets to Poll Simultaneously",
          "pause_bewtween_probes": "Time Between Discovery Queries",
          "ip_ranges": "IP Ranges",
          "interval": "Mapping Rate",
          "portScanRange": "Mapping Range"
        },
        "status_options": {
          "created": "Created",
          "preparing": "Preparing",
          "running": "Running",
          "completed": "Completed",
          "failed": "Failed",
          "unknown": "Unknown"
        },
        "category_options": {
          "ot": "OT",
          "it": "IT",
          "discovery": "Discovery"
        },
        "trigger_options": {
          "periodic": "Periodic",
          "manual": "Manual",
          "system": "System"
        },
        "operation_options": {
          "unknown": "Unknown",
          "backplane_mapping_manual": "Backplane mapping—Resync Button",
          "code_snapshots_manual": "Code Snapshots—Take Snapshot Button",
          "details_query_manual": "Details query—Resync Button",
          "ot_identification_manual": "OT Identification",
          "state_changes_manual": "State changes-Resync Button",
          "arp_query_manual": "ARP query-Resync Button",
          "dns_query_manual": "DNS Lookup-Resync Button",
          "netbios_query_manual": "NetBIOS query-Resync Button",
          "port_mapping_manual": "Port Mapping-Update Open Ports Button",
          "snmp_query_manual": "SNMP query-Resync Button",
          "wmi_details_query_manual": "WMI details query-Resync Button",
          "nessus_basic_scan_manual": "Nessus Basic Scan-Nessus scan button",
          "backplane_mapping_periodic": "Backplane mapping",
          "code_snapshots_periodic": "Code Snapshots",
          "details_query_periodic": "Details query",
          "state_changes_periodic": "State changes",
          "active_asset_tracking_periodic": "Active Asset Tracking",
          "netbios_query_periodic": "NetBIOS query",
          "snmp_query_periodic": "SNMP query",
          "wmi_details_query_periodic": "WMI details query",
          "wmi_usb_state_periodic": "WMI USB state",
          "asset_discovery_periodic": "Asset Discovery",
          "controller_discovery_periodic": "Controller Discovery",
          "identification_query_periodic": "Identification Query",
          "backplane_mapping_system": "Backplane mapping—Asset enrichment",
          "code_snapshots_policy": "Code Snapshots",
          "details_query_system": "Details query—Asset enrichment",
          "ot_identification_system": "OT Identification—Asset enrichment",
          "state_changes_system": "State changes",
          "arp_query_system": "ARP query-Asset enrichment",
          "dns_query_system": "DNS query-Asset enrichment",
          "arp_query_periodic": "ARP query",
          "dns_query_periodic": "DNS query",
          "netbios_query_system": "NetBIOS query—Asset enrichment",
          "port_mapping_continuous": "Port Mapping - Continuous",
          "port_mapping_system": "Port Mapping—Asset enrichment",
          "snmp_query_system": "SNMP query—Asset enrichment"
        },
        "descriptions": {
          "backplane_mapping_periodic": "Backplane Query discovers modules and their specifications within a backplane. The query allows for quick identification of the entire backplane configuration.",
          "code_snapshots_periodic": "A snapshot represents the current program deployed on a controller. By periodically taking snapshots, Tenable OT Security can detect changes that were made to the controller’s program.",
          "details_query_periodic": "Controller details querying allows us to retrieve the controller’s hardware and firmware details. Password-protected controllers may require a password to be configured in Tenable OT before using this query.",
          "state_changes_periodic": "Controller state querying allows us to detect the current PLC status (Running, Stopped, Fault, No config, Test). Password-protected controllers may require a password to be configured in Tenable OT before using this query.",
          "active_asset_tracking_periodic": "Active Asset Tracking pings assets in the inventory periodically to validate their availability.",
          "netbios_query_periodic": "NetBIOS queries use a unicast packet sent to classify and detect Windows machines in the network.",
          "snmp_query_periodic": "SNMP queries provide useful information from SNMP-enabled devices, such as printers, cameras, or network devices.",
          "wmi_details_query_periodic": "WMI queries enable collection of a broad range of system and installed software details for Windows machines.",
          "dns_details_query_periodic": "This query will enrich the asset name by querying the DNS server. If a DNS record exists for this asset, it will replace the system’s automatically generated asset name with the DNS FQDN associated with this IP.",
          "arp_details_query_periodic": "ARP queries detect MAC and IP connected devices in the same broadcast domain.",
          "wmi_usb_state_periodic": "USB queries enable the detection of removable media or USB device details from Windows machines.",
          "asset_discovery_periodic": "Asset Discovery assists in fast identification and monitoring of the entire inventory. Only assets within the Monitored Networks ranges will be pinged.",
          "controller_discovery_periodic": "Controller Discovery is a broadcast scan that searches for new controllers and assists in classifying those devices.",
          "arp": "ARP queries detect MAC and IP connected devices in the same broadcast domain.",
          "bp": "Backplane Query discovers modules and their specifications within a backplane. The query allows for quick identification of the entire backplane configuration.",
          "details": "Controller details querying allows us to retrieve the controller's hardware and firmware details. Password protected controllers may require a password to be configured in Tenable OT before using this query.",
          "dns": "DNS Lookup enriches the asset name or FQDN by querying the DNS server. If a DNS name record exists for an asset, it will replace the system-given name.",
          "identification": "Identification Query is a set of unicast queries that will fingerprint the asset based on network protocols, services, and banners.",
          "netBios": "NetBIOS queries use a unicast packet sent to classify and detect Windows machines in the network.",
          "nessus": "Performs a full system vulnerability scan suitable for most devices. Tenable OT Security will exclude or remove sensitive systems like controllers, PLCs, and unknown devices from any initiated scans.",
          "port_scan": "Port mapping is a process of finding open ports on monitored assets. It can be performed manually from the single asset page, or as a continuous process that runs through all the assets. For each of the two options, the behavior and speed of the scan can be configured.",
          "port_scan_asset_enrichment": "This is a quick scan that covers a minimal set of the most frequently used ports.",
          "snapshot": "A snapshot represents the current program deployed on a controller.",
          "controller_discovery": "Controller Discovery is a broadcast scan that searches for new controllers and assists in classifying those devices.",
          "asset_discovery": "Asset Discovery assists in fast identification and monitoring of the entire inventory. Only assets within the Monitored Networks ranges will be pinged.",
          "initial_asset_enrichment": "Asset Enrichment is an automatic process that will perform device identification queries to newly discovered assets. When an asset is discovered passively or actively, we will attempt to fingerprint it and gather more device details.\n\nAsset Enrichment can use a variety of active device queries to elicit information from network-connected assets. With the switches below, you can determine which ones are used in your environment.",
          "snmp": "SNMP queries provide useful information from SNMP-enabled devices, such as printers, cameras, or network devices. \n\nNote: The default SNMP query variation below, created by System, cannot be adjusted to fetch this additional data. In order to take advantage of the physical ports or neighbors functionality, a new variation must be created with those settings enabled.",
          "wmi": "WMI queries enable collection of a broad range of system and installed software details for Windows machines.",
          "wmi_usb": "USB queries enable the detection of removable media or USB device details from Windows machines.",
          "state": "Controller state querying allows us to detect the current PLC status (Running, Stopped, Fault, no config, Test). Password protected controllers may require a password to be configured in Tenable OT before using this query.",
          "active_asset_tracking": "Active Asset Tracking pings assets in the inventory periodically to validate their availability.",
          "ping": "An ICMP ping to verify a system is reachable and responsive.",
          "subnets": "Identifies subnets automatically by querying network devices through SNMP."
        }
      },
      "restrictions": {
        "title": "Restrictions",
        "ot_agents_message": "<b>Note:</b> these restrictions are not applied on queries performed via agents.",
        "form": {
          "add": "Add Restrictions",
          "edit": "Edit Restrictions",
          "view": "View Restrictions",
          "fields": {
            "blocked_assets": "Blocked assets",
            "restricted_clients": "Restricted clients",
            "blackout_period": "Black-out period"
          }
        },
        "notifications": {
          "success": "Restrictions saved successfully",
          "failure": "Unable to save restrictions",
          "message": {
            "prefix": "Applied active Query Restrictions:",
            "client_type": "<b>{{count}} client type</b>",
            "client_type_other": "<b>{{count}} client types</b>",
            "asset_group": "<b>{{count}} asset group</b>",
            "asset_group_other": "<b>{{count}} asset groups</b>"
          }
        },
        "blackout_period_popup": {
          "header": "End Black-out",
          "text": "Are you sure?<br>A black-out period is in effect—ending the black-out period will enable all paused active queries.",
          "submit_title": "End Black-out"
        }
      },
      "global_toggle": {
        "title": "Active Queries Engine Enabled",
        "notifications": {
          "warning": "Ongoing queries will not stop until finished"
        }
      },
      "force_run_now_dialog": {
        "title": "Confirmation Required",
        "text": "This action does not conform with the queries settings set by the system administrator—a system event will be logged."
      },
      "single_query": {
        "state": {
          "on": "On",
          "off": "Off",
          "paused": "Paused"
        }
      },
      "create_query": {
        "title": "Create Query Variation",
        "wizard_steps": {
          "query_definition_step": {
            "title": "Query definition",
            "fields": {
              "name": "Name",
              "description": "Description",
              "assets": "Assets",
              "ip_ranges": "IP Ranges",
              "repeats_every": "Repeats Every",
              "query_state_periodic": "Recurring Run",
              "query_state_port_mapping": "Query State",
              "mapping_range": "Mapping range",
              "mapping_rate": "Mapping rate",
              "number_of_assets": "Number of assets to poll simultaneously",
              "time_between": "Time between discovery queries",
              "estimated_time": "Estimated time for discovery"
            },
            "placeholders": {
              "assets": "Any Asset",
              "ip_ranges": "One CIDR per line"
            },
            "help_tips": {
              "assets": "Only eligible assets will be included in the query",
              "ip_ranges_no_feature_flag": "Only assets within the monitored network range will be found (see under Local Settings > Environment Settings > Network Definitions)",
              "ip_ranges": "Only Assets within the enabled subnets in the monitored network will be found (see under Settings > Environment Settings > monitored Network)",
              "estimated_time": "Enter IP range to calculate"
            },
            "mapping_range_options": {
              "full_sweep": "All Ports (Slower mapping)",
              "basic": "Common Ports (Recommended)",
              "lean": "Minimal Port Mapping (Enrichment ports—faster mapping)"
            },
            "mapping_rate_options": {
              "OnePort": "1 port mapped per second",
              "TwoPorts": "2 ports mapped per second",
              "FivePorts": "5 ports ports mapped per second",
              "TenPorts": "10 ports mapped per second",
              "FiftyPorts": "50 ports mapped per second",
              "HundredPorts": "100 ports mapped per second",
              "FiveHundredPorts": "500 ports mapped per second",
              "ThousandPorts": "1000 ports mapped per second"
            },
            "number_of_assets_options": {
              "Ten": "10 Assets",
              "Twenty": "20 Assets",
              "Thirty": "30 Assets"
            },
            "time_between_options": {
              "OneSecond": "1 second",
              "TwoSeconds": "2 seconds",
              "ThreeSeconds": "3 seconds"
            }
          },
          "notifications": {
            "success": "Query created successfully",
            "failure": "Unable to create query"
          }
        }
      },
      "edit_query": {
        "title": "Edit Query Variation",
        "notifications": {
          "success": "Query saved successfully",
          "failure": "Unable to save changes"
        }
      },
      "duplicate_query": {
        "title": "Duplicate Query",
        "notifications": {
          "success": "Query duplicated successfully",
          "failure": "Unable to duplicate query"
        }
      },
      "disable_query": {
        "notifications": {
          "warning": "This query is completing its cycle and will not stop until completed"
        }
      },
      "delete_query": {
        "title": "Delete Query",
        "text": "Are you sure?<br>If you proceed, this query will be permanently deleted.",
        "notifications": {
          "success": "Query deleted successfully",
          "failure": "Unable to delete query"
        }
      },
      "run_now": {
        "notifications": {
          "success": "Query {{name}} has been initiated",
          "failure": "Unable to initiate the query {{name}}"
        }
      },
      "asset_enrichment_popup": {
        "title": "Enable Asset Enrichment Query",
        "text": "If you proceed, \"Open Ports Check\" and \"Identification Query\" will be enabled. If you disable these queries, it may hinder asset fingerprinting."
      },
      "snmp": {
        "query_network_interfaces": {
          "title": "Fetch SNMP Port State Details",
          "description": "Will leverage saved SNMP credentials to obtain network port status information from the device."
        }
      }
    }
  },
  "ot_agents": {
    "title": "Agents",
    "toggle_text": "Auto-approve agent pairing requests",
    "active_queries_management": "Active Queries Management",
    "restrictions_message": "<b>Note:</b> active query restrictions that are defined on the ICP level <b>do not apply for agents.</b>",
    "no_results": {
      "title": "No Agents Found",
      "description": "OT Agents allow visibility into OT assets from Windows hosts like HMIs or engineering workstations—especially when sensors can't be deployed.",
      "call_for_action": "Need help getting started?\n Contact Support or visit our documentation."
    },
    "column_defs": {
      "id": "Agent ID",
      "host_type": "Host Type",
      "ip": "IP/Host",
      "status": "Status",
      "active_query_networks": "Active Query Networks",
      "name": "Agent Name",
      "host_asset": "Host Asset",
      "scan_schedule": "Scan Schedule",
      "last_scan": "Last Scan",
      "last_scan_duration": "Last Scan Duration",
      "credentials": "Credentials",
      "reported_assets": "Reported Assets",
      "agent_version": "Agent Version",
      "scout_version": "OTD Version",
      "host_os": "Host OS",
      "last_scan_result": "Last Scan Result",
      "network_area": "Reported From"
    },
    "last_scan_result_options": {
      "completed": "Completed",
      "failed": "Failed"
    },
    "state_options": {
      "no_status": "No Status",
      "connected": "Connected",
      "pending_approval": "Pending approval",
      "pending_configuration": "Pending Configuration",
      "disconnected": "Disconnected",
      "scanning": "Scanning",
      "updating": "Updating",
      "waiting_for_connection": "Waiting For Connection",
      "manually_registered": "Manually Registered",
      "preparing_connection": "Preparing Connection"
    },
    "edit_agent": {
      "info": "The schedule set here will override any existing schedules.",
      "bulk_set_schedule_title": "Set Schedule ({{count}} Agents)",
      "title": "Configure Agent",
      "name": "Name",
      "active_query_networks": "Active Query Networks",
      "help_tip": "One CIDR per Line",
      "hint": "e.g. 10.10.10.10/18",
      "run_schedule_scan": "Run Scheduled Scan",
      "repeats_every": "Repeats Every",
      "at": "At",
      "credentials": "Credentials",
      "credentials_tip": "These are the available credentials. To define more, go to Data Collection > Active Queries > Credentials",
      "duplicate_networks_title": "Duplicate Active Query Networks",
      "duplicate_networks_label": "Scan all assigned duplicate networks",
      "duplicate_networks_message_prefix": "These CIDRS were assigned to this agent via Duplicate Networks Management: ",
      "duplicate_networks_message_suffix": "When checked, they are all scanned by this agent. To fine-tune this configuration, unselect them and add the specific desired CIDRs in the text box below",
      "notifications": {
        "success": "Changes saved successfully",
        "failure": "An error occurred—unable to save changes"
      }
    },
    "delete_agent": {
      "title": "Delete Agent",
      "text": "Are you sure?<br>If you proceed, the agent’s connection to the system will be terminated. To reconnect it in the future, you’ll need to re-pair the agent with the system.",
      "bulk_title": "Bulk Delete Agents",
      "bulk_text": "Are you sure?<br>If you proceed, the agents connection to the system will be terminated. To reconnect it in the future, you’ll need to re-pair the agents with the system.",
      "notifications": {
        "success": "Agent {{agentName}} was deleted successfully",
        "failure": "Unable to delete the agent {{agentName}}"
      }
    },
    "update_agent": {
      "title": "Update Agent",
      "up_to_date": "All agents are up to date",
      "update_successful": "Agent {{agentIp}} was updated successfully",
      "update_failed": "Unable to update the agent {{agentIp}}",
      "check_for_updates": "Check for updates",
      "enable_schedule_scan_successful": "Scheduled Scan enabled on {{ count }} agents",
      "disable_schedule_scan_successful": "Scheduled Scan disabled on {{ count }} agents",
      "update_available": "Update available",
      "auto_update": {
        "toggle_text": "Auto-updates",
        "enable": {
          "title": "Enable Auto-Updates",
          "text": "The OT Discovery engine version will be automatically updated for all the agents, when an update is available.",
          "success": "OT Discovery will be automatically updated for all agents"
        },
        "disable": {
          "title": "Disable Auto-Updates",
          "text": "Version updates will be managed manually.",
          "success": "Auto-updates disabled"
        }
      },
      "popup": {
        "single": {
          "title": "Update OTD Version",
          "text": "The OT Discovery engine for <b>{{name}}</b> will be updated to version {{version}}",
          "success": "OT Discovery updated successfully in {{name}}"
        },
        "bulk": {
          "title": "Update Agents",
          "text": "The OT Discovery engine for <b>{{count}} agents</b> will be updated to version {{version}}",
          "success": "OT Discovery updated successfully in {{count}} agents"
        }
      }
    },
    "actions": {
      "bulk_enable_schedule_scan": "Enable Scheduled Scan",
      "bulk_disable_schedule_scan": "Disable Scheduled Scan",
      "bulk_set_schedule": "Set Schedule",
      "scan_now": "Scan Now",
      "abort": "Abort Scan",
      "approve": "Approve",
      "configure": "Configure",
      "update": "Update",
      "delete": "Delete"
    },
    "notifications": {
      "scan_success": "<{{agent_name}}> agent scan completed.",
      "scan_aborted": "<{{agent_name}}> agent scan aborted.",
      "scan_update": "<{{agent_name}}> agent update completed.",
      "scan_approve": "<{{agent_name}}> agent approve completed.",
      "delete": "<{{agent_name}}> agent delete completed.",
      "bulk_schedule_scan_enabled": "Scheduled scan enabled for {{count}} agents.",
      "bulk_schedule_scan_disabled": "Scheduled scan disabled for {{count}} agents."
    },
    "generate_api_key": {
      "action_button_title": "Generate Pairing key",
      "slider": {
        "title": "Generate Agent Pairing key",
        "step_1_name": "Generate Key",
        "step_2_name": "Get Key",
        "info": "A pairing key is a secure file that combines an API key, a certificate, and the IP address of the ICP into a single object. It’s used to quickly and securely register OT Agents to the ICP.",
        "warning": "Full Pairing key will be displayed only once and will not be accessible once you close this window! Please be sure to record it securely.",
        "expiration_period": "Expiration Period",
        "description": "Description",
        "id": "ID",
        "api_key": "Pairing Key",
        "days": "Days",
        "icp_ip": "ICP IP/Host"
      }
    },
    "upload_file": {
      "card_title": "OTD Engine Updates (for OT Agents)",
      "description": "Manually upload a newer version of the OT Discovery active query engine, that can be distributed to your OT agents.",
      "grid": {
        "version": "Version",
        "last_upload": "Last Upload"
      },
      "form": {
        "title": "Upload File",
        "input_label": "Update File",
        "submit": "Upload",
        "success": "File uploaded successfully"
      }
    }

  },
  "settings": {
    "title": "Settings",
    "system_config": {
      "title": "System Configuration",
      "compliance": {
        "title": "Compliance",
        "card_data": {
          "title": "Compliance Dashboard Preferences",
          "subtitle": "The frameworks that are selected here will be referenced in your Compliance Dashboard.",
          "fields": {
            "selected_frameworks": "Selected Frameworks"
          },
          "messages": {
            "success": "Selected Frameworks changed successfully."
          },
          "slider": {
            "title": "Edit Referenced Compliance Frameworks",
            "submit": "Save"
          }
        }
      },
      "device": {
        "title": "Device",
        "device_url": {
          "submit": "Apply and Restart",
          "subtitle": "Device URLs allows you to set multiple URLs from which the system can be accessed (FQDN/IP) in addition to the locally configured IP addresses. (Change requires restart).",
          "title": "Device URLs",
          "edit": "Edit Device URLs",
          "fields": {
            "url": "Device URLs"
          },
          "hint": "One IP/URL per line (Maximum 32). You can use wildcard URLs (for example: *.tenable.com)",
          "restart_dialog": {
            "title": "System Restart",
            "subtitle": "In order to apply the URL changes, a restart is required. Restart may take a few minutes and, during that time, the system will not be available.",
            "submit_text": "Apply and Restart"
          }
        },
        "classification_banner": {
          "title": "Classification Banner",
          "subtitle": "Add a configurable header and footer banner to Tenable OT Security to indicate the classification of the data accessible via the software.",
          "slider": {
            "title": "Edit Classification Banner",
            "submit": "Save"
          },
          "messages": {
            "success": "Classification Banner changed successfully."
          },
          "fields": {
            "banner_title": "Banner Title",
            "banner_color": "Banner Background Color"
          },
          "dropdown_values": {
            "DefaultColor": "Yellow",
            "Color1": "Yellow-Orange",
            "Color2": "Yellow-Green",
            "Color3": "Green",
            "Color4": "Blue-Green",
            "Color5": "Blue",
            "Color6": "Violet",
            "Color7": "Red",
            "Color8": "Red-Orange",
            "Color9": "Orange",
            "Color10": "Red-Violet"
          }
        },
        "device_name": {
          "edit": "Edit Site Name",
          "edit_em": "Edit Organization Name",
          "title_icp": "Site Name",
          "title_em": "Organization Name",
          "subtitle": "The name of the site where the Tenable OT Security ICP device is installed",
          "subtitle_em": "The name of the organization using this Tenable OT Security Enterprise Manager platform",
          "fields": {
            "name_icp": "Site Name",
            "name_em": "Organization Name"
          },
          "messages": {
            "success": "Name changed successfully."
          },
          "submit": "Save"
        },
        "device_auto_logout": {
          "title": "Maximum Log-in Session Time-out",
          "subtitle": "Determines the session period after which logged in users will be logged out automatically and required to log in again. (Requires log-out)",
          "fields": {
            "logout_after": "Log out After"
          },
          "dropdown_values": {
            "thirty_minutes": "30 Minutes",
            "one_hour": "1 Hour",
            "four_hours": "4 Hours",
            "twelve_hours": "12 Hours",
            "one_day": "1 Day",
            "one_week": "1 Week",
            "two_weeks": "2 Weeks"
          },
          "popup": {
            "header": "Update Maximum Log-in Session Time-out Period",
            "button": "Log out and Update"
          },
          "messages": {
            "success": "Device auto-log-out setting updated successfully."
          }
        },
        "device_inactivity_auto_logout": {
          "title": "Maximum Inactivity Time-out",
          "subtitle": "Determines the inactivity period after which logged-in users will be logged out automatically and required to log in again. (Requires log-out)",
          "dropdown_values": {
            "never": "Never",
            "fifteen_minutes": "15 Minutes",
            "thirty_minutes": "30 Minutes",
            "one_hour": "1 Hour",
            "three_hour": "3 Hours",
            "six_hour": "6 Hours",
            "tweelve_hour": "12 Hours"
          },
          "popup": {
            "header": "Update Inactivity Log-out Period",
            "button": "Update"
          },
          "messages": {
            "success": "Inactivity auto-log-out setting updated successfully."
          }
        },
        "open_ports": {
          "title": "Open Ports Age-out Period",
          "subtitle": "Discovered open ports will disappear from the list after a certain period of time.",
          "fields": {
            "period": "Period"
          },
          "slider": {
            "title": "Edit Open Ports Age-out Period"
          },
          "messages": {
            "success": "Configuration changes saved successfully"
          }
        },
        "packet_capture": {
          "title": "Packet Capture",
          "subtitle": "Turning on the full packet capture capability will cause Tenable OT Security to record all traffic from all its sensors in a continuous process to files, as well as to delete older files upon reaching maximum storage capacity limit."
        },
        "sensor": {
          "title": "Auto-Approve Sensor Pairing Requests"
        },
        "usage_statistics": {
          "title": "Enable Usage Statistics",
          "subtitle": "Enable this option to turn on telemetry and to access the OT Security Resource Center. After enabling or disabling, refresh your browser for the change to take effect.\nNote: When enabled, Tenable collects anonymous telemetry data from your account. This information cannot be attributed to a specific individual; it does not include Personal Data. We analyze this data in-house and also send it to third-party partners for analytics and optimization. We use this data to identify ways of improving the user experience in future Tenable OT Security releases. We may also use the data for other reasonable business purposes in accordance with the Tenable Master Agreement. You can disable this option at any time, in order to stop sharing usage statistics with Tenable."
        },
        "enable_graphql": {
          "title": "GraphQL Playground",
          "subtitle": "GraphQL Playground is an in-browser GraphQL IDE. This toggle will allow you to enable/disable the playground in production to test your API queries."
        }
      },
      "sensors": {
        "title": "Sensors",
        "toggle_text": "Auto-approve sensor pairing requests",
        "no_results": {
          "title": "No Sensors Found",
          "description": "Sensors extend visibility into network segments that can’t be reached directly—ideal for remote areas, isolated lines, or zones requiring dedicated monitoring.",
          "call_for_action": "Need help with sensor deployment?\nContact Support or visit our documentation."
        },
        "column_defs": {
          "ip": "IP",
          "status": "Status",
          "active_queries": "Active Queries",
          "active_query_networks": "Active Query Networks",
          "name": "Name",
          "last_update": "Last Update",
          "sensor_identifier": "Sensor ID",
          "version": "Version",
          "platform_type": "Platforms",
          "throughput": "Throughput",
          "network_area": "Network Area"
        },
        "platforms": {
          "centos_7": "CentOS 7",
          "ol8": "Oracle Linux 8",
          "windows": "Windows"
        },
        "state_options": {
          "connected": "Connected",
          "connected_unauthenticated": "Connected (Unauthenticated)",
          "disconnected": "Disconnected",
          "disconnected_no_tunnel": "Disconnected (No tunnel)",
          "paused": "Paused",
          "pending_approval": "Pending approval",
          "updating": "Update in progress"
        },
        "edit_sensor": {
          "title": "Edit Sensor",
          "info": "Make sure to add only CIDRs that are accessible through this Sensor. Adding CIDRs that are not accessible may interfere with the ICP’s ability to query those segments by other means.",
          "name": "Name",
          "active_query_networks": "Active Query Networks",
          "help_tip": "One CIDR per Line",
          "help_tip_duplicate_network": "This Sensor is assigned to duplicated networks",
          "hint": "e.g. 10.10.10.10/18",
          "sensor_active_queries": "Sensor active queries",
          "invalid_ip": "IP list contains an invalid address",
          "notifications": {
            "success": "Changes saved successfully",
            "failure": "An error occurred—unable to save changes"
          }
        },
        "pause_sensor": {
          "title": "Pause Sensor",
          "text": "Are you sure?<br>If you proceed, data from the selected sensor will not be processed.",
          "notifications": {
            "success": "Sensor {{sensorName}} was paused successfully",
            "failure": "Unable to pause the sensor {{sensorName}}"
          }
        },
        "delete_sensor": {
          "title": "Delete Sensor",
          "text": "Are you sure?<br>If you proceed, sensor connection will be terminated. You will not be able to undo this action.",
          "notifications": {
            "success": "Sensor {{sensorName}} was deleted successfully",
            "failure": "Unable to delete the sensor {{sensorName}}"
          }
        },
        "resume_sensor": {
          "notifications": {
            "success": "Sensor {{sensorName}} connection was resumed successfully",
            "failure": "Unable to resume connection to the sensor {{sensorName}}"
          }
        },
        "update_sensor": {
          "title": "Update Sensor",
          "title_other": "Update Sensors ({{count}})",
          "dialog_text": "Are you sure?<br>During the update process, the sensor might not be available and data from the sensor might be lost.",
          "dialog_text_other": "Are you sure?<br>During the update process, the sensors might not be available and data from the sensors might be lost.",
          "update_successful": "Sensor {{sensorIp}} was updated successfully",
          "update_successful_other": "{{succeeded}} sensors out of {{count}} were updated successfully",
          "update_failed": "Unable to update the sensor {{sensorIp}}",
          "update_failed_other": "0 sensors out of {{count}} were updated",
          "nag": "Sensor updates are available",
          "system_update_exist": "OS update available",
          "stockdog_update_exist": "Version update available",
          "view_sensors": "View Sensors",
          "check_for_updates": "Check for updates",
          "up_to_date": "All sensors are up to date",
          "updates_available": "Updates available",
          "not_available_title": "Update Sensor Not Available",
          "not_available_dialog_text": "Sensors running at least version 3.16 will receive updates from Tenable OT Security. If your sensor is running a version prior to 3.16, please contact support for assistance.",
          "active_query_enabled_successful": "Active queries enabled on {{ count }} sensors",
          "active_query_disabled_successful": "Active queries disabled on {{ count }} sensors",
          "bulk_resume_successful": "The connection of {{ count }} sensors was successfully resumed.",
          "bulk_pause_successful": "{{ count }} sensors were paused successfully"
        },
        "actions": {
          "bulk_enable_active_queries": "Enable Active Queries",
          "bulk_disable_active_queries": "Disable Active Queries",
          "delete": {
            "tooltip": "You cannot delete a sensor as long as it is assigned to a duplicated network."
          }
        }
      },
      "suricata_updates": {
        "card_title": "IDS Engine Ruleset Cloud Updates",
        "actions": {
          "update_file": "Update from File",
          "update_now": "Update Now",
          "edit_freq": "Edit Frequency"
        },
        "grid_columns": {
          "frequency": "Frequency",
          "ruleset": "Rule Set",
          "last_updated": "Last Updated"
        },
        "update_online": {
          "info_message": "Nessus plugin set update started—it may take 30 minutes or longer to complete",
          "success_message": "Nessus plugin set updated successfully"
        },
        "license_message": {
          "license_outdated": "License outdated—IDS Engine ruleset cloud updates are not available",
          "license_expired": "License expired—IDS Engine ruleset updates are not available",
          "link": "update your license"
        },
        "update_file_form": {
          "title": "Update from File",
          "label": "Upload IDS Engine Ruleset file",
          "file_link": "Download the latest IDS Engine ruleset file",
          "info": "(Requires Internet connection)",
          "license_outdated": "In order to download the latest IDS Engine ruleset file, you have to",
          "license_outdated_link": "update your license"
        },
        "notifications": {
          "update_from_file": {
            "success": "IDS Engine ruleset was updated successfully. {{added}} new rules were added, {{edited}} rules were edited, and {{deleted}} rules were deleted.",
            "failed_invalid_file": "Unable to update IDS Engine ruleset—invalid file",
            "failed_newer_exists": "Unable to update IDS Engine ruleset—a newer version of the ruleset already exists",
            "failed": "Unable to update IDS Engine ruleset"
          },
          "edit_frequency": {
            "success": "Frequency updated successfully",
            "failed": "Failed to configure IDS engine updates frequency"
          },
          "online_update": {
            "success": "IDS Engine ruleset was updated successfully. {{added}} new rules were added, {{edited}} rules were edited, and {{deleted}} rules were deleted.",
            "failed_newer_exists": "Unable to update IDS Engine ruleset—a newer version of the ruleset already exists",
            "failed": "Unable to update IDS Engine ruleset",
            "failed_no_connection": "Unable to update IDS Engine ruleset (no connection)"
          }
        }
      },
      "updates": {
        "title": "Updates",
        "card_title": "Nessus Plugin Set Cloud Updates",
        "actions": {
          "update_file": "Update from File",
          "update_now": "Update Now",
          "edit_freq": "Edit Frequency"
        },
        "grid_columns": {
          "frequency": "Frequency",
          "last_updated": "Last Updated",
          "plugin_set": "Plugin Set"
        },
        "repeats": "Repeats every",
        "update_file_form": {
          "title": "Update from File",
          "label": "Upload plugin set file",
          "file_link": "Download the latest Nessus plugin file",
          "info": "(Requires Internet connection)",
          "license_outdated": "In order to download the latest plugin file, you have to",
          "license_outdated_link": "update license"
        },
        "notifications": {
          "update_started": "Nessus plugin set update started—it might take 30 minutes or longer to complete. Please keep this browser window open and do not refresh while in progress.",
          "success": "Nessus plugin set updated successfully",
          "up_to_date": "Nessus plugin set already up to date",
          "failure": "Unable to update Nessus plugin set",
          "failure_license_inactive": "Unable to update Nessus plugin set (license inactive)",
          "failure_license_old": "Unable to update Nessus plugin set (outdated license)",
          "failure_nessus": "Unable to update Nessus plugin set (Nessus not ready)",
          "failure_already_exists": "Unable to update Nessus plugin set",
          "failure_update_running": "Unable to update Nessus plugin set (update already in progress)",
          "network_error": "Unable to update Nessus plugin set (no connection)",
          "frequency_success": "Nessus update frequency configured successfully",
          "frequency_failure": "Failed to configure Nessus update frequency"
        },
        "grid_messages": {
          "nessus_loading": "Nessus is still being loaded—updates are not available at this time.",
          "license_outdated": "License outdated—Nessus plugin set cloud updates are not available.",
          "license_expired": "License expired—Nessus plugin set updates are not available.",
          "license_outdated_link": "Update license"
        }
      },
      "port_config": {
        "title": "Port Configuration",
        "subtitle": "Below are the network connection details of your ICP device. To make any modifications in this configuration, such as changing addresses or splitting management and queries to different ports, access the Cockpit interface on your Tenable Core operating system (port 8000).",
        "fields": {
          "ip": "IP",
          "subnet": "Subnet Mask",
          "gateway": "Gateway",
          "managementIp": "Management IP",
          "managementSubnet": "Management Subnet Mask",
          "managementGateway": "Management Gateway"
        },
        "config_image": {
          "queries": "Queries",
          "management": "Management",
          "together": "Queries + Management",
          "mirror": "Mirror Port",
          "reserved": "Reserved"
        },
        "details": {
          "queries": "Queries IP configuration",
          "management": "Management IP configuration"
        },
        "reboot_messages": {
          "success": "Your system is restarting…",
          "failure": "Error occurred while trying to reboot."
        }
      },
      "certificates": {
        "title": "Certificates",
        "help_text": "The certificate is used to secure the HTTPS connection. Use this section to generate a self-signed certificate or to upload an externally signed one.",
        "read_error": "Certificate could not be read. Please try again later.",
        "actions": {
          "generate": "Generate Self-Signed Certificate",
          "upload": "Upload Certificate",
          "download": "Download Certificate"
        },
        "upload_form": {
          "title": "Upload Certificate",
          "file": "Certificate File",
          "file_subtitle": "PEM format only",
          "private_key_file": "Private Key File",
          "private_key_passphrase": "Private Key Passphrase",
          "error": "An error occurred while trying to upload a certificate",
          "success": "Certificate was uploaded successfully"
        },
        "generate": {
          "title": "Generate Certificate",
          "content": "Are you sure?<br>Generating a new certificate will override the current certificate issued by ${issuedBy}.<br><br>Self-signed certificate will be valid for 1 year. Please note that your session will not be trusted.",
          "confirm_btn": "Generate",
          "error": "An error occurred while trying to generate a certificate",
          "success": "Self-signed certificate was generated successfully"
        },
        "data_table": {
          "issuedTo": "Issued to",
          "issuedBy": "Issued by",
          "issuedOn": "Issued on",
          "expiresOn": "Expires on",
          "fingerprint": "Certificate Fingerprint",
          "missing_data": "- N/A -"
        }
      },
      "api_keys": {
        "title": "API Keys",
        "grid": {
          "id": "ID",
          "user": "Created By",
          "role": "Role",
          "description": "Description",
          "expiryTime": "Expiration Date"
        },
        "generate": {
          "title": "Generate Key",
          "submit": "Generate",
          "notification": "Full API key will be displayed only once and will not be accessible once you close this window!",
          "notification_bottom": "Please be sure to record it securely.",
          "fields": {
            "role": "Role",
            "expiryTime": "Expiration Period",
            "expiryTimeDays": "days",
            "description": "Description",
            "apiKey": "ID",
            "apiSecret": "API KEY"
          }
        },
        "delete": {
          "singular": {
            "title": "Delete API Key",
            "text": "Are you sure?",
            "success": "API Key deleted successfully",
            "failure": "Failed to delete an API Key"
          },
          "plural": {
            "title": "Delete API Keys",
            "text": "Are you sure?<br>If you proceed, ${number_of_checked_items} API keys will be permanently deleted."
          }
        }
      },
      "license": {
        "title": "License",
        "card_desc": "",
        "actions": {
          "update": "Update license",
          "reinit": "Reinitialize license"
        },
        "reinit_popup": {
          "title": "Reinitialize License",
          "content": "Are you sure?<br/>Once you complete the three-step process to reinitialize your license, the current license will be replaced by the new one. Until the process is completed, your current license will remain in effect.",
          "button": "Reinitialize"
        },
        "update_text": "Follow these steps in order to update your license",
        "reinit_text": "Follow these steps in order to reinitialize your license"
      },
      "dfe_updates": {
        "card_title": "Dynamic Fingerprinting Engine (DFE) Cloud Update",
        "actions": {
          "update_file": "Update From File",
          "update_now": "Update Now",
          "edit_freq": "Edit Frequency"
        },
        "grid_columns": {
          "frequency": "Frequency",
          "ruleset": "Version",
          "last_updated": "Last Updated"
        },
        "license_message": {
          "license_outdated": "License outdated - DFE updates are not available",
          "license_expired": "In order to download the latest DFE file, you have to update your license",
          "link": "update your license"
        },
        "update_file_form": {
          "title": "Update From File",
          "label": "Upload DFE file",
          "file_link": "Download the latest DFE file",
          "info": "(Requires internet connection)",
          "license_outdated": "License outdated - DFE updates are not available ",
          "license_outdated_link": "update your license"
        },
        "notifications": {
          "update_from_file": {
            "success": "DFE updated successfully",
            "failed_invalid_file": "Unable to update DFE, invalid file",
            "failed_newer_exists": "Unable to update DFE, a newer version already exists",
            "failed": "Unable to update DFE"
          },
          "edit_frequency": {
            "success": "Frequency updated successfully",
            "failed": "Failed to configure frequency"
          },
          "online_update": {
            "success": "DFE updated successfully",
            "failed_newer_exists": "Unable to update DFE, a newer version already exists",
            "failed": "Unable to update DFE",
            "failed_no_connection": "Unable to update DFE (no connection)"
          }
        }
      }
    },
    "env_config": {
      "title": "Environment Settings",
      "enterprise_manager": {
        "title": "Enterprise Manager",
        "em_pairing": {
          "title": "EM Pairing",
          "subtitle": "Setting up a connection with the Enterprise Manager. Multiple ICPs can be connected to the Enterprise Manager.",
          "not_paired_button": "Start Pairing",
          "show_certificate": "Show Certificate",
          "notifications": {
            "delete_success": "EM Pairing disconnected successfully",
            "approve_success": "EM certificate has been approved successfully",
            "nag_text": "EM pairing process requires certificate approval",
            "nag_link_text": "View Request Details"
          },
          "disconnect_popup": {
            "title": "Disconnect",
            "text": "Are you sure? If you proceed, connection with the EM will be lost and all pairing details will be erased permanently.",
            "submit_text": "Disconnect"
          },
          "pairing_statuses": {
            "trying_to_connect": "Trying to connect",
            "waiting_for_certificate_approval": "Waiting for certificate approval",
            "pending_em_approval": "Pending EM approval",
            "certificate_mismatch_error": "Trying to connect (Error: Certificate mismatch)",
            "host_unreachable_error": "Trying to connect (Error: Host unreachable)",
            "bad_credentials_error": "Trying to connect (Error: Bad credentials)",
            "internal_server_error": "Trying to connect (Error: Internal server error)",
            "cant_get_target_version_error": "Trying to connect (Error: Can’t get target version)",
            "unsupported_target_version_error": "Trying to connect (Error: Unsupported target version)",
            "disconnected_error": "Trying to connect (Error: Disconnected)",
            "connected": "Connected"
          },
          "grid": {
            "hostname": "EM hostname/IP",
            "status": "Status",
            "last_sync": "Last Data Sync"
          },
          "start_pairing_slider": {
            "title": "EM Pairing Configuration",
            "submit": "Pair",
            "fields": {
              "hostname": "Hostname/IP",
              "username_password_pair": "Pair using username and password",
              "api_key_pair": "Pair using API secret",
              "unpair": "No Pairing (disconnect)",
              "api_key": "API secret",
              "username": "Username",
              "password": "Password",
              "fingerprint": "EM CERTIFICATE FINGERPRINT",
              "fingerprint_description": "Fingerprint can be found in EM settings certificates page"
            }
          },
          "approve_certificate_slider": {
            "title": "Approve Certificate",
            "submit": "Approve",
            "info": "Make sure that the fingerprint matches the certificate details that can be found on the EM settings certificates page",
            "fields": {
              "issued_to": "Issued To",
              "issued_by": "Issued By",
              "issued_on": "Issued On",
              "expires_on": "Expires On",
              "fingerprint": "Fingerprint"
            }
          }
        }
      },
      "asset_settings": {
        "title": "Network Definitions",
        "scd_files": {
          "title": "SCD Files",
          "subtitle": "Upload SCD files to import each of your substations’ configuration and define IED device communication settings according to the IEC 61850 Standard.",
          "note": "Note:",
          "note_message": "only one SCD file is allowed per substation. The most recently uploaded file containing the same substation name will override previous ones.",
          "download_details": "Download Details",
          "subscriptions_message": "{{ count }} unauthorized clients attempted to subscribe to MMS report datasets. Ensure that only authorized clients are listed in the SCD file for the relevant reports.",
          "misconfiguration_message": "SCD import analysis detected {{ count }} potential unauthorized access risks in MMS Reports. The Max attribute allows more clients than explicitly defined. Review and update the configuration to restrict access, or create a Tenable OT policy to monitor unauthorized attempts.",
          "existing_filename_info_message": "Upload SCD files to identify assets, view MMS Reports, and enhance security insights. Files with existing Project IDs will automatically override previous data, so always provide the most up-to-date file for each Project ID.",
          "upload_success": "SCD file uploaded successfully",
          "invalid_file": {
            "max_size": "The uploaded SCD file exceeds the size limit of 50 MB. Please ensure your file is within the allowed size and try again",
            "general_error": "You must upload the an SCD file; any other type will not be accepted"
          },
          "grid_settings": {
            "columns": {
              "substation": "Substation",
              "filename": "SCD File Name",
              "last_updated": "Last Updated",
              "project": "Project"
            }
          }
        },
        "project_files": {
          "title": "Rockwell Project Files",
          "description": "Upload a single project file (.L5X) to extract controller configuration and enrich your asset inventory with details like controller type, IP address, and backplane structure.",
          "upload_success": "Project file uploaded successfully",
          "max_size": "The uploaded file exceeds the size limit of 50 MB. Please ensure your file is within the allowed size and try again"
        },
        "network_management": {
          "title": "Network Management"
        },
        "network_areas": {
          "title": "Network Areas",
          "grid": {
            "name": "Name",
            "description": "Description",
            "online_sources": "Local Sources",
            "reported_sources": "Reported Sources",
            "assigned_duplicated_subnets": "Assigned Duplicated Subnets",
            "id": "Network Area ID",
            "actions": {
              "add": "Add Remote Network Area",
              "edit_details": "Edit Details",
              "unite": "Unite Sources",
              "assign_duplicated_subnets": "Assign Duplicated Subnets",
              "move_sources": "Move Sources"
            },
            "delete": {
              "tooltip": "This network area is in-use, remove it from all objects in order to delete."
            }
          },
          "form": {
            "name": "Name",
            "description": "Description"
          },
          "move_sources": {
            "sources": "Sources to Move",
            "move_to": "Move to Network Area"
          },
          "create_network_area": {
            "notifications": {
              "success": "Network area created successfully"
            }
          },
          "delete_network_area": {
            "title": "Delete Network Area",
            "text": "Are you sure?<br>If you proceed, this network area will be permanently deleted.",
            "notifications": {
              "success": "Network area deleted successfully",
              "failure": "Unable to delete network area"
            }
          }
        },
        "monitored_network": {
          "title": "Monitored Networks",
          "subnets": "Subnets",
          "subtitle": "The Assets Network is an aggregation of IP ranges in which assets are located. Use these settings in order to configure these IP ranges. Please note that in addition to these settings, any host within Tenable OT Security sensors’ subnets or any activity-performing device will be classified as an asset.",
          "default_ips": "Default IP ranges",
          "additional_ips": "Additional IP ranges",
          "popups": {
            "enable": {
              "title": "Enable Subnet",
              "text": "Tenable OT Security will passively capture traffic and allow executing active queries and scans within the range of subnet {{ subnet }}.",
              "submit_text": "Enable Subnet"
            },
            "disable": {
              "title": "Disable Subnet",
              "text": "Tenable OT Security will stop passively capturing traffic within the range of subnet {{ subnet }}, and block it for executing active queries and scans. <br> <br> Note: in case there are overlaps between this subnet and other subnets that are still enabled, the common ranges will remain enabled.",
              "submit_text": "Disable Subnet"
            },
            "save_and_enable_monitoring": {
              "title": "Enable Monitoring",
              "text": "Subnet <b>{{ subnet }}</b> will be included in the monitored network in these sites:",
              "additional_text": "Tenable OT Security will keep track of the assets and monitor the network traffic within its range, in these sites.",
              "submit_text": "Save and Enable Monitoring"
            },
            "enable_monitoring": {
              "title": "Enable Monitoring",
              "text": "Subnet <b>{{ subnet }}</b> will be included in the monitored network in <b>{{ site }}</b>. Tenable OT Security will keep track of the assets and monitor the network traffic within its range.",
              "submit_text": "Enable Monitoring"
            },
            "disable_monitoring": {
              "title": "Disable Monitoring",
              "text": "Subnet <b>{{ subnet }}</b> will be excluded from the monitored network of <b>{{ site }}</b>. Tenable OT Security will stop keeping track of the assets and monitoring the traffic within its range. <br><br>Note: in case there are overlaps between this subnet and other subnets that are still enabled, the common ranges will remain enabled.",
              "submit_text": "Save and Disable Monitoring"
            },
            "bulk_enable": {
              "title": "Enable Subnets",
              "text": "{{ count }} Subnet will be included in the monitored network. Tenable OT Security will keep track of the assets and monitor the network traffic within their range.",
              "text_other": "{{ count }} Subnets will be included in the monitored network. Tenable OT Security will keep track of the assets and monitor the network traffic within their range.",
              "submit_text": "Enable Subnets"
            },
            "bulk_disable": {
              "title": "Disable Subnets",
              "text": "This subnet will be excluded from the monitored network. Tenable OT Security will stop keeping track of the assets and monitoring the traffic within their range.<br><br>Note: in case any of the subnets overlap with other subnets that are still enabled, the common ranges will remain enabled.",
              "text_other": "These {{ count }} subnets will be excluded from the monitored network. Tenable OT Security will stop keeping track of the assets and monitoring the traffic within their range.<br><br>Note: in case any of the subnets overlap with other subnets that are still enabled, the common ranges will remain enabled.",
              "submit_text": "Disable Subnets"
            },
            "save_locations": {
              "title": "Save Subnet Locations",
              "text": "After your confirmation, this will be the updated site distribution and monitoring status of subnet <b>{{ subnet }}</b>:",
              "submit_text": "Save Subnet Locations"
            },
            "delete": {
              "title": "Delete Subnet",
              "title_other": "Delete {{ count }} Subnets",
              "text": "If you proceed, the subnet {{ subnet }} will be permanently removed from the monitored network.",
              "text_other": "If you proceed, {{ count }} subnets will be permanently removed from the monitored network.",
              "monitoring_text": "Tenable OT Security will stop keeping track of the assets and monitoring the traffic within its range.",
              "submit_text": "Delete Subnet",
              "submit_text_other": "Delete Subnets",
              "cannot_delete_default": "You cannot delete default IP ranges"
            }
          },
          "bulk_actions": {
            "enable_subnets": "Enable Subnets",
            "disable_subnets": "Disable Subnets",
            "delete_subnets": "Delete Subnets"
          },
          "grid": {
            "columns": {
              "local_names": "Local Names",
              "local_descriptions": "Local Descriptions"
            },
            "site_index": "Site {{ index }}"
          },
          "slider": {
            "one_per_line": "IP Ranges—One CIDR per Line",
            "additional_ips_placeholder": "e.g 10.10.10.10/8",
            "bulk_placeholder": "Enter CIDRs, one per line (e.g. 192.168.1.0/24)",
            "placeholder": "Type one CIDR (e.g. 192.168.1.0/24)",
            "additional_ips_validation_error": "IP list contains an invalid address",
            "suricata_exceeded_max": "IDS engine will only monitor the first {{ count }} subnet definitions (CIDRs).",
            "add_subnets": "Add New Subnets",
            "add_one_subnet": "Add One Subnet",
            "add_bulk_subnets": "Add Subnets List",
            "edit_subnet": "Edit Subnet",
            "delete_subnet": "Delete Subnet",
            "edit_details": "Edit Details",
            "manage_locations": "Manage Locations",
            "edit_warning": "Be cautious: making changes in the distribution and monitoring status of subnets can have a substantial influence on the inventory in your sites",
            "reconfigure_info": "You will always be able to reconfigure these locations in the future - per subnet, per site or in bulk.",
            "subnet_edit_hint_deletable": "You cannot change the CIDR. In case of need, add a new subnet with the required CIDR, and delete this one",
            "subnet_edit_hint_not_deletable": "You cannot change the CIDR. In case of need, add a new subnet with the required CIDR",
            "monitored": "Monitored",
            "all_subnets": "(all added subnets)",
            "monitored_tooltip": "When a subnet is enabled, Tenable OT Security captures traffic and allows executing active queries and scans within its range.",
            "titles": {
              "subnet_details": "Subnet Details",
              "subnet_locations": "Subnet Locations"
            },
            "labels": {
              "sites": "Site Distribution",
              "sites_hint": "In which of your site networks this subnet is currently present",
              "monitoring": "Enable Monitoring (optional)",
              "monitoring_hint": "From the sites selected above, choose in which ones monitoring will be instantly enabled for this subnet",
              "enabled": "Enabled",
              "disabled": "Disabled"
            },
            "placeholders": {
              "select_sites": "Select sites"
            }
          },
          "notifications": {
            "add_success": "Subnet was added successfully",
            "add_success_other": "{{ count }} Subnets were added successfully",
            "edit_success": "Subnet was edited successfully",
            "edit_success_other": "{{ count }} Subnets were edited successfully",
            "bulk_edit_success": "{{ count }} Subnet was updated successfully",
            "bulk_edit_success_other": "{{ count }} Subnets were updated successfully",
            "delete_success": "{{ count }} Subnet was deleted successfully",
            "delete_success_other": "{{ count }} Subnets were deleted successfully",
            "success": "Monitored networks were successfully changed",
            "failure": "Failed to change monitored networks"
          },
          "tooltips": {
            "on": "Monitoring enabled in this site. Click to disable it.",
            "off": "Monitoring disabled in this site. Click to enable it.",
            "not_defined": "This subnet is not defined in this site and cannot be enabled. To add it, choose “Manage Locations”.",
            "icp_disconnected": "This site is disconnected from the enterprise manager. The monitoring status cannot be modified until the connection is restored.",
            "icp_old_version": "The ICP in this site is running an incompatible Tenable OT version, and cannot currently be accessed from the Enterprise Manager. For further assistance consult with our user guide or contact your system admin or Tenable Support."
          }
        },
        "update_asset_csv": {
          "title": "Update Asset Details Using CSV",
          "subtitle": "You can export a CSV file of the ‘All Assets’ table, edit it, and upload it in order to update asset details in bulk. Editable fields are: Type, Name, Criticality, Purdue Level, Location, Description, and all custom fields. <br> <br> The capability to update asset details using a CSV file is only available while using English. Non-English users can switch to English while exporting and uploading the CSV file and then switch back to their preferred language.",
          "latest_upload": "Latest upload date",
          "download": "Download Report",
          "notification": {
            "success": "Update asset details completed—${updated} out of ${outOf} rows were updated",
            "success_with_error": "${error} did not update due to an error",
            "invalid_file": {
              "max_size": "Unable to upload CSV—maximum size limit is 30 MB",
              "missing_id": "Unable to upload CSV—missing ID column",
              "general_error": "You must upload the exported CSV file of the Assets list; any other CSV will not be accepted"
            }
          },
          "statistics_csv": {
            "file_name": "Update asset details report",
            "asset_Id": "Asset ID",
            "status": "Status"
          }
        },
        "upload_assets": {
          "title": "Add Assets Manually",
          "subtitle": "In order to add new assets manually to your inventory, you must first download the CSV template and enter the new assets’ details in accordance with the guidelines (presented in the CSV template), and then upload the CSV.",
          "actions": {
            "download_template": "Download CSV template",
            "upload": "Upload CSV",
            "download_report": "Download Report"
          },
          "template_file_name": "Assets template",
          "grid": {
            "last_upload_date": "Latest upload date",
            "loading_csv": "Processing CSV"
          },
          "notification": {
            "success": "CSV was uploaded successfully—added {{count}} new asset",
            "success_other": "CSV was uploaded successfully—added {{count}} new assets",
            "success_with_error": "{{error}} did not update due to an error",
            "invalid_file": {
              "format": "Unable to upload CSV—not a valid CSV format",
              "max_size": "Unable to upload CSV—the maximum size limit is 15 MB",
              "general_error": "Unable to upload CSV—if the problem persists, contact our support team"
            }
          }
        },
        "duplicate_networks": {
          "title": "Duplicated Internal Networks",
          "no_results": "No duplicated networks are currently defined.",
          "button": {
            "title": "Add Network"
          },
          "message_box": {
            "title": "IP Reserve Pool: {{ overlappingPool }}",
            "subtitle": "This pool will be used internally within OT Security for the purposes of background reservation of IP address mapping for NAT IP allocation.\nIf you wish to change the designated segment, contact Tenable OT Security Support.",
            "nessus_not_loaded_subtitle": "Nessus upload in progress - setting will be ready shortly.",
            "no_sources": "In order to define duplicate networks, at least one sensor (with version 4.1 or above) needs to be connected to the system. For further assistance contact your administrator or Tenable OT support."
          },
          "grid": {
            "title": "Duplicated Networks",
            "columns": {
              "cidr": "CIDR",
              "sources": "Sources",
              "in_use_discovery": "In Use - Discovery Queries",
              "in_use_nessus": "In Use - Nessus Scans"
            },
            "actions": {
              "delete": {
                "title": "Delete Duplicated Network",
                "confirm_delete": "Are you sure you want to delete network {{ networkName }}?",
                "cannot_delete": "Unable to delete the duplicated network. <br> It is currently being used in:",
                "used_in_discovery": "{{count}} Active Queries",
                "used_in_nessus": "{{count}} Nessus Scans"
              }
            }
          },
          "wizard": {
            "header": {
              "create": "Add Duplicated Network",
              "edit": "Edit Duplicated Network",
              "delete": "Delete Duplicated Network"
            },
            "steps": {
              "details": {
                "title": "Network Details",
                "inputs": {
                  "network": {
                    "title": "Duplicated IP Range",
                    "subtitle_no_feature_flag": "If the range is not in the monitored network, it will be added to it",
                    "subtitle": "Duplicate ranges are self managed under their respective sources, independent of the ICP's monitored subnets list",
                    "placeholder": "Type one CIDR (e.g: 192.168.0.0/24)",
                    "in_used": "You cannot edit a CIDR that’s in use in a query or a scan."
                  },
                  "origins": {
                    "title": "Duplicates (Sources)",
                    "placeholder": "Select",
                    "in_used": "You cannot remove sensors when in use in a query or a scan."
                  }
                }
              },
              "confirmation": {
                "title": "Confirmation",
                "inputs": {
                  "delete_checkbox": {
                    "label": "Delete Assets"
                  }
                },
                "message": {
                  "assetsDeletion": {
                    "title": "Please Confirm Asset Deletion",
                    "subtitle": "In order to separate these {{assetsCount}} assets into their own networks, the system will need to delete them automatically, allowing them to be rediscovered again after startup.\nIf you wish not to delete these {{assetsCount}} assets, they will remain in their current IP range and this may cause data inconsistencies or unexpected behavior. Best practices suggest deleting the affected overlapping assets.",
                    "link": "View Assets in New Tab"
                  },
                  "noAssetsDeletion": {
                    "title": "Please Confirm Action",
                    "subtitle": "No assets are currently located in the specified range. After completing the action, an asset discovery process will start in all duplicated versions of the range."
                  }
                }
              }
            },
            "notifications": {
              "create": {
                "success": "Duplicated network added."
              },
              "edit": {
                "success": "Duplicated network modified."
              },
              "delete": {
                "success": "Duplicated network deleted."
              }
            }
          }
        },
        "snmp_discovery": {
          "title": "Discover New Assets via SNMP",
          "subtitle": "When this setting is enabled, assets that are discovered by SNMP queries (active or passive) are automatically added to the Inventory."
        },
        "passive_monitoring": {
          "title": "Passive Monitoring",
          "subtitle": "Passive Monitoring captures network traffic to fingerprint assets and detect activities or threats on the network.",
          "message_box": {
            "title_no_feature_flag": "Before enabling Passive Monitoring, set the Monitored Network to define which ranges are in scope for monitoring and asset detection.",
            "title": "Before enabling Passive Monitoring, it is recommended to properly define which subnets are included in the monitored network (via \"Network Management\" page in this section)."
          },
          "notifications": {
            "success": {
              "state": {
                "enabled": "Passive monitoring was successfully enabled",
                "disabled": "Passive monitoring was successfully disabled"
              }
            }
          },
          "passive_monitoring_popup": {
            "header": "Enable Passive Monitoring",
            "title": "This will start capturing network traffic to enrich asset data and detect events.<br><br>To avoid alert overload, the following baseline-sensitive policies are disabled by default:<br>• New Module Discovered<br>• Asset Not Seen for 1 Hour<br>• Controller Not Seen for 1 Hour<br>• Communication to External Network<br>• Communication from External Network<br>• Network Traffic Data Spike Detected<br>• Network Traffic Conversation Count Spike Detected<br><br><b>It’s highly recommended to enable these policies only after the system reaches a stable baseline (typically one week after enabling monitoring).</b>",
            "submit": "Enable Passive Monitoring"
          }
        }
      },
      "removed_assets": {
        "title": "Hidden Assets",
        "removed": "(Hidden)",
        "form": {
          "comment": "Comment",
          "info": "Hidden assets will not be displayed in asset inventory pages and will not be counted into the license asset quota.",
          "title": "Hide Asset",
          "title_other": "Hide Assets ({{ count }})",
          "submit_restore_btn": "Restore",
          "submit_remove_btn": "Hide",
          "restore_asset": "Restore Asset",
          "restore_asset_other": "Restore {{ count }} Assets",
          "are_you_sure": "Are you sure?",
          "notifications": {
            "restore": {
              "success": "Asset was restored successfully",
              "success_other": "$t(general.bulk_toaster.success)",
              "failure": "Failed to restore asset",
              "failure_other": "$t(general.bulk_toaster.failure)"
            },
            "remove": {
              "success": "Asset has been hidden successfully",
              "success_other": "$t(general.bulk_toaster.success)",
              "failure": "Failed to hide asset",
              "failure_other": "$t(general.bulk_toaster.failure)"
            }
          }
        },
        "grid_columns": {
          "name": "Name",
          "ip": "IPs",
          "mac": "MACs",
          "type": "Type",
          "date_removed": "Date Hidden",
          "comment": "Comment",
          "removed_by": "Hidden By"
        }
      },
      "custom_fields": {
        "title": "Custom Fields",
        "form": {
          "add_title": "Add Custom Field",
          "update_title": "Edit Custom Field",
          "name_field": "Title",
          "type_field": "Type",
          "possible_types": {
            "PlainText": "Plain Text",
            "HyperLink": "Hyperlink"
          }
        },
        "column_defs": {
          "name": "Title",
          "type": "Type"
        },
        "delete_dialog": {
          "header": "Delete Custom Field",
          "text": "Are you sure?<br/>This action will delete this custom field and all the data assigned to it from the system."
        },
        "add_messages": {
          "success": "Custom field added successfully",
          "failure": "Failed to add a custom field"
        },
        "update_messages": {
          "success": "Custom field updated successfully",
          "failure": "Failed to update a custom field"
        },
        "delete_messages": {
          "success": "Custom field deleted successfully",
          "failure": "Failed to delete a custom field"
        }
      },
      "pcap_player": {
        "indicator_title": "PCAP file play is in progress",
        "title": "PCAP Player",
        "actions": {
          "upload": "Upload PCAP File",
          "play": "Play",
          "delete": "Delete"
        },
        "column_defs": {
          "name": "File Name",
          "size": "File Size",
          "upload_at": "Uploaded At",
          "uploaded_by": "Uploaded By",
          "last_played": "Last Played",
          "played_by": "Last Played By"
        },
        "play": {
          "never": "Never",
          "start_playing_message": "{{name}} is being played at {{speed}}x",
          "slider": {
            "warning": "Playing a PCAP file injects data into the system. This operation cannot be undone or stopped once executed.",
            "play_speed_label": "Play Speed",
            "submitBtnText": "Play",
            "header": "Play PCAP"
          },
          "messages": {
            "success": "Finished playing {{name}} at {{speed}}x",
            "failure": "Failed playing {{name}} at {{speed}}x"
          }
        },
        "upload": {
          "messages": {
            "success": "PCAP file uploaded successfully",
            "failure": "Not a valid PCAP file"
          }
        },
        "delete": {
          "popup": {
            "header": "Delete PCAP file",
            "text": "Are you sure? If you proceed, the PCAP file you selected will be permanently deleted from the system.",
            "submit": {
              "title": "Delete"
            }
          },
          "messages": {
            "success": "PCAP file deleted successfully",
            "failure": "Unable to delete—this PCAP file is currently being played"
          }
        }
      },
      "event_clusters": {
        "title": "Event Clusters",
        "fields": {
          "distinctPeriod": "Maximum time between consecutive events",
          "continuousTime": "Maximum time between first and last events"
        },
        "info": {
          "title": "Learn More About Event Cluster Settings",
          "overview_block": {
            "title": "Overview",
            "summary": "When multiple events with similar characteristics (e.g. event type, source and destination assets etc.) occur within a short time interval, this is likely to indicate that the events are closely related. In order to minimize noise in the system, Tenable OT Security automatically displays these events as a single “Cluster”. You can expand the cluster to view each individual event."
          },
          "distinctPeriod": "For events to be shown as a cluster, they must occur within the specified time interval. If the time between the current event and the previous event is greater than the “Maximum time between consecutive events”, then it will not be included in the cluster.",
          "continuousTime": "For events to be shown as a cluster, they must all occur within the specified period of time. If an event occurs over a time period that exceeds the “Maximum time between first and last events”, then this event will not be included in the cluster."
        },
        "errors": {
          "time": "Please enter a time between 0 and 999"
        },
        "messages": {
          "success": "Changes saved successfully",
          "failure": "Failed to edit an event cluster—please try again later"
        },
        "configurationEvent": {
          "header": "Configuration Event Clusters",
          "edit": "Edit Configuration Event Clusters"
        },
        "scadaEvent": {
          "header": "SCADA Event Clusters",
          "edit": "Edit SCADA Event Clusters"
        },
        "networkThreatEvent": {
          "header": "Network Threat Event Clusters",
          "edit": "Edit Network Threat Event Clusters"
        },
        "networkEvent": {
          "header": "Network Event Clusters",
          "edit": "Edit Network Event Clusters"
        }
      }
    },
    "data_collection": {
      "title": "Data Collection",
      "data_sources": {
        "title": "Data Sources",
        "manual_uploads": {
          "title": "Manual Uploads"
        }
      }
    },
    "user_and_roles": {
      "title": "User Management",
      "user_settings": {
        "title": "User Settings",
        "user_details": {
          "title": "User Details",
          "edit_user_details": {
            "title": "Edit User Details",
            "messages": {
              "success": "User details were saved successfully",
              "failure": "Unable to save user details"
            }
          },
          "name": {
            "title": "Full name"
          },
          "username": {
            "title": "Username"
          },
          "groups": {
            "title": "Assigned user groups"
          }
        },
        "password": {
          "title": "Password",
          "subtitle": "After password reset, you will be logged out of the system.",
          "edit_user_password": {
            "title": "Reset Password",
            "messages": {
              "failure": "Current password is incorrect—please try again"
            },
            "apply_btn": "Apply and Log Out"
          },
          "password": {
            "title": "Password",
            "fields": {
              "current": "Current Password",
              "new": "New Password",
              "retype": "Retype New Password"
            }
          }
        },
        "localization": {
          "title": "Localization",
          "edit": {
            "title": "Edit Localization",
            "success": "System language has been updated successfully"
          },
          "fields": {
            "language": "Language"
          }
        }
      },
      "local_users": {
        "title": "Local Users",
        "add_user": "Add User",
        "delete_user": "Delete User",
        "reset_password": "Reset Password",
        "edit_user": "Edit User",
        "grid": {
          "fullName": "Full Name",
          "username": "Username",
          "groups": "User Groups",
          "icp_groups": "ICP-Level User Groups",
          "iem_groups": "EM-Level User Groups"
        },
        "add_user_slider": {
          "title": "Add User",
          "fields": {
            "name": "Full Name",
            "username": "Username",
            "password": "Password",
            "retype_password": "Retype New Password",
            "groups": "User Groups",
            "icp_groups": "ICP-Level User Groups",
            "iem_groups": "EM-Level User Groups"
          },
          "messages": {
            "success": "User was created successfully",
            "failure": "Unable to create user"
          }
        },
        "reset_user_password_slider": {
          "title": "Reset Password",
          "text": "Reset password for {{ user }}.",
          "fields": {
            "password": "Password",
            "retype_password": "Retype New Password"
          },
          "messages": {
            "success": "User’s password was reset successfully",
            "failure": "An error occurred while trying to reset the user’s password—please try again"
          }
        },
        "edit_user_slider": {
          "title": "Edit User",
          "fields": {
            "groups": "User Groups",
            "icp_groups": "ICP-Level User Groups",
            "iem_groups": "EM-Level User Groups"
          },
          "messages": {
            "success": "User saved successfully",
            "failure": "Unable to edit user"
          }
        },
        "delete_user_popup": {
          "header": "Delete User",
          "text": "Are you sure you want to delete the user {{user.fullName}}?",
          "messages": {
            "success": "User was deleted successfully",
            "failure": "An error occurred while trying to delete the user"
          }
        }
      },
      "user_groups": {
        "title": "User Groups",
        "create_icp_access_user_group": "Create ICP-Access User Group",
        "grid": {
          "local_sites_user_groups": "Local Sites User Groups",
          "name": "Name",
          "members": "Members",
          "role": "Role",
          "zones": "Zones",
          "zones_all": "All",
          "em_groups": "Related EM User Groups",
          "type": "Type",
          "auth_servers": "Authentication Servers",
          "iem_level": "EM-Level",
          "icp_level": "ICP-Level",
          "all_sites": "All Sites",
          "system_defined": "System-Defined",
          "user_defined": "User-Defined",
          "origin": "Origin",
          "site": "Site"
        },
        "help": {
          "title": "Description of User Roles",
          "parts": [
            {
              "title": "Administrator",
              "summary": "Has maximum privileges to do all operational as well as administrative tasks in the system, including creating new user accounts."
            },
            {
              "title": "Supervisor",
              "summary": "Has full privileges to do all operational tasks in the system as well as some limited administrative tasks (excluding creating new users and other sensitive activities)."
            },
            {
              "title": "Security Manager",
              "summary": "Can manage all security-related capabilities, including configuring policies, viewing data in the system, and resolving events."
            },
            {
              "title": "Security Analyst",
              "summary": "Can view data in the system and resolve security events."
            },
            {
              "title": "Site Manager",
              "summary": "Can view data in the system and manage the asset inventory."
            },
            {
              "title": "Read only",
              "summary": "Can view data (asset inventory, events, network traffic) but can’t take action in the system."
            }
          ]
        },
        "iem_help": {
          "title": "Description of User Roles",
          "parts": [
            {
              "title": "EM Administrator",
              "summary": "Has maximum-level privileges to do all operational and administrative tasks on the EM level including creating new users and user groups.\nThe EM administrator cannot access or view operational data from the ICPs."
            },
            {
              "title": "EM Read Only",
              "summary": "Can view EM data but can’t take action in the system."
            },
            {
              "title": "ICP Administrator",
              "summary": "Has maximum ICP-level privileges to do all operational as well as administrative tasks in the system, including creating new user accounts."
            },
            {
              "title": "ICP Supervisor",
              "summary": "Has full ICP-level privileges to do all operational tasks in the system as well as some limited administrative tasks (excluding creating new users and other sensitive activities)."
            },
            {
              "title": "ICP Security Manager",
              "summary": "Can manage all security-related capabilities, including configuring policies, viewing data in the system, and resolving events."
            },
            {
              "title": "ICP Security Analyst",
              "summary": "Can view data in the system and resolve security events."
            },
            {
              "title": "ICP Site Operator",
              "summary": "Can view data in the system and manage the asset inventory."
            },
            {
              "title": "ICP Read only",
              "summary": "Can view data (asset inventory, events, network traffic) but can’t take action in the system."
            }
          ]
        },
        "form": {
          "title_create": "Create User Group",
          "title_edit": "Edit User Group",
          "title_create_with_site_group": "Create Site-Access User Group",
          "title_edit_with_site_group": "Edit Site-Access User Group",
          "create_group": "Create Group",
          "fields": {
            "name": "Name",
            "role": "Role",
            "zones": "Zones",
            "users": "Local Members",
            "auth_servers": "Authentication Servers"
          },
          "notifications": {
            "create": {
              "success": "User group created successfully",
              "failure": "Failed to create user group"
            },
            "edit": {
              "success": "User group saved successfully",
              "failure": "Failed to save user group"
            },
            "delete": {
              "success": "User group deleted successfully",
              "failure": "Failed to delete user group"
            }
          },
          "auth_providers": {
            "mapping_hint": "One {{mappingType}} per line"
          },
          "groupless_users_dialog": {
            "title_edit": "Edit User Group",
            "title_delete": "Delete User Group",
            "content": "Are you sure?<br>If you proceed, the following users will not be assigned to any group and will not be able to access the system:<br>",
            "em": {
              "content": "Are you sure?<br>If you proceed, the following users will not be assigned to any EM-level group and will not be able to access the system:<br>"
            },
            "icp": {
              "content": "Are you sure?<br>If you proceed, the following users will not be assigned to any ICP-level group and will only have read-only permissions to all CPs:<br>"
            }
          },
          "steps": {
            "group_details": "Group Details",
            "group_access": "Group Access"
          },
          "grid": {
            "title": "Site-level User Groups"
          }
        },
        "delete_popup": {
          "header": "Delete User Group",
          "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
          "cannot_delete": "Unable to delete the user group. <br> It is currently being used in:",
          "title_with_policy": "Unable to delete the user group—it has users or is being used by other entities."
        }
      },
      "auth_providers": {
        "title": "Authentication Server",
        "title_other": "Authentication Servers",
        "description": "Use this section to configure an integration with the organization’s Active Directory. This will allow users to\n log in to the system using their Active Directory credentials.",
        "steps": {
          "server_type": "Server Type",
          "configuration": "Configuration"
        },
        "headers": {
          "status": {
            "title": "Status",
            "enabled": "Enabled",
            "disabled": "Disabled"
          },
          "name": "Name",
          "domain": "Domain / Server",
          "type": "Type"
        },
        "form": {
          "restart_warning": "Auth Provider changes are pending a restart",
          "name": "Name",
          "trusted_ca": "Trusted CA",
          "pem_format_only": "PEM format only",
          "enabled": "Enable active directory",
          "replace_current_cert": "Replace Current Certificate"
        },
        "add": "Add Server",
        "active_directory": {
          "title": "Active Directory",
          "short_title": "AD",
          "form": {
            "domain_name": "Domain",
            "base_dn": "Base DN",
            "group_dn": "Group DN",
            "groupsMappings": "{{ user_group_name }} Group DN"
          }
        },
        "ldap": {
          "title": "LDAP",
          "form": {
            "domain_append": "Domain Append",
            "server": "Server",
            "port": "Port",
            "port_hint": "389 or 636",
            "user_dn": "User DN",
            "password": "Password",
            "userBaseDn": "User Base DN",
            "groupBaseDn": "Group Base DN",
            "groupName": "Group Name",
            "groupsMappings": "{{ user_group_name }} Group Name"
          }
        },
        "saml": {
          "title": "SAML",
          "subtitle": "SAML single sign-on log-in",
          "populate": {
            "title": "Populate SAML account with the following",
            "entity_id": "Entity ID",
            "url": "URL"
          },
          "config_details": {
            "title": "Configuration details"
          },
          "form": {
            "restart_warning": "SAML changes are pending a restart",
            "title": "Configure SAML",
            "idp_id": "IDP ID",
            "idp_url": "IDP URL",
            "certificate_data": "Certificate data",
            "username": "Username attribute",
            "groups": "Groups attribute",
            "description": "Description",
            "group_obj_id": "Group object ID",
            "groupsMappings": "{{ user_group_name }} Group object ID",
            "hints": {
              "idp_id": "https://SAML_Host.com",
              "idp_url": "https://SAML_host/saml-authresponse",
              "certificate_data": "Copy & paste your entire X.509 certificate here",
              "username": "NameID",
              "groups": "GroupsID"
            }
          },
          "notifications": {
            "success": "SAML configuration saved successfully",
            "enable_note": "Note that SAML authentication is not enabled yet",
            "failure": "Failed to configure SAML"
          }
        },
        "delete_dialog": {
          "title": "Delete Authentication Server",
          "subtitle": "Are you sure?",
          "success": "Server deleted successfully",
          "error": "Failed to delete server",
          "cancel": "Cancel"
        },
        "notifications": {
          "success": "Authentication server configuration saved successfully",
          "failure": "Failed to configure authentication server",
          "dup_name_failure": "Name already exists\nCannot create AD and LDAP with the same name\n"
        }
      },
      "zones": {
        "title": "Zones",
        "grid": {
          "name": "Name",
          "asset_groups": "Asset Groups",
          "user_groups": "User Groups",
          "description": "Description",
          "last_modified_by": "Last Modified by",
          "last_modified_on": "Last Modified on"
        },
        "form": {
          "title_create": "Create Zone",
          "title_edit": "Edit Zone",
          "title_dup": "Duplicate Zone",
          "fields": {
            "name": "Name",
            "asset_groups": "Asset Groups",
            "user_groups": "User Groups",
            "description": "Description"
          },
          "notifications": {
            "create": {
              "success": "Zone created successfully",
              "failure": "Unable to create Zone"
            },
            "edit": {
              "success": "Zone saved successfully",
              "failure": "Failed to save zone"
            },
            "delete": {
              "success": "Zone deleted successfully",
              "failure": "Failed to delete zone"
            }
          }
        },
        "delete_popup": {
          "header": "Delete Zone",
          "title": "Are you sure? <br>If you proceed, this group will be permanently deleted.",
          "title_with_policy": "Unable to delete zone—it is currently being used by other entities."
        }
      }
    },
    "integrations": {
      "title": "Integrations",
      "steps": {
        "type": "Module Type",
        "definition": "Module Definition"
      },
      "status_texts": {
        "ok": "OK",
        "unreachable": "Unreachable",
        "bad_credentials": "Bad Credentials",
        "no_permission": "No Permission",
        "unknown_error": "Unknown Error",
        "in_progress": "In Progress",
        "sessions_limit_exceeded": "Sessions Limit Exceeded"
      },
      "column_defs": {
        "hostname": "Hostname / IP",
        "username": "Username",
        "client": "Client ID",
        "repo_id": "Repository ID",
        "sync": "Sync Frequency",
        "status": "Status",
        "sync_details": "Sync Details",
        "last_sync": "Last sync on"
      },
      "actions": {
        "add": "Add Integration Module",
        "test": "Test Connection",
        "sync": "Sync"
      },
      "vendors": {
        "names": {
          "palo_alto": "Palo Alto Networks NGFW",
          "aruba": "Aruba Networks ClearPass",
          "sc": "Tenable Security Center",
          "io": "Tenable Vulnerability Management",
          "one": "Tenable One"
        },
        "sync_freq": {
          "label": "Sync Frequency",
          "help_label_sc": "Sync frequency controls how often data is sent to Tenable Security Center.",
          "help_label_io": "Sync frequency controls how often data is sent to Tenable Vulnerability Management.",
          "options": [
            {
              "name": "Every 1 hour",
              "value": "1h0m0s"
            },
            {
              "name": "Every 3 hours",
              "value": "3h0m0s"
            },
            {
              "name": "Every 6 hours",
              "value": "6h0m0s"
            },
            {
              "name": "Every 12 hours",
              "value": "12h0m0s"
            },
            {
              "name": "Every 24 hours",
              "value": "24h0m0s"
            },
            {
              "name": "Every 72 hours",
              "value": "72h0m0s"
            }
          ]
        },
        "palo_alto": {
          "fields": {
            "hostname": {
              "label": "Hostname / IP"
            },
            "username": {
              "label": "Username"
            },
            "password": {
              "label": "Password",
              "placeholder": "Password"
            }
          }
        },
        "aruba": {
          "fields": {
            "hostname": {
              "label": "Hostname / IP"
            },
            "username": {
              "label": "Username"
            },
            "password": {
              "label": "Password",
              "placeholder": "Password"
            },
            "client": {
              "label": "Client ID"
            },
            "client_secret": {
              "label": "API Client Secret"
            }
          }
        },
        "sc": {
          "iem_info": "Click the info button on the integration modules page for detailed instructions",
          "fields": {
            "hostname": {
              "label": "Hostname / IP"
            },
            "username": {
              "label": "Username"
            },
            "password": {
              "label": "Password",
              "placeholder": "Keep existing"
            },
            "repo_id": {
              "label": "Repository ID",
              "iem_label": "Default repository ID"
            }
          }
        },
        "io": {
          "fields": {
            "access_key": {
              "label": "Access Key",
              "placeholder": "Keep existing"
            },
            "secret_key": {
              "label": "Secret Key",
              "placeholder": "Keep existing"
            },
            "enable_editing": "Enable editing of Access Key and Secret Key"
          }
        },
        "one": {
          "help_text": "To integrate with Tenable One, you will need to generate a linking key from Tenable One and provide it here with the cloud site name. The generated linking key can only be used once, and it must be used within two hours of generation. Please refer to the product documentation for guidance.",
          "fields": {
            "clout_site": {
              "label": "Cloud Site"
            },
            "linking_key": {
              "label": "Linking Key"
            }
          }
        }
      },
      "slider": {
        "edit": {
          "slider_title": "Edit Integration Module",
          "notifications": {
            "success": "{{integrationType}} integration module changes saved successfully",
            "failure": "Failed to save changes to integration module"
          }
        },
        "create": {
          "notifications": {
            "success": "{{integrationType}} integration module was added successfully",
            "failure": "Failed to add integration module"
          }
        },
        "delete": {
          "title": "Delete Integration Module",
          "text": "Are you sure?",
          "submit": "Delete",
          "notifications": {
            "success": "{{integrationType}} integration module deleted successfully",
            "failure": "Failed to delete integration module"
          }
        },
        "test": {
          "notifications": {
            "success": "Successful connection",
            "failure": "Connection failed"
          }
        },
        "sync": {
          "notifications": {
            "success": "Sync was successful",
            "failure": "Sync failed: {{error}}",
            "limit_exceeded_failure": "Integration/Sync failed: the integrated server has exceeded its maximum limit of parallel sessions."
          }
        }
      },
      "iem_more_info": {
        "title": "Learn More About Integration Modules",
        "parts": [
          {
            "title": "Integration with Tenable Security Center",
            "summary": "As part of the integration between the Tenable OT Security Enterprise Manager (EM) and Tenable Security Center, the EM will serve as a centralized point for synchronizing Tenable OT Security assets and vulnerability data with Tenable Security Center. Each instance or site of Tenable OT Security managed by the EM will be linked to a specific Tenable Security Center repository where information is updated on a regular basis."
          },
          {
            "summary": "Tenable OT Security Enterprise Manager will look for Tenable Security Center repositories with names that match up to the Tenable OT Security sites in order to do this mapping automatically. For example, if you have 2 sites of Tenable OT Security for “London” and “New York”, you would need a Tenable Security Center repository for each, that could be named “TOT_London” or “New York - Tenable OT Security”. You can see that the Tenable OT Security site names are contained within the Tenable Security Center repository names. There can be additional distinguishing naming conventions applied to the Tenable Security Center repository names, as long as the exact Tenable OT Security site name exists somewhere within the repository name."
          },
          {
            "summary": "Before configuring the integration between Tenable Security Center and Tenable OT Security Enterprise Manager, you should compare the list of linked Tenable OT Security sites present on the EM with the available repositories in Tenable Security Center. Each repository containing Tenable OT Security data will need to be an “Agent Type” Tenable Security Center repository. The Tenable Security Center user account provided to the EM for integration will require “Scan Upload” permission to all relevant repositories within Tenable Security Center."
          },
          {
            "summary": "When you’re setting up the integration, you will have an option to specify a default Tenable Security Center repository ID. This allows you to potentially import results from all sites into a single repository. If Tenable OT Security Enterprise Manager is unable to find a repository matching in name, it will automatically use that default repository ID."
          }
        ]
      },
      "tenable_workspace": "Tenable Workspace"
    },
    "iot_connectors": {
      "title": "IoT Connectors",
      "column_defs": {
        "name": "Name",
        "ip": "IP",
        "connection_method": "Connection Method",
        "connector_type": "Connector Type",
        "status": "Status",
        "assets": "Assets"
      },
      "iot_connectors_not_ready": {
        "title": "IoT Connectors page is loading",
        "text": "It may take a few minutes to display the IoT Connectors page.\nIf the problem persists, contact support@tenable.com."
      },
      "notifications": {
        "test_connection": {
          "success": "Successful IoT connection"
        }
      },
      "actions": {
        "add": "Add IoT Connector",
        "edit": "Edit IoT Connector",
        "test_connection": "Test Connection",
        "via_agent": "Via Agent",
        "via_remote_api": "Via Remote API"
      },
      "status": {
        "connected": "Connected",
        "connected_not_valid": "Connected; Invalid Credentials",
        "disconnected": "Disconnected",
        "secure_mode_failure": "Secure Mode Failure",
        "unknown": "Unknown Failure",
        "not_available": "N/A"
      },
      "form": {
        "name": "Connector Name",
        "ip": "IP Address of the Server",
        "port": "Port",
        "username": "Username",
        "password": "Password",
        "acc_username": "ACC Username",
        "acc_password": "ACC Password",
        "web_portal_username": "Web Portal Username",
        "web_portal_password": "Web Portal Password",
        "same_cred": "Use same credentials for web portal",
        "web_protocol": "Web Protocol",
        "snmp_port": "SNMP Port Number",
        "snmp_read_community_name": "SNMP Read Community Name",
        "connector_details": "Connector Details",
        "hasVmsCredentials": "VMS Credentials",
        "vmsDbIp": "IP Address of the Database",
        "vmsDbPort": "Database Port",
        "vmsPassword": "Password",
        "vmsUsername": "Username",
        "dbPort": "DB Port",
        "dbName": "DB Name",
        "dbInstance": "DB Instance",
        "dbDomain": "DB Domain",
        "dbIp": "IP Address of the DB Server",
        "dbUsername": "DB Username",
        "dbPassword": "DB Password",
        "placeholders": {
          "name": "Give the connector a name",
          "snmpPort": "Typically: 161",
          "snmpCommunityName": "For example: public",
          "dbPort": "1433 (default)",
          "dbName": "Directory (default)",
          "dbInstance": "SQLEXPRESS (default)"
        },
        "description": {
          "vmsDbIp": "If left empty, the IP address of the server will be used",
          "dbDomain": "Fill this if you are using an NT domain account"
        },
        "infoBox": {
          "genetec": "Note: after saving this connector, the IoT connectors module will restart, and the page will not be available for up to 1-2 minutes."
        }
      },
      "connectors": {
        "mobotix": "Mobotix Camera",
        "exacq": "Exacq Edge",
        "agent": "Agent",
        "milestone": "Milestone",
        "genetec": "Genetec"
      },
      "messages": {
        "added_successfully": "IoT Connector added successfully.",
        "updated_successfully": "IoT Connector changes saved successfully.",
        "deleted_successfully": "IoT Connector deleted successfully.",
        "delete_title": "Delete IoT Connector",
        "confirm_delete": "Are you sure you want to delete the IoT connector {{connectorName}}?"
      },
      "tooltips": {
        "test_connection": "Connection testing is not available for remote APIs"
      },
      "settings": {
        "query_ip": {
          "title": "Fetch IP Address for IoT Assets",
          "description": "When this setting is enabled, IP addresses are obtained when importing assets from an IoT connector, along with the MAC address. Note that in the case of overlapping IP Addresses, only the most recently observed asset will retain the address. When this setting is disabled, only the MAC address of the device is imported, thus avoiding such IP conflicts."
        }
      }
    },
    "servers": {
      "title": "Servers",
      "fortigate": {
        "create_policy_btn": "Create FortiGate Policy",
        "create_policy_wizard": {
          "submitBtnText": "Create",
          "header": "Create Policy on FortiGate",
          "messages": {
            "success": "Policy was created successfully on FortiGate Server",
            "failure": "Unable to create policy on FortiGate Server"
          }
        },
        "create_policy_form": {
          "source_address": "Source Address",
          "source_address_findings": "Source Address (based on last event)",
          "destination_address": "Destination Address",
          "destination_address_findings": "Destination Address (based on last event)",
          "fortigate_server": "FortiGate Server",
          "fortigate_server_placeholder": "Select Server"
        },
        "title": " FortiGate Firewalls",
        "add_server_btn": "Add Firewall",
        "form": {
          "fields": {
            "server_name": "Server Name",
            "host": "Host/IP",
            "api_key": "API Key",
            "test_btn": "Test Server"
          }
        },
        "edit_server": {
          "form": {
            "api_key_placeholder": "Keep existing"
          },
          "wizard": {
            "submitBtnText": "Save",
            "header": "Edit FortiGate Firewall"
          },
          "messages": {
            "success": "Changes saved successfully"
          }
        },
        "delete_server": {
          "popup": {
            "header": "Delete FortiGate Firewall",
            "text": "Are you sure?",
            "submit_btn": "Delete"
          },
          "messages": {
            "success": "FortiGate Firewall deleted successfully",
            "failure": "Failed to delete FortiGate Firewall"
          }
        },
        "add_server": {
          "wizard": {
            "info": "The Tenable OT Security-FortiGate integration allows the user to send firewall policy suggestions based on the Tenable OT Security network events, to FortiGate",
            "submitBtnText": "Add",
            "header": "Add FortiGate Firewall"
          },
          "messages": {
            "success": "Fortigate Firewall was added successfully"
          }
        },
        "test_server": {
          "test_btn": "Test Server",
          "messages": {
            "success": "Fortigate Firewall test was successful",
            "failure": "FortiGate Firewall test has failed"
          }
        }
      },
      "smtp": {
        "title": "SMTP Servers",
        "test_email": {
          "title": "Send test email",
          "fields": {
            "email": "Recipient email"
          },
          "messages": {
            "failure": "Could not send a test email—please try again later",
            "success": "Test email sent successfully"
          }
        },
        "create": {
          "fields": {
            "server": "Server Name",
            "hostname": "Hostname / IP",
            "port": "Port",
            "email": "Sender Email Address",
            "username": "Username (Optional)",
            "password": "Password (Optional)"
          }
        },
        "form": {
          "notifications": {
            "create": {
              "failure": "Something went wrong while trying to create an SMTP server",
              "success": "SMTP server created successfully"
            },
            "edit": {
              "failure": "Something went wrong while trying to update an SMTP server",
              "success": "SMTP server saved successfully"
            },
            "delete": {
              "failure": "Something went wrong while trying to delete an SMTP server",
              "success": "SMTP server deleted successfully"
            }
          }
        },
        "delete_popup": {
          "header": "Delete SMTP Server",
          "title": "Are you sure? <br>If you proceed, this server will be permanently deleted.",
          "title_with_policy": "Unable to delete the server—it is currently being used by other entities."
        },
        "buttons": {
          "create": "Add SMTP Server",
          "test_email": "Send Test Email"
        }
      },
      "syslog": {
        "title": "Syslog Servers",
        "buttons": {
          "create": "Add Syslog Server",
          "test": "Send Test Message"
        },
        "create": {
          "fields": {
            "server": "Server Name",
            "hostname": "Hostname / IP",
            "port": "Port",
            "transport": "Transport",
            "keepAlive": "Send keep-alive message every {{ interval }}",
            "caching": "Allow Syslog message caching",
            "tlsEnabled": "TLS",
            "caCertificate": "Trusted CA",
            "pemFormatOnly": "PEM format only",
            "replaceCurrentCert": "Replace Current Certificate"
          }
        },
        "form": {
          "notifications": {
            "create": {
              "failure": "Something went wrong while trying to create a Syslog server",
              "success": "Syslog server created successfully"
            },
            "edit": {
              "failure": "Something went wrong while trying to update a Syslog server",
              "success": "Syslog server saved successfully"
            },
            "delete": {
              "failure": "Something went wrong while trying to delete a Syslog server",
              "success": "Syslog server deleted successfully"
            }
          }
        },
        "delete_popup": {
          "header": "Delete Syslog Server",
          "title": "Are you sure?<br>If you proceed, this server will be permanently deleted.",
          "title_with_policy": "Unable to delete the server—it is currently being used by other entities."
        },
        "test": {
          "messages": {
            "success": "Message sent successfully",
            "failure": "Message could not be sent—please try again later"
          }
        }
      }
    },
    "system": {
      "title": "System Actions",
      "factory_reset": {
        "title": "Factory Reset",
        "subtitle": "Resets all parameters to the factory defaults. IMPORTANT! This operation cannot be undone, and all of your data will be lost.",
        "action_btn": "Factory Reset",
        "popup": {
          "title": "Factory Reset",
          "message": "This will reset all settings to factory defaults.",
          "submit": "Factory Reset"
        },
        "notifications": {
          "failure": "Failed to factory reset"
        }
      }
    },
    "system_log": {
      "title": "System Log",
      "counter": "Log Entries",
      "column_defs": {
        "time": "Time",
        "event": "Event",
        "username": "Username",
        "entry_id": "Entry ID"
      },
      "syslog": {
        "initial_option": "Select Syslog server",
        "toaster": {
          "success": "Syslog server has been set successfully",
          "failure": "Something went wrong while trying to set a Syslog server"
        }
      }
    },
    "assets": {
      "notifications": {
        "edit": {
          "success": "Asset was successfully changed",
          "failed": "Failed to change asset"
        }
      }
    },
    "restart_dialog": {
      "title": "System Restart",
      "subtitle": "In order to apply the configuration changes, a restart is required. Restart may take a few minutes and, during that time, the system will not be available.",
      "submit_text": "Restart Now",
      "later_text": "Restart Later"
    },
    "service_restart_dialog": {
      "title": "Authentication Service Restart Required",
      "subtitle": "In order to apply the configuration changes, you will need to restart the authentication service. To allow this, all users including yourself will be logged out of the system.",
      "submit_text": "Restart Service Now",
      "later_text": "Restart Service Later"
    },
    "sites_management": "Sites Management"
  },
  "single_asset_page": {
    "navigation_tree": {
      "details": "Details",
      "code": "Code Revision",
      "ip_trail": "IP Trail",
      "attack_vectors": "Attack Vectors",
      "open_ports": "Open Ports",
      "vulnerabilities": "Vulnerabilities",
      "active": "Active ({{ count }})",
      "fixed": "Fixed ({{ count }})",
      "events": "Events",
      "network_map": "Network Map",
      "related_assets": "Related Assets",
      "iec_61850": "IEC 61850",
      "goose_streams": "GOOSE Streams",
      "mms_reports": "MMS Reports"
    },
    "backplane": {
      "title": "Backplane View",
      "tile": {
        "you_are_here": "You are here",
        "hidden_asset": "Hidden asset",
        "additional_nested_devices": "{{count}} additional nested devices"
      },
      "card": {
        "title": "Details",
        "name": "Name",
        "risk": "Risk score",
        "type": "Type",
        "description": "Description",
        "model": "Model",
        "vendor": "Vendor",
        "firmware_version": "FW Version",
        "associated": "Associated IPs",
        "mac": "Mac",
        "slot": "Slot number",
        "purdue_level": "Purdue level",
        "no_card": "No card selected…"
      },
      "nested_devices": {
        "title": "Nested Devices ({{count}})",
        "name": "Name",
        "risk": "Risk score",
        "type": "Type",
        "ip": "IP",
        "vendor": "Vendor",
        "firmware_version": "Firmware",
        "last_seen": "Last seen"
      }
    },
    "open_ports": {
      "view": "View in Browser",
      "grid_settings": {
        "ip": "IP",
        "port": "Port",
        "protocol": "Protocol",
        "source": "Source",
        "description": "Description",
        "last_update": "Last update"
      }
    },
    "code_revision": {
      "snapshots": {
        "title": "Version {{ordinal_text}} Snapshots List"
      }
    },
    "ip_trail": {
      "network_card": "Network Card",
      "backplane_slot": "Slot",
      "active": "Active",
      "inactive": "Inactive",
      "grid_settings": {
        "ip": "IP",
        "network_card": "Network Card",
        "start_date": "Start Date",
        "end_date": "End Date"
      }
    },
    "related_assets": {
      "title": "Related Assets",
      "grid_settings": {
        "columns": {
          "partner_asset": "Partner Asset",
          "relationship_type": "Relationship Type",
          "relationship_direction": "Access Direction",
          "details": {
            "title": "Details",
            "type": "Type",
            "address": "Address",
            "channel": "Channel",
            "station_number": "Station Number",
            "ip": "IP",
            "instance_id": "Instance ID"
          },
          "first_seen": "First Seen",
          "last_updated": "Last Updated",
          "ip": "IP",
          "mac": "MAC",
          "vendor": "Vendor",
          "family": "Family",
          "model": "Model"
        },
        "relationship_direction_options": {
          "from": "From Partner",
          "to": "To Partner",
          "bidirectional": "Bidirectional"
        },
        "relationship_type": {
          "nesting": "Nesting",
          "iot_connectors": "IoT Connector",
          "ba_cnet": "BACnet",
          "snmp_crawler": "SNMP",
          "agent_gateway": "Agent Gateway",
          "project_file": "Project File"
        },
        "connection_type_options": {
          "control_net": "ControlNet",
          "dh_plus": "DhPlus",
          "ip": "Ethernet",
          "flex_bus": "FlexBus"
        }
      }
    },
    "iec_61850": {
      "no_scd_notification": "There are no MMS reports associated with this Asset. Please upload an SCD file with MMS reports to receive security insights and improve visibility.",
      "notification_call_to_action": "Manual Uploads",
      "no_reports": {
        "title": "No Available Reports",
        "description": "There are no MMS reports associated with this Asset. Please upload an SCD file with MMS reports to receive security insights and improve visibility.",
        "action_button": "Go to Manual Uploads"
      },
      "grid_settings": {
        "title": "{{count}} MMS Reports",
        "columns": {
          "report_id": "Report ID",
          "report_name": "Report Name",
          "project": "Project",
          "dataset_name": "Dataset Name",
          "client": "Client Name",
          "empty_client_name": "Not defined",
          "substation": "Substation"
        }
      }
    },
    "goose": {
      "grid_settings": {
        "title": "{{count}} Goose Streams",
        "columns": {
          "report_id": "Goose ID",
          "reference_id": "Goose Ref",
          "mac_address": "Multicast MAC Address",
          "data_set": "Data Set"
        }
      },
      "no_reports": {
        "title": "No Available Reports",
        "description": "There are no GOOSE reports associated with this asset. Make sure you have passive monitoring turned on, or check other Network settings.",
        "action_button": "Network Definitions"
      }
    }
  },
  "password_validator": {
    "title": "Password must contain at least:",
    "minlength": "12 characters",
    "uppercase": "One uppercase letter",
    "lowercase": "One lowercase letter",
    "digit": "One digit",
    "specialchars": "One special character"
  },
  "username_validator": {
    "title": "Username must be:",
    "pattern": "Only lowercase letters and numbers",
    "duplicate": "Unique username"
  },
  "asset_resync": {
    "title": "Resync",
    "messages": {
      "success": "${queryName} completed successfully",
      "failure": "{{queryName}} on asset {{assetName}} has failed with error: {{error}}",
      "failure_other": "{{queryName}} on asset {{assetName}} has failed with a total of {{ count }} errors.",
      "download_errors": "Download Detailed List",
      "try_anyway": "Try Anyway",
      "limit_exceeded_error": "Too many failed {{queryName}} attempts—query not available"
    },
    "disabled_tooltip": {
      "definitions": "Action is not in accordance with queries definition",
      "running": "Query in progress"
    },
    "queries": {
      "all": "Run All Queries"
    }
  },
  "unauthorized": {
    "default": {
      "header": "Unauthorized",
      "subheader": "Sorry, you do not have a permission to access this page."
    },
    "no_groups": {
      "header": "Not authorized to access the system!",
      "subheader": "You are not assigned to any user group—contact your Tenable OT Security system administrator"
    }
  },
  "nessus_scan": {
    "popup": {
      "header": "Approve Nessus Scan",
      "content": "The Nessus scan is an invasive scan that uses queries to identify vulnerabilities in assets. This should not be run on controllers, field devices, or other OT devices, as it may impair their functionality. Make sure that this asset is not an OT device before proceeding with the scan.",
      "confirm": "Proceed with Scan"
    },
    "notifications": {
      "started": "Nessus scan started—it may take a few minutes to complete",
      "success": "Nessus scan on ${assetName} completed successfully",
      "failure": "Nessus scan on ${assetName} failed"
    }
  },
  "attack_vectors": {
    "attack_vectors_disabled_text": {
      "title": "Attack Vector not supported",
      "subtitle": "This feature is under maintenance. Please contact your CSM (global_csm@tenable.com) for assistance."
    },
    "asset_details": {
      "events": "Events",
      "vulnerabilities": "Vulnerabilities",
      "cves": "CVEs",
      "criticality": "Criticality"
    },
    "select_source": {
      "title": "Available Assets",
      "columns": {
        "name": "NAME",
        "risk": "RISK",
        "type": "TYPE",
        "ips": "IPS"
      }
    },
    "main": {
      "risk_mismatch": "Asset risk score for some of the assets in this vector has been updated. The current vector may not be the most updated vector.",
      "no_vector": "Click on Generate to calculate an Attack Vector for this asset",
      "actions": {
        "generate": "Generate",
        "auto_select": "Select Source Automatically",
        "manual_select": "Select Source Manually",
        "manual_select_header": "Select Source"
      },
      "external": "External Network",
      "help": {
        "title": "Learn More about Attack Vectors",
        "close": "Close"
      },
      "inter_bp_comm": "Serial/Direct/IP Communications",
      "start_generate": "Attack Vector is being generated",
      "generate": {
        "success": "Attack Vector was generated successfully",
        "failure": "Failed generating Attack Vector because of \"{{error}}\""
      },
      "generated_on": "Attack Vector generated on"
    },
    "help": {
      "parts": [
        {
          "title": "What is an Attack Vector?",
          "summary": "An Attack Vector is a potential path that a malicious actor could use in order to reach a critical asset on the network. This asset is the destination target and the Attack Vector is the route the attack takes to get to the asset."
        },
        {
          "title": "How do we determine the Attack Vector?",
          "summary": "Once the destination asset is chosen, the system will calculate all of the potential attack vectors that could target this asset and will present the path that has the highest risk potential associated with that asset.\n\nThe calculation factors in multiple parameters and uses a risk-based approach in order to identify the most critical attack vector.\nThe parameters that are used include:",
          "list": [
            "Assets risk",
            "Length of the path",
            "Asset-to-asset communication",
            "External communications (Internet/Corporate) vs. internal communications"
          ],
          "conclusion": "Each time the calculation is performed, the latest set of information is used in a new path that can be selected and viewed."
        },
        {
          "title": "Recommended mitigation steps",
          "summary": "In order to minimize the risk of a potential attack using the selected vector, the recommended mitigation steps include the following:",
          "list": [
            "Reducing the associated and individual risk scores of the assets that participate in the Attack Vector.",
            "Minimizing or removing network access to external networks (Internet or the corporate network)",
            "Examining the communication paths along the chain and validating their relevance to the process. If they are not vital, they should be removed (e.g. Port closing or service removal) in order to eliminate the potential attack path."
          ]
        }
      ]
    }
  },
  "license_activation": {
    "title": "License Activation",
    "subtitle": "Follow these steps in order to activate your license",
    "step1": {
      "step": {
        "active": "Enter license code",
        "active_btn": "Enter license code",
        "visited": "License code entered successfully",
        "visited_btn": "Enter new license code"
      },
      "slider": {
        "title": "Enter license code",
        "field": "License Code",
        "primary_btn": "Verify",
        "required": "Please enter a license code",
        "invalid": "Please enter a valid license code"
      },
      "messages": {
        "failure": "Not a valid license code"
      },
      "reenter_dialog": {
        "title": "Enter New License Code",
        "content": "Are you sure? if you enter a new license code, it will override the current certificate that has been issued.<br>Any previous activation code you may have will not be accepted.",
        "primary_btn": "Proceed"
      }
    },
    "step2": {
      "step": {
        "active": "Generate activation certificate",
        "active_btn": "Generate Certificate",
        "visited": "Certificate was generated successfully",
        "visited_btn": "Generate certificate"
      },
      "slider": {
        "title": "Generate Certificate",
        "field": "Activation Certificate",
        "copy": "Copy text to clipboard",
        "primary_btn": "Done"
      }
    },
    "step3": {
      "step": {
        "link": "Self-service portal",
        "link_url": "https://provisioning.tenable.com/ot-security",
        "link_2": "Click here",
        "link_2_url": "https://provisioning.tenable.com/activate/offline/tenable-ot",
        "active": "Enter activation code, which can be obtained from Tenable ${link} or from your sales rep. ${link_2} to activate your evaluation period.",
        "active_btn": "Enter Activation Code"
      },
      "slider": {
        "title": "Enter Activation Code",
        "field": "Activation Code",
        "primary_btn": "Activate",
        "required": "Please enter an activation code"
      },
      "messages": {
        "success": "System was activated successfully",
        "failure": "Unable to activate license",
        "cert_expired": "Certificate expired! Generate a new certificate and send it to your sales representative."
      }
    }
  },
  "license_messages": {
    "subscription_expiring": "Your license will expire in {{ days }} days",
    "maintenance_expiring": "Your license maintenance will expire in {{ days }} days",
    "maintenance_expired": "Your license maintenance expired"
  },
  "navbar_license": {
    "version": "Version",
    "expires": "Expires",
    "assets_limit": "Assets Limit"
  },
  "grid_override": {
    "settingsToolPanel": "settings",
    "selectAll": "(Select All)",
    "blanks": "(Blanks)",
    "applyFilter": "Apply",
    "clearFilter": "Clear",
    "resetFilter": "Reset",
    "cancelFilter": "Cancel",
    "loadingOoo": "Loading…",
    "searchOoo": "Search…",
    "selectAllSearchResults": "(Select All Search Results)",
    "noMatches": "No matches.",
    "filterOoo": "Filter…",
    "empty": "Choose One",
    "equals": "Equals",
    "notEqual": "Not equal",
    "lessThan": "Less than",
    "greaterThan": "Greater than",
    "inRange": "In range",
    "inRangeStart": "From",
    "inRangeEnd": "To",
    "lessThanOrEqual": "Less than or equal to",
    "greaterThanOrEqual": "Greater than or equal to"
  },
  "constant_nags": {
    "restart": "System changes are pending a restart",
    "license_assets_exceeded": "Your asset limit has reached {{ percent }}%",
    "disk_space": {
      "soft": "Your system has reached {{ percent }}% storage capacity and is running low on space. For further instructions, please refer to the user guide.",
      "hard": "Your system has reached {{ percent }}% storage capacity and is running very low on space. For further instructions, please refer to the user guide."
    },
    "license_expired": "Your license has expired",
    "auth_providers_restart_warning": "Authentication configuration updates are pending logout and service restart",
    "assets_pending_deletion": "Pending Action: Deletion of Assets, to allow an update in duplicate network definitions. This action requires a system restart",
    "sensor_pending_approval": "Sensor pairing requests are pending approval",
    "agent_pending_approval": "Agent pairing requests are pending approval",
    "blackout_period": {
      "text": "All enabled queries have been paused due to a blackout period until {{time}}",
      "btn_text": "End Black-out"
    },
    "link_texts": {
      "view_requests": "View Requests"
    },
    "sensor_awaiting_first_use": {
      "text": "There are sensors in “Paused” status. To start using them to collect data, you need to manually resume it.",
      "link": "Go to sensors page"
    }
  },
  "pendo": {
    "icon": {
      "tooltip": {
        "disabled": "To enable access for the Tenable OT Resource Center, make sure you have a live internet connection, and that the \"Enable Usage Statistics\" setting is turned on (see under Local Settings > System Configuration > Device)."
      }
    }
  },
  "overview": {
    "page_title": "Overview",
    "download_report": "Executive Report",
    "kpi_widgets": {
      "sub_title": "at High Risk",
      "risk_score_tooltip": "Assets with Risk Score 70 and above are considered to be at high risk.",
      "ot_controllers": {
        "title": "OT Controllers"
      },
      "network_assets": {
        "title": "Network Assets"
      },
      "iot_assets": {
        "title": "IoT Assets"
      },
      "vulnerability_finding": {
        "title": "Vulnerability Findings",
        "sub_title": "Critical or High Severity",
        "tooltip": "Vulnerabilities with severity \"Info\" are excluded from the count."
      },
      "vulnerability": {
        "title": "Vulnerabilities",
        "sub_title": "Critical or High Severity",
        "tooltip": "Vulnerabilities with severity \"Info\" are excluded from the count."
      }
    },
    "kpi_whats_new_widgets": {
      "title": "What’s New",
      "assets_discovered": {
        "text": "Assets Discovered"
      },
      "assets_updated": {
        "text": "Assets Updated",
        "label": "Active Queries"
      },
      "high_risk_violations": {
        "text": "High-Risk Violations"
      },
      "operational_violations": {
        "text": "Operational Violations",
        "label": "Snapshots"
      },
      "ot_vulnerabilities": {
        "text": "OT Vulnerabilities Found"
      },
      "it_vulnerabilities": {
        "text": "IT Vulnerabilities Found",
        "label": "Nessus"
      },
      "em": {
        "title": "Status Report",
        "assets_discovered": {
          "text": "Assets Discovered (Last 24h)"
        },
        "events_one_week": {
          "text": "Total Events (Last 7 Days)"
        },
        "events_one_day": {
          "text": "Total Events (Last 24h)"
        },
        "events_one_hour": {
          "text": "Total Events (Last 1h)"
        },
        "risk_events": {
          "text": "High-Risk Events (Last 24h)"
        },
        "configuration_events": {
          "text": "Configurations (Last 24h)"
        },
        "icps": {
          "text": "ICPs Online"
        },
        "sensors": {
          "text": "Sensors Online"
        }
      },
      "current_value_of_total_value": "{{currentValue}} of {{totalValue}}"
    },
    "network_summary": {
      "graph_title": "Network Traffic",
      "hosts_title": "Hosts Involved",
      "tooltip": {
        "conversations": "Conversations",
        "bytes": "B"
      }
    },
    "highest_risk": {
      "title": "Highest-Risk Assets",
      "button": "All Assets",
      "table_columns": {
        "name": "Asset Name",
        "type": "Asset Type",
        "vendor": "Vendor",
        "risk_score": "Risk Score",
        "criticality": "Criticality"
      }
    },
    "connected_sites": {
      "title": "Connected Sites",
      "button": "ICPs Management",
      "table_columns": {
        "name": "Name",
        "assets": "Assets",
        "risk_score": "Avg. Risk Score",
        "vulnerabilities": "Severe Vulnerabilities",
        "last_events": "Last 24h Events"
      }
    }
  },
  "onboarding": {
    "welcome_popup": {
      "header": "Welcome to Tenable OT Security",
      "title": "Your system is now activated and ready for use! However, passive network monitoring has not yet begun.<br><br>Prior to enabling passive analysis, we strongly recommend that you set the monitored network ranges. This will control which networks are in scope for monitoring and for detecting new assets.",
      "submit_no_feature_flag": "Go to Network Definitions",
      "submit": "Go to Network Management"
    },
    "passive_monitoring": {
      "header": {
        "state": {
          "enabled": "Passive monitoring engine is enabled and running.",
          "disabled": "Passive monitoring engine is disabled. To enable it and increase your visibility, turn on the Passive Monitoring switch under Settings > Environment Settings > Network Definitions."
        }
      }
    }
  }
}
